webpackJsonp([2],{

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(322)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(233),
  /* template */
  __webpack_require__(588),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4f275797",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(232),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(325)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(236),
  /* template */
  __webpack_require__(591),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-624594c9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(333)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(599),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f6d24b4e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 207:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard_dist_vue_form_wizard_min_css__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard_dist_vue_form_wizard_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_form_wizard_dist_vue_form_wizard_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_good_table_dist_vue_good_table_css__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_good_table_dist_vue_good_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_good_table_dist_vue_good_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_min_css__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_flatpickr_component__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_flatpickr_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_flatpickr_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_flatpickr_dist_flatpickr_css__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_flatpickr_dist_flatpickr_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_flatpickr_dist_flatpickr_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_flatpickr_dist_themes_material_blue_css__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_flatpickr_dist_themes_material_blue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_flatpickr_dist_themes_material_blue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue2_simplert_plugin__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue2_simplert_plugin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue2_simplert_plugin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_axios__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_chartjs__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_clipboard2__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_clipboard2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_form_wizard__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_good_table__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_highlightjs__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_highlightjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_highlightjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_slideout_panel__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_slideout_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_slideout_panel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_AppLogs__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_AppLogs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__pages_AppLogs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_Apps__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_Apps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__pages_Apps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_AppView__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_AppView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__pages_AppView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_Config__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_Config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__pages_Config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_Deployments__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_Deployments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__pages_Deployments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_HeliumDevLatestCLI__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_HeliumDevLatestCLI___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__pages_HeliumDevLatestCLI__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_Home__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__pages_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_PgStats__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_PgStats___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__pages_PgStats__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_ScheduledFunctions__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_ScheduledFunctions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__pages_ScheduledFunctions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_SchemaAccess__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_SchemaAccess___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__pages_SchemaAccess__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_SignIn__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_SignIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__pages_SignIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_SupportRoster__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_SupportRoster___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__pages_SupportRoster__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_Sync__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_Sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__pages_Sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_SyncDashboard__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_SyncDashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__pages_SyncDashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_SyncForm__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_SyncForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__pages_SyncForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__pages_SyncGuide__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__pages_SyncGuide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__pages_SyncGuide__);




















__webpack_require__(314);


















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_5_axios___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_flatpickr_component___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue2_simplert_plugin___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_chartjs__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_clipboard2___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vue_form_wizard___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_vue_good_table__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_vue_highlightjs___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17_vue_slideout_panel___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'root',
    component: __WEBPACK_IMPORTED_MODULE_24__pages_Home___default.a
  }, {
    path: '/home/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_24__pages_Home___default.a
  }, {
    path: '/signin/',
    name: 'SignIn',
    component: __WEBPACK_IMPORTED_MODULE_28__pages_SignIn___default.a
  }, {
    path: '/app/',
    name: 'AppView',
    component: __WEBPACK_IMPORTED_MODULE_20__pages_AppView___default.a
  }, {
    path: '/apps/',
    name: 'Apps',
    component: __WEBPACK_IMPORTED_MODULE_19__pages_Apps___default.a
  }, {
    path: '/apps/:appid',
    name: 'AppsParam',
    component: __WEBPACK_IMPORTED_MODULE_19__pages_Apps___default.a
  }, {
    path: '/logs/:appid',
    name: 'Logs',
    component: __WEBPACK_IMPORTED_MODULE_18__pages_AppLogs___default.a
  }, {
    path: '/schema-access/',
    name: 'SchemaAccess',
    component: __WEBPACK_IMPORTED_MODULE_27__pages_SchemaAccess___default.a
  }, {
    path: '/deployments/',
    name: 'Deployments',
    component: __WEBPACK_IMPORTED_MODULE_22__pages_Deployments___default.a
  }, {
    path: '/config/:appid',
    name: 'Config',
    component: __WEBPACK_IMPORTED_MODULE_21__pages_Config___default.a
  }, {
    path: '/scheduledfunctions/:appid',
    name: 'ScheduledFunctions',
    component: __WEBPACK_IMPORTED_MODULE_26__pages_ScheduledFunctions___default.a
  }, {
    path: '/support-roster/:team?',
    name: 'SupportRoster',
    component: __WEBPACK_IMPORTED_MODULE_29__pages_SupportRoster___default.a
  }, {
    path: '/sync/:appid?',
    name: 'Sync',
    component: __WEBPACK_IMPORTED_MODULE_30__pages_Sync___default.a
  }, {
    path: '/sync-guide',
    name: 'SyncGuide',
    component: __WEBPACK_IMPORTED_MODULE_33__pages_SyncGuide___default.a
  }, {
    path: '/sync/form/:appid?',
    name: 'SyncForm',
    component: __WEBPACK_IMPORTED_MODULE_32__pages_SyncForm___default.a
  }, {
    path: '/sync-dashboard/:name?',
    name: 'SyncDashboard',
    component: __WEBPACK_IMPORTED_MODULE_31__pages_SyncDashboard___default.a
  }, {
    path: '/dbspy/:appid?',
    name: 'PgStats',
    component: __WEBPACK_IMPORTED_MODULE_25__pages_PgStats___default.a
  }, {
    path: '/helium-dev-latest',
    name: 'HeliumDevLatestCLI',
    component: __WEBPACK_IMPORTED_MODULE_23__pages_HeliumDevLatestCLI___default.a
  }]
}));

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(329)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(229),
  /* template */
  __webpack_require__(595),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);

var DatetimeStringFactory = {
  getMomentFormat: function getMomentFormat() {
    return 'YYYY-MM-DD HH:MM:ss';
  },
  getDateFromMillis: function getDateFromMillis(value) {
    return new Date(parseInt(value));
  },
  formatMillis: function formatMillis(value) {
    if (!value) {
      return 'Invalid date';
    }
    var date = this.getDateFromMillis(value);
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format(this.getMomentFormat());
  }
};
/* harmony default export */ __webpack_exports__["a"] = (DatetimeStringFactory);

/***/ }),

/***/ 228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(207);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__webpack_require__(208);

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 229:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_SignIn__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_SignIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_SignIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Apps__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Apps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_Apps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_slideout_panel__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_slideout_panel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_slideout_panel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_min_css__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_min_css__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    SignIn: __WEBPACK_IMPORTED_MODULE_0__pages_SignIn___default.a,
    Apps: __WEBPACK_IMPORTED_MODULE_1__pages_Apps___default.a,
    VueSlideoutPanel: __WEBPACK_IMPORTED_MODULE_3_vue_slideout_panel___default.a,
    modal: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["modal"],
    Loading: __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      baseUrl: "https://portal.heliumapps.com",
      year: new Date().getFullYear(),
      displayBackButton: false,
      nav: null,
      socket: null,
      username: null,
      password: null,
      loginError: null,
      apps: null,
      app: null,
      environments: null,
      environment: null,
      heliumBaseUrl: null,
      syncApps: null,
      showSlideoutPanel: false,
      modalSignoutVisibile: false,
      modalBackdrop: false,
      loading: false
    };
  },

  methods: {
    closeWs: function closeWs() {
      if (this.socket !== null && this.socket !== undefined) {
        this.socket.close();
      }
    },
    signOutBtn: function signOutBtn() {
      this.modalSignoutVisibile = true;
    },
    modalSignoutConfirmBtn: function modalSignoutConfirmBtn() {
      this.apps = null;
      this.closeWs();
      this.modalSignoutVisibile = false;
      this.$router.push({ name: 'root' });
    },
    modalSignoutCloseBtn: function modalSignoutCloseBtn() {
      this.modalSignoutVisibile = false;
    },
    httpUrlToWebSockeUrl: function httpUrlToWebSockeUrl(url) {
      if (url.indexOf('http') === 0) {
        return url.replace(/http/, 'ws');
      } else if (url.indexOf('https') === 0) {
        return url.replace(/https/, 'ws');
      }
      return url;
    },
    setSlideoutPanelHidden: function setSlideoutPanelHidden() {
      this.showSlideoutPanel = false;
    },
    setSlideoutPanelVisible: function setSlideoutPanelVisible() {
      this.showSlideoutPanel = true;
    },
    toggleSlideoutPanelBtn: function toggleSlideoutPanelBtn() {
      this.closeWs();
      if (this.showSlideoutPanel) {
        this.setSlideoutPanelHidden();
      } else {
        this.setSlideoutPanelVisible();
      }
    }
  },
  watch: {
    '$route': function $route(newRoute) {},
    'environment': function environment(value) {
      this.heliumBaseUrl = value.baseUrl;
    }
  },
  created: function created() {
    var vm = this;
    window.addEventListener('keydown', function (e) {
      if (e.keyCode === 27) {
        vm.setSlideoutPanelHidden();
        vm.modalSignoutCloseBtn();
      }
    });
  },

  computed: {
    isProduction: function isProduction() {
      return this.environment && (this.environment.name === 'Production' || this.environment.name === 'Localhost');
    },
    signedInAs: function signedInAs() {
      if (!this.environment || !this.username) {
        return 'Not signed in';
      } else {
        return 'Signed into ' + this.environment.name + ' as ' + this.username;
      }
    }
  }
});

/***/ }),

/***/ 230:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_strap__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['config'],
  components: {
    modal: __WEBPACK_IMPORTED_MODULE_1_vue_strap__["modal"]
  },
  data: function data() {
    return {
      modalShow: false,
      modalBackdrop: false,
      selectedKey: null,
      selectedValue: null,
      columns: [{
        label: 'Entry Point',
        field: 'key',
        filterable: true
      }, {
        label: 'Value',
        field: 'value'
      }, {
        label: 'Actions',
        field: 'btn',
        html: true
      }]
    };
  },

  methods: {
    tableRowClass: function tableRowClass(row) {
      if (row.value >= 45) {
        return 'table-danger';
      } else if (row.value >= 20) {
        return 'table-warning';
      }
      return 'table-primary';
    },
    btnUpdateEntryPoint: function btnUpdateEntryPoint(key, value) {
      this.$parent.updateEntryPoint(key, value, true);
    },
    btnRemoveEntryPoint: function btnRemoveEntryPoint(key, value) {
      this.modalShow = true;
      this.selectedKey = key;
      this.selectedValue = value;
    },
    modalRemoveCallback: function modalRemoveCallback() {
      this.$parent.updateEntryPoint(this.selectedKey, this.selectedValue, false);
      this.$parent.deleteEntryPoint(this.selectedKey, this.selectedValue);
      this.modalCloseCallback();
    },
    modalCloseCallback: function modalCloseCallback() {
      var vm = this;
      vm.modalShow = false;
    }
  },
  computed: {
    configData: function configData() {
      return this.config.processEntryPointTimeouts;
    },
    showConfigData: function showConfigData() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.config.processEntryPointTimeouts).length > 0;
    }
  },
  created: function created() {
    var vm = this;
    window.addEventListener('keydown', function (e) {
      if (e.keyCode === 27) {
        vm.modalCloseCallback();
      }
    });
  }
});

/***/ }),

/***/ 231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    success: Boolean,
    spin: Boolean,
    message: String
  }
});

/***/ }),

/***/ 232:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(201);


var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* mixins */].reactiveProp;

/* harmony default export */ __webpack_exports__["default"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["c" /* Pie */],
  mixins: [reactiveProp],
  props: ['options'],
  mounted: function mounted() {
    this.renderChart(this.chartData, this.options);
  }
});

/***/ }),

/***/ 233:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['contentProp', 'width', 'height', 'readonly', 'scrollToLine', 'lang'],
  components: {
    editor: __webpack_require__(603)
  },
  data: function data() {
    return {
      editor: Object,
      content: ''
    };
  },

  methods: {
    editorInit: function editorInit() {
      __webpack_require__(553);
      __webpack_require__(550);
      __webpack_require__(554);
      __webpack_require__(552);
      __webpack_require__(551);
      __webpack_require__(555);
    },
    setContent: function setContent(val) {
      var vm = this;
      vm.content = val;
      vm.scrollToEnd(vm.contentProp);
    },
    scrollToEnd: function scrollToEnd(val) {
      var vm = this;
      if (vm.scrollToLine) {
        var lines = val.split(/\r\n|\r|\n/).length;
        vm.editor = window.ace.edit('editor');
        vm.editor.resize(true);
        vm.editor.gotoLine(lines, 10, true);
      }
    }
  },
  mounted: function mounted() {
    var vm = this;
    vm.editor = window.ace.edit('editor');
    vm.editor.setOption('showPrintMargin', false);
    vm.editor.setReadOnly(vm.readonly);
    vm.editor.session.setUseWrapMode(true);
    vm.editor.session.setWrapLimit(vm.width);
    vm.setContent(vm.contentProp);
  },

  computed: {},
  watch: {
    'contentProp': function contentProp(val) {
      var vm = this;
      vm.setContent(val);
    }
  }
});

/***/ }),

/***/ 234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Feedback_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Feedback_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Feedback_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TextEditor_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TextEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_TextEditor_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Feedback: __WEBPACK_IMPORTED_MODULE_1__components_Feedback_vue___default.a,
    TextEditor: __WEBPACK_IMPORTED_MODULE_2__components_TextEditor_vue___default.a
  },
  data: function data() {
    return {
      app: Object,
      logs: [],
      message: '',
      success: false,
      wsOpen: false,
      showSpinner: false,
      showEditor: false,
      textBlockWidth: 0,
      textBlockHeight: 0,
      textBlockReadOnly: true,
      scrollToLine: true,
      disableStop: false,
      disableStart: true,
      textBlockLang: 'sql'
    };
  },
  methods: {
    openWs: function openWs() {
      var vm = this;

      var wsUrl = 'wss://portal.heliumapps.com/portal-backend/ws/' + vm.app.id;
      vm.message = 'Opening websocket connection to ' + wsUrl;
      vm.showSpinner = true;
      vm.$parent.socket = new WebSocket(wsUrl);
      vm.$parent.socket.onopen = function () {
        vm.resizeEditor();

        var credentials = {};
        credentials['userName'] = vm.$parent.username;
        credentials['password'] = vm.$parent.password;
        var data = {};
        data['baseUrl'] = vm.$parent.environment.baseUrl;
        data['credentials'] = credentials;

        vm.$parent.socket.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));

        vm.$parent.socket.onmessage = function (response) {
          vm.success = true;
          vm.wsOpen = true;
          var json = JSON.parse(response.data);
          var log = new Date(json.millis).toLocaleString() + ' - ' + json.key + ' - ' + json.value;
          vm.logs.push(log);
          vm.message = 'Streaming Logs...';
          vm.showSpinner = true;
          vm.disableStop = false;
          vm.disableStart = true;
        };
      };
      vm.$parent.socket.onclose = function (response) {
        var log = new Date().toLocaleString() + ' - Terminate - Connection to portal backend closed.';
        vm.logs.push(log);

        vm.message = 'Socket closed with code ' + response.code + '.';
        vm.showSpinner = false;
        vm.success = false;
        if (response.code === 1006) {
          vm.message = vm.message + ' ' + 'The connection was closed abnormally, e.g., without sending or receiving a Close control frame (RFC 6455 - The WebSocket Protocol)';
        }
        vm.wsOpen = false;
        vm.disableStop = true;
        vm.disableStart = false;
      };
    },
    closeWs: function closeWs() {
      var vm = this;
      vm.$parent.closeWs();
      vm.wsOpen = false;
      vm.showSpinner = false;
    },
    clearLogs: function clearLogs() {
      this.logs = [];
    },
    resizeEditor: function resizeEditor() {
      var newHeight = window.innerHeight;
      var newWidth = 0;
      if (this.$refs.resultsRef) {
        newWidth = this.$refs.resultsRef.clientWidth;
      }
      this.textBlockWidth = Math.round(newWidth * 90 / 100);
      this.textBlockHeight = Math.round(newHeight * 60 / 100);
      this.showEditor = true;
    }
  },
  created: function created() {
    var vm = this;
    vm.$parent.apps.forEach(function (key) {
      if (key.id === vm.$route.params.appid) {
        vm.app = key;
      }
    });
    vm.openWs();
    window.addEventListener('resize', this.resizeEditor);
  },

  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resizeEditor);
  },
  computed: {
    numLogs: function numLogs() {
      return this.logs.length;
    },
    textBlock: function textBlock() {
      return this.logs.join('\n');
    }
  }
});

/***/ }),

/***/ 235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PieChart_vue__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PieChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_PieChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_min_css__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_min_css__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    modal: __WEBPACK_IMPORTED_MODULE_1_vue_strap__["modal"],
    PieChart: __WEBPACK_IMPORTED_MODULE_0__components_PieChart_vue___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      app: null,
      columns: [{
        label: 'Query',
        field: 'query',
        filterable: true
      }, {
        label: 'Calls',
        field: 'calls',
        filterable: true,
        type: 'number'
      }, {
        label: 'Total Time',
        field: 'total_time',
        filterable: true,
        type: 'number'
      }, {
        label: 'Min Time',
        field: 'min_time',
        filterable: true,
        type: 'number'
      }, {
        label: 'Max Time',
        field: 'max_time',
        filterable: true,
        type: 'number'
      }, {
        label: 'Mean Time',
        field: 'mean_time',
        filterable: true,
        type: 'number'
      }, {
        label: 'Standard Deviation',
        field: 'stddev_time',
        filterable: true,
        type: 'number'
      }, {
        label: 'Rows retrieved or affected',
        field: 'rows',
        filterable: true,
        type: 'number'
      }],
      rows: [],
      chartQueries: [],
      chartData: null,
      chartResultSetSize: 5,
      chartSortType: 'Descending',
      chartType: 'Mean Time',
      modalShowDetail: false,
      modalBackdrop: false,
      selectedQuery: null,
      loading: true,
      functionResults: [],
      functionColumns: [{
        label: 'Function Name',
        field: 'qualifiedName'
      }, {
        label: 'Started',
        field: 'started'
      }, {
        label: 'Finished',
        field: 'finished'
      }, {
        label: 'Exception',
        field: 'exception'
      }, {
        label: 'Stacktrace',
        field: 'stacktrace'
      }],
      statsLoading: false,
      sfLoading: false
    };
  },
  methods: {
    getPgStats: function getPgStats() {
      var vm = this;
      var endpoint = vm.$parent.baseUrl + '/portal-backend/api/db-spy/stats';
      var config = {};
      config['environment'] = vm.$parent.environment.name;
      config['appId'] = vm.app.id;
      vm.statsLoading = true;
      vm.$parent.loading = true;
      vm.axios.post(endpoint, config).then(function (response) {
        vm.$parent.loading = false;
        vm.rows = response.data;
        vm.statsLoading = false;
        if (vm.rows.length <= 0) {
          var obj = {
            title: 'No stats found!',
            message: 'No postgres statement stats found on ' + endpoint,
            type: 'error'
          };
          vm.$Simplert.open(obj);
        }
        vm.maybeUpdateChartData();
      }).catch(function (error) {
        vm.$parent.loading = false;
        vm.statsLoading = false;
        var obj = {
          title: 'Error getting stats!',
          message: error.response.data,
          type: 'error'
        };
        vm.$Simplert.open(obj);
        console.log(error);
      });
    },
    maybeUpdateChartData: function maybeUpdateChartData() {
      var vm = this;
      if (vm.chartType !== null && vm.chartSortType !== null && vm.chartResultSetSize != null) {
        vm.setChartData();
      }
    },
    setChartData: function setChartData() {
      var vm = this;

      vm.chartQueries = [];

      var chartLabels = [];
      var chartDataElements = [];
      var chartColours = [];
      var chartDatasets = [];

      var chartTypeField = vm.formatChartTypeLabelToField(vm.chartType);

      var rowsData = this.rows.slice().sort(function (a, b) {
        if (vm.chartSortType === 'Ascending') {
          return a[chartTypeField] - b[chartTypeField];
        } else if (vm.chartSortType === 'Descending') {
          return b[chartTypeField] - a[chartTypeField];
        }
      });
      for (var i = 0; i < vm.chartResultSetSize && i < rowsData.length; i++) {
        var ele = rowsData[i];
        chartLabels.push('#' + (i + 1) + ' ' + chartTypeField);
        var suffix = chartTypeField === 'total_time' || chartTypeField === 'min_time' || chartTypeField === 'max_time' || chartTypeField === 'mean_time' || chartTypeField === 'stddev_time' ? 's' : '';
        vm.chartQueries.push('-- Query #' + (i + 1) + '\n' + ele.query + '\n-- Value:\n' + ele[chartTypeField] + suffix + ' ' + vm.chartType);
        chartDataElements.push(ele[chartTypeField]);
        chartColours.push(vm.getRandomColor());
      }
      chartDatasets.push({
        backgroundColor: chartColours,
        data: chartDataElements
      });
      vm.chartData = {
        labels: chartLabels,
        datasets: [{
          backgroundColor: chartColours,
          data: chartDataElements
        }]
      };
    },
    formatChartTypeLabelToField: function formatChartTypeLabelToField(value) {
      var vm = this;
      if (vm.chartType === null) {
        return null;
      }
      var result = null;
      vm.columns.slice().filter(function (item) {
        return item.label === value;
      }).forEach(function (element) {
        result = element.field;
      });
      return result;
    },
    getRandomColor: function getRandomColor() {
      var letters = '0123456789ABCDEF';
      var color = '#';
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    onClickFn: function onClickFn(row, index) {
      var vm = this;
      vm.selectedQuery = row;
      vm.modalShowDetail = true;
    },
    closeModalShowDetail: function closeModalShowDetail() {
      var vm = this;
      vm.modalShowDetail = false;
    },
    getScheduledFunctions: function getScheduledFunctions() {
      var vm = this;
      vm.sfLoading = true;
      vm.functionResults = [];

      var config = {};
      config['environment'] = vm.$parent.environment.name;
      config['uuid'] = vm.app.id;

      var endpoint = vm.$parent.baseUrl + '/portal-backend/api/debug/scheduled-function';

      vm.axios.post(endpoint, config).then(function (response) {
        vm.functionResults = response.data;
        vm.sfLoading = false;
      }).catch(function (error) {
        vm.sfLoading = false;
        var obj = {
          title: 'Error getting scheduled-function stats!',
          message: error.response.data,
          type: 'error'
        };
        vm.$Simplert.open(obj);
      });
    }
  },
  computed: {
    chartTypeDropdown: function chartTypeDropdown() {
      var vm = this;
      return vm.columns.slice().filter(function (item) {
        return item.field !== 'query';
      });
    },
    chartResultSetSizes: function chartResultSetSizes() {
      var values = [];
      for (var i = 5; i <= this.rows.length; i = i + 5) {
        values.push(i);
      }
      return values;
    }
  },
  created: function created() {
    var vm = this;
    vm.$parent.apps.forEach(function (key) {
      if (key.id === vm.$route.params.appid) {
        vm.app = key;
      }
    });
    if (vm.app == null) {
      vm.$router.push({ name: 'Apps' });
      return;
    }
    vm.getPgStats();
    vm.getScheduledFunctions();
    window.addEventListener('keydown', function (e) {
      if (e.keyCode === 27) {
        vm.closeModalShowDetail();
      }
    });
  },

  watch: {
    'chartType': function chartType(newValue) {
      var vm = this;
      vm.maybeUpdateChartData();
    },
    'chartSortType': function chartSortType(newValue) {
      var vm = this;
      vm.maybeUpdateChartData();
    },
    'chartResultSetSize': function chartResultSetSize(newValue) {
      var vm = this;
      vm.maybeUpdateChartData();
    }
  }
});

/***/ }),

/***/ 236:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Apps',
  components: {},
  data: function data() {
    return {
      apps: [],
      width: 601
    };
  },
  methods: {
    view: function view(entry) {
      this.$router.push({ name: 'AppsParam', params: { appid: entry.id } });
      this.$router.push({ name: 'AppView', params: { appid: entry.id } });
    },
    config: function config(entry) {
      this.$router.push({ name: 'AppsParam', params: { appid: entry.id } });
      this.$router.push({ name: 'Config', params: { appid: entry.id } });
    },
    logs: function logs(entry) {
      this.$router.push({ name: 'AppsParam', params: { appid: entry.id } });
      this.$router.push({ name: 'Logs', params: { appid: entry.id } });
    },
    scheduledfunctions: function scheduledfunctions(entry) {
      this.$router.push({ name: 'AppsParam', params: { appid: entry.id } });
      this.$router.push({ name: 'ScheduledFunctions', params: { appid: entry.id } });
    },
    windowResizeCallback: function windowResizeCallback() {
      this.width = this.$refs.widthRef.clientWidth;
    },
    isMobileDevice: function isMobileDevice() {
      return (/iphone|ipod|android|ie|blackberry|fennec/.test(navigator.userAgent.toLowerCase())
      );
    },
    showAppId: function showAppId() {
      return this.width > 750 && !this.isMobileDevice();
    }
  },
  computed: {
    columns: function columns() {
      if (this.showAppId()) {
        return [{
          label: 'Name',
          field: 'name'
        }, {
          label: 'ID',
          field: 'id'
        }, {
          label: 'FQDN',
          field: 'fqdn'
        }, {
          label: 'Actions',
          field: 'btn',
          html: true
        }];
      } else {
        return [{
          label: 'Name',
          field: 'name'
        }, {
          label: 'FQDN',
          field: 'fqdn'
        }, {
          label: 'Actions',
          field: 'btn',
          html: true
        }];
      }
    }
  },
  mounted: function mounted() {
    this.windowResizeCallback();
    window.addEventListener('resize', this.windowResizeCallback);
    this.apps = this.$parent.apps;
  },

  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.windowResizeCallback);
  }
});

/***/ }),

/***/ 237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppConfigEntryPoint_vue__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppConfigEntryPoint_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_AppConfigEntryPoint_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Feedback_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Feedback_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Feedback_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_strap__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Config',
  components: {
    AppConfigEntryPoint: __WEBPACK_IMPORTED_MODULE_1__components_AppConfigEntryPoint_vue___default.a,
    Feedback: __WEBPACK_IMPORTED_MODULE_2__components_Feedback_vue___default.a,
    modal: __WEBPACK_IMPORTED_MODULE_3_vue_strap__["modal"]
  },
  data: function data() {
    return {
      config: null,
      app: null,
      entryPointType: null,
      entryPointScope: null,
      entryPointName: null,
      entryPointValue: null,
      entryPointScopeTmp: null,
      entryPointNameTmp: null,
      entryPointValueTmp: null,
      entryPointScopeReadOnly: false,
      entryPointScopePlaceholder: null,
      entryPointNamePlaceholder: null,
      entryPointIsNew: false,
      modalShow: false,
      modalBackdrop: false,
      loading: true,
      teamNames: [],
      teamUser: '',
      endpointUndo: null,
      configUndo: null,
      undoKey: null,
      undoValue: null,
      maxDatabaseResults: null,
      disabledApp: null,
      lockedApp: null
    };
  },

  methods: {
    getCurrentConfig: function getCurrentConfig() {
      var vm = this;
      var config = {};
      vm.config = null;
      config['baseUrl'] = vm.$parent.environment.baseUrl;
      config['appId'] = vm.app.id;
      var endpoint = vm.$parent.baseUrl + '/portal-backend/api/config/get-config/';
      vm.$parent.loading = true;
      vm.axios.post(endpoint, config).then(function (response) {
        vm.config = response.data;
        vm.feedbackSuccess = true;
        vm.loading = false;
        vm.$parent.loading = false;
        vm.maxDatabaseResults = vm.config.maxDatabaseResults;
        vm.disabledApp = vm.convertBooleanToFieldDisabled(vm.config.disabled);
        vm.lockedApp = vm.convertBooleanToFieldLocked(vm.config.locked);
      }).catch(function (response) {
        vm.$Simplert.open({ title: 'Error', message: 'Unable to get app config!', type: 'error' });
        vm.$parent.loading = false;
      });
    },
    modalCloseCallback: function modalCloseCallback() {
      this.modalShow = false;
    },
    modalSaveCallback: function modalSaveCallback() {
      this.modalShow = false;
      this.postEntryPoint();
      this.clearModal();
    },
    postEntryPoint: function postEntryPoint() {
      var vm = this;

      if (vm.entryPointScope === null) {
        vm.$Simplert.open({ title: 'Validation', message: 'Please enter Entry Point Scope Name', type: 'error' });
        return;
      } else if (vm.entryPointName === null) {
        vm.$Simplert.open({ title: 'Validation', message: 'Please enter Entry Point', type: 'error' });
        return;
      } else if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(parseInt(vm.entryPointValue)) || vm.entryPointValue <= 0) {
        vm.$Simplert.open({ title: 'Validation', message: 'Please select a timeout value', type: 'error' });
        return;
      }

      var entryPointScope = vm.entryPointScope;
      var entryPointName = vm.entryPointName;
      var entryPointValue = vm.entryPointValue;

      if (!vm.entryPointIsNew) {
        var config = {};
        config['baseUrl'] = vm.$parent.environment.baseUrl;
        config['appId'] = vm.app.id;
        config['entryPoint'] = vm.entryPointTmp;
        config['username'] = vm.$parent.username;
        config['duration'] = 0;
        var endpoint = vm.$parent.baseUrl + '/portal-backend/api/config/remove-entry-point';
        vm.$parent.loading = true;
        vm.axios.post(endpoint, config).then(function (response) {
          vm.entryPointScope = entryPointScope;
          vm.entryPointName = entryPointName;
          vm.entryPointValue = entryPointValue;
          vm.addEntryPoint(vm);
        }).catch(function (error) {
          console.log(error);
          vm.$parent.loading = false;
          vm.$Simplert.open({ title: 'Error', message: error, type: 'error' });
          vm.getCurrentConfig();
        });
      } else {
        vm.addEntryPoint(vm);
      }
    },
    addEntryPoint: function addEntryPoint(vm) {
      var entryPoint = vm.entryPointScope + ':' + vm.entryPointName;

      var endpoint = vm.$parent.baseUrl + '/portal-backend/api/config/add-entry-point';
      var config = {};
      config['baseUrl'] = vm.$parent.environment.baseUrl;
      config['appId'] = vm.app.id;
      config['entryPoint'] = entryPoint.trim();
      config['duration'] = vm.entryPointValue;
      config['username'] = vm.$parent.username;
      vm.$parent.loading = true;
      vm.axios.post(endpoint, config).then(function (response) {
        vm.$parent.loading = false;
        vm.$Simplert.open({ title: 'Success', message: response.data, type: 'success' });
        vm.getCurrentConfig();
      }).catch(function (error) {
        console.log(error);
        vm.$parent.loading = false;
        vm.$Simplert.open({ title: 'Error', message: error, type: 'error' });
        vm.getCurrentConfig();
      });
    },

    deleteEntryPoint: function deleteEntryPoint(key, value) {
      var vm = this;
      var config = {};
      config['baseUrl'] = vm.$parent.environment.baseUrl;
      config['appId'] = vm.app.id;
      config['entryPoint'] = key;
      config['username'] = vm.$parent.username;
      config['duration'] = 0;

      var endpoint = vm.$parent.baseUrl + '/portal-backend/api/config/remove-entry-point';
      vm.$parent.loading = true;
      vm.axios.post(endpoint, config).then(function (response) {
        vm.$parent.loading = false;
        vm.$Simplert.open({ title: 'Success', message: response.data, type: 'success' });
        vm.getCurrentConfig();
      }).catch(function (error) {
        console.log(error);
        vm.$parent.loading = false;
        vm.$Simplert.open({ title: 'Error', message: error, type: 'error' });
        vm.getCurrentConfig();
      });
    },

    updateEntryPoint: function updateEntryPoint(key, value, show) {
      var arr = key.split(':');
      var entryPointType;
      if (arr[0] === 'processViewResponse') {
        entryPointType = 'Helium View In WebApp';
      } else {
        entryPointType = 'Scheduled Function';
      }
      this.entryPointTmp = key;
      this.updateModalValues(entryPointType, arr[0], arr[1], value);
      if (!show) {
        this.undoKey = key;
        this.undoValue = value;
      }
      this.modalShow = show;
    },
    clearModal: function clearModal() {
      this.entryPointType = null;
      this.entryPointScope = null;
      this.entryPointName = null;
      this.entryPointValue = null;
      this.entryPointIsNew = false;
    },
    btnNewEntryPoint: function btnNewEntryPoint() {
      this.clearModal();
      this.modalShow = true;
      this.entryPointIsNew = true;
    },
    updateModalValues: function updateModalValues(type, scope, entryPoint, value) {
      this.entryPointType = type;
      if (type === 'Helium View In WebApp') {
        this.entryPointScopeReadOnly = true;
        this.entryPointScopePlaceholder = null;
        this.entryPointNamePlaceholder = 'VXML filename (Without extension)';
        this.entryPointValue = value;
        this.entryPointScope = 'processViewResponse';
        this.entryPointName = entryPoint;
      } else if (type === 'Scheduled Function') {
        this.entryPointScope = null;
        this.entryPointScopeReadOnly = false;
        this.entryPointValue = value;
        this.entryPointScopePlaceholder = 'DSL Unit name (As in .mez file)';
        this.entryPointNamePlaceholder = 'DSL function name (As in .mez file)';
        if (scope) {
          this.entryPointScope = scope;
        } else {
          this.entryPointScope = null;
        }
        this.entryPointName = entryPoint;
      }
    },
    getTeams: function getTeams() {
      var vm = this;
      var endpoint = vm.$parent.baseUrl + '/portal-backend/api/schema-access/team-names';
      vm.$parent.loading = true;
      vm.axios.post(endpoint).then(function (response) {
        vm.$parent.loading = false;
        vm.teamNames = response.data;
      }).catch(function (error) {
        vm.$parent.loading = false;
        vm.$Simplert.open({ title: 'Error', message: error.response, type: 'error' });
      });
    },
    grantAccess: function grantAccess() {
      var vm = this;
      var endpoint = vm.$parent.baseUrl + '/portal-backend/api/schema-access/migrate-app';
      var config = {};
      config['environment'] = vm.$parent.environment.name;
      config['teamUser'] = vm.teamUser;
      config['appId'] = vm.app.id;
      vm.$parent.loading = true;
      vm.axios.post(endpoint, config).then(function (response) {
        vm.$parent.loading = false;
        vm.$Simplert.open({ title: 'Success', message: 'Done', type: 'success' });
      }).catch(function (error) {
        console.log(error.response);
        vm.$parent.loading = false;
        vm.$Simplert.open({ title: 'Error', message: error.response.data.response, type: 'error' });
      });
    },
    btnUndo: function btnUndo() {
      var vm = this;
      var endpoint = vm.$parent.baseUrl + '/portal-backend/api/config/add-entry-point';
      var config = {};
      config['baseUrl'] = vm.$parent.environment.baseUrl;
      config['appId'] = vm.app.id;
      config['entryPoint'] = vm.undoKey;
      config['duration'] = vm.undoValue;
      config['username'] = vm.$parent.username;
      vm.$parent.loading = true;
      vm.axios.post(endpoint, config).then(function (response) {
        vm.$parent.loading = false;
        vm.$Simplert.open({ title: 'Success', message: 'Undo Done', type: 'success' });
        vm.getCurrentConfig();
        vm.undoKey = null;
        vm.undoValue = null;
      }).catch(function (error) {
        console.log(error);
        vm.$parent.loading = false;
        vm.$Simplert.open({ title: 'Error', message: error.response.data.response, type: 'error' });
        vm.getCurrentConfig();
      });
    },
    btnApplyMaxDatabaseResults: function btnApplyMaxDatabaseResults() {
      var vm = this;
      var endpoint = vm.$parent.baseUrl + '/portal-backend/api/config/set-max-db-results';
      var config = {};
      config['baseUrl'] = vm.$parent.environment.baseUrl;
      config['appId'] = vm.app.id;
      config['maxDatabaseResults'] = vm.maxDatabaseResults;
      config['username'] = vm.$parent.username;
      vm.$parent.loading = true;
      vm.axios.post(endpoint, config).then(function (response) {
        vm.$parent.loading = false;
        vm.$Simplert.open({ title: 'Success', message: 'Done', type: 'success' });
        vm.getCurrentConfig();
        vm.undoKey = null;
        vm.undoValue = null;
      }).catch(function (error) {
        console.log(error);
        vm.$parent.loading = false;
        vm.$Simplert.open({ title: 'Error', message: error.response.data.response, type: 'error' });
        vm.getCurrentConfig();
      });
    },
    btnApplyEnabled: function btnApplyEnabled() {
      var vm = this;
      var endpoint = vm.$parent.baseUrl + '/portal-backend/api/config/disable-app';
      var config = {};
      config['baseUrl'] = vm.$parent.environment.baseUrl;
      config['appId'] = vm.app.id;
      config['disabled'] = vm.convertFieldToBoolean(vm.disabledApp);
      config['disabledMessage'] = 'This app is currently disabled. Please contact support@mezzanineware.com for further assistance.';
      config['username'] = vm.$parent.username;
      vm.$parent.loading = true;
      vm.axios.post(endpoint, config).then(function (response) {
        vm.$parent.loading = false;
        vm.$Simplert.open({ title: 'Success', message: 'Done', type: 'success' });
        vm.getCurrentConfig();
        vm.undoKey = null;
        vm.undoValue = null;
      }).catch(function (error) {
        console.log(error);
        vm.$parent.loading = false;
        vm.$Simplert.open({ title: 'Error', message: error.response.data.response, type: 'error' });
        vm.getCurrentConfig();
      });
    },
    btnApplyLocked: function btnApplyLocked() {
      var vm = this;
      var endpoint = vm.$parent.baseUrl + '/portal-backend/api/config/lock-app';
      var config = {};
      config['baseUrl'] = vm.$parent.environment.baseUrl;
      config['appId'] = vm.app.id;
      config['locked'] = vm.convertFieldToBoolean(vm.lockedApp);
      config['lockedMessage'] = 'This app is currently locked. Please contact support@mezzanineware.com for further assistance.';
      config['username'] = vm.$parent.username;
      vm.$parent.loading = true;
      vm.axios.post(endpoint, config).then(function (response) {
        vm.$parent.loading = false;
        vm.$Simplert.open({ title: 'Success', message: 'Done', type: 'success' });
        vm.getCurrentConfig();
        vm.undoKey = null;
        vm.undoValue = null;
      }).catch(function (error) {
        console.log(error);
        vm.$parent.loading = false;
        vm.$Simplert.open({ title: 'Error', message: error.response.data.response, type: 'error' });
        vm.getCurrentConfig();
      });
    },
    convertFieldToBoolean: function convertFieldToBoolean(value) {
      if (value === 'Disabled' || value === 'Locked') {
        return true;
      } else if (value === 'Enabled' || value === 'Unlocked') {
        return false;
      }
    },
    convertBooleanToFieldDisabled: function convertBooleanToFieldDisabled(value) {
      if (value === true) {
        return 'Disabled';
      } else {
        return 'Enabled';
      }
    },
    convertBooleanToFieldLocked: function convertBooleanToFieldLocked(value) {
      if (value === true) {
        return 'Locked';
      } else {
        return 'Unlocked';
      }
    }
  },
  created: function created() {
    var vm = this;
    vm.$parent.apps.forEach(function (key) {
      if (key.id === vm.$route.params.appid) {
        vm.app = key;
      }
    });
    vm.getCurrentConfig();
    vm.getTeams();
    vm.configUndo = vm.config;
  },

  watch: {
    'entryPointType': function entryPointType(val) {
      this.updateModalValues(val, this.entryPointScope, this.entryPointName, this.entryPointValue);
    }
  },
  computed: {
    timeoutValueClass: function timeoutValueClass() {
      return {
        'text-primary': this.entryPointValue === 0,
        'text-success': this.entryPointValue < 20,
        'text-warning': this.entryPointValue >= 20,
        'text-danger': this.entryPointValue > 45
      };
    },
    maxDatabaseResultsValueClass: function maxDatabaseResultsValueClass() {
      return {
        'text-primary': this.maxDatabaseResults === 0,
        'text-success': this.maxDatabaseResults < 2500,
        'text-warning': this.maxDatabaseResults >= 2500,
        'text-danger': this.maxDatabaseResults > 6000
      };
    },
    timeoutValues: function timeoutValues() {
      var values = [];
      for (var i = 1; i <= 120; i = i + 5) {
        if (i === 6) {
          i--;
        }
        values.push(i);
      }
      return values;
    },
    maxDatabaseResultsValues: function maxDatabaseResultsValues() {
      var values = [];
      for (var i = 1; i <= 100000; i = i + 500) {
        if (i === 501) {
          i--;
        }
        values.push(i);
      }
      return values;
    }
  },
  mounted: function mounted() {
    var vm = this;
    window.addEventListener('keydown', function (e) {
      if (vm.modalShow && e.keyCode === 27) {
        vm.modalCloseCallback();
      }
    });
  }
});

/***/ }),

/***/ 238:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_min_css__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_strap__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Deployments',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default.a,
    modal: __WEBPACK_IMPORTED_MODULE_3_vue_strap__["modal"]
  },
  data: function data() {
    return {
      wizardTitle: '',
      modalTitle: '',
      modalInfoShow: false,
      selection: null,
      mergeBtnDisabled: false,
      loading: false,
      success: false,
      alertDuration: 3000,
      showSpinner: false,
      showForm: false,
      isEdit: false,
      modalBackdrop: false,
      loadingWizard: false,
      errorMsg: null,
      count: 0,
      dataSources: [],
      teams: [],
      jiraProjects: [],
      deployments: [],
      heliumApps: [],
      selectedAppIds: [],
      selectedAppSchemas: [],
      selectedAppNames: [],
      selectedDate: null,
      selectedDataSource: null,
      selectedTeam: null,
      selectedProject: null,
      releaseName: '',
      releaseTag: '',
      releaseDescription: '',
      instructions: '',
      releaseGroup: '',
      scheduleToBeResolved: null,
      deploymentScheduleRequestId: 'null',
      modalResolveShow: false,
      modalResolveConfirmInput: '',
      resolveDisabled: true,
      date: 'today',
      config: {
        wrap: true,
        altInput: true,
        enableTime: true,
        defaultHour: 18,
        defaultMinute: 0,
        enableSeconds: true,
        minDate: new Date(),
        disable: [function (date) {
          return date.getDay() === 0 || date.getDay() === 6 || date.getDay() === 6;
        }]
      },
      deploymentColumns: [{
        label: 'Deployment Date',
        field: 'deploymentDate',
        type: 'datetime',
        filterable: true
      }, {
        label: 'Team',
        field: 'team',
        filterable: true
      }, {
        label: 'Project',
        field: 'jiraProject',
        filterable: true
      }, {
        label: 'Helium Apps',
        field: 'appNames',
        filterable: true
      }, {
        label: 'Schemas',
        field: 'appSchemas',
        filterable: true
      }, {
        label: 'Release Name',
        field: 'releaseName',
        filterable: true
      }, {
        label: 'Release Group',
        field: 'releaseGroup',
        filterable: true
      }, {
        label: 'Actions',
        field: 'actions'
      }],
      heliumAppColumns: [{
        label: 'Helium App',
        field: 'name',
        filterable: true
      }, {
        label: 'App ID',
        field: 'id',
        filterable: true
      }]
    };
  },

  methods: {
    validateStep1: function validateStep1() {
      var vm = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (!vm.selectedDataSource) {
          reject('Please select a data source');
        }
        if (!vm.selectedTeam) {
          reject('Please select a team');
        }
        if (!vm.selectedProject) {
          reject('Please select a JIRA Project');
        }
        if (vm.selectedAppIds.length < 1) {
          reject('Please select atleast one Helium App.');
        }
        resolve(true);
      });
    },
    validateStep2: function validateStep2() {
      var vm = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (!vm.releaseTag.startsWith('https://bitbucket.org/mezzanineapps/')) {
          reject('This URL is invalid. It does not begin with "https://bitbucket.org/mezzanineapps/". Please enter a valid Bitbucket URL containing the tag to release.');
        }
        if (!vm.releaseTag.includes('/commits/tag/')) {
          reject('This URL does not contain the tag. Please enter a valid Bitbucket URL containing the tag to release.');
        }
        if (!vm.releaseName) {
          reject('Please enter a Release Name');
        }
        if (!vm.releaseGroup) {
          reject('Please enter a Release Group');
        }
        if (!vm.selectedDate) {
          reject('Please select a Deployment Date.');
        }
        resolve(true);
      });
    },
    setLoading: function setLoading(value) {
      this.loadingWizard = value;
    },
    handleValidation: function handleValidation(isValid, tabIndex) {
      console.log('Tab: ' + tabIndex + ' valid: ' + isValid);
    },
    handleErrorMessage: function handleErrorMessage(errorMsg) {
      this.errorMsg = errorMsg;
    },
    pingDatabase: function pingDatabase(dataSource) {
      var vm = this;
      var endpoint = vm.$parent.baseUrl + '/portal-backend/api/schema-access/ping-database';
      var config = {};
      config['environment'] = vm.$parent.environment.name;
      config['dataSource'] = dataSource;
      vm.loading = true;
      vm.axios.post(endpoint, config).then(function (response) {
        vm.loading = false;
        var element = {};
        element['heliumDataSourceName'] = dataSource.heliumDataSourceName;
        element['response'] = response.data.response;
        element['dataSource'] = dataSource;
        vm.dataSources.push(element);
      }).catch(function (error) {
        vm.loading = false;
        var obj = {
          title: 'Problem retrieving Ping to Database.',
          message: error.response,
          type: 'error'
        };
        vm.$Simplert.open(obj);
      });
    },
    getDatabaseServers: function getDatabaseServers() {
      var vm = this;
      vm.$parent.environment.dataSources.forEach(function (key) {
        vm.pingDatabase(key);
      });
    },
    getTeams: function getTeams() {
      var vm = this;
      var endpoint = vm.$parent.baseUrl + '/portal-backend/api/deployment/teams';
      vm.axios.get(endpoint).then(function (response) {
        vm.teams = response.data;
      }).catch(function (error) {
        vm.loading = false;
        var obj = {
          title: 'Problem retrieving Teams.',
          message: error.response,
          type: 'error'
        };
        vm.$Simplert.open(obj);
      });
    },
    getJiraProjects: function getJiraProjects(team) {
      var teamParam = team.replace(/\s+/g, '');
      var vm = this;
      var endpoint = vm.$parent.baseUrl + '/portal-backend/api/deployment/jira-project/' + teamParam;
      vm.axios.get(endpoint).then(function (response) {
        vm.jiraProjects = response.data;
      }).catch(function (error) {
        vm.loading = false;
        var obj = {
          title: 'Problem retrieving JIRA Projects.',
          message: error.response,
          type: 'error'
        };
        vm.$Simplert.open(obj);
      });
    },
    getHeliumApps: function getHeliumApps(team, jiraProject) {
      var teamParam = team.replace(/\s+/g, '');
      var projectParam = jiraProject.replace(/\s+/g, '');
      var vm = this;
      var endpoint = vm.$parent.baseUrl + '/portal-backend/api/deployment/apps/';
      var config = {};
      config['environment'] = vm.$parent.environment.name;
      config['dataSource'] = vm.selectedDataSource;
      config['team'] = teamParam;
      config['jiraProject'] = projectParam;
      vm.axios.post(endpoint, config).then(function (response) {
        vm.heliumApps = response.data;
        var selectAll = {};
        if (vm.isEdit) {
          selectAll['selected'] = true;
        } else {
          selectAll['selected'] = false;
        }
        selectAll['selectedRows'] = vm.heliumApps;
        vm.onSelectAll(selectAll);
      }).catch(function (error) {
        vm.loading = false;
        var obj = {
          title: 'Problem retrieving Helium Apps.',
          message: error.response,
          type: 'error'
        };
        vm.$Simplert.open(obj);
      });
    },
    onRowClick: function onRowClick(params) {
      var index = this.selectedAppIds.indexOf(params.row.id);
      var exists = index !== -1;
      if (params.selected) {
        if (!exists) {
          this.selectedAppIds.push(params.row.id);
          this.selectedAppSchemas.push(params.row.schemaName);
          this.selectedAppNames.push(params.row.name);
        }
      } else {
        if (exists) {
          this.selectedAppIds.splice(index, 1);
          this.selectedAppSchemas.splice(index, 1);
          this.selectedAppNames.splice(index, 1);
        }
      }
    },
    onSelectAll: function onSelectAll(params) {
      var vm = this;
      var selectedAppIdsTmp = vm.selectedAppIds;
      vm.selectedAppIds = [];
      vm.selectedAppNames = [];
      vm.selectedAppSchemas = [];
      params.selectedRows.forEach(function (key) {
        var index = selectedAppIdsTmp.indexOf(key.id);
        if (params.selected) {
          if (vm.isEdit && index >= 0) {
            key.vgtSelected = true;
            vm.selectedAppIds.push(key.id);
            vm.selectedAppNames.push(key.name);
            vm.selectedAppSchemas.push(key.schemaName);
          } else {
            key.vgtSelected = false;
            vm.selectedAppIds.push(key.id);
            vm.selectedAppNames.push(key.name);
            vm.selectedAppSchemas.push(key.schemaName);
          }
        }
      });
    },
    newForm: function newForm() {
      var vm = this;
      vm.selected = null;
      vm.wizardTitle = 'Schedule a Helium Deployment';
      vm.resetFilters();
      vm.$refs.heliumAppsTable.resetTable();
      vm.$refs.deploymentWizard.reset();
      vm.isEdit = false;
      vm.showForm = true;
      vm.resetFields();
    },
    closeForm: function closeForm() {
      var vm = this;
      vm.showForm = false;
      vm.resetFields();
    },
    resetFields: function resetFields() {
      var vm = this;
      vm.mergeBtnDisabled = false;
      vm.deploymentDate = null;
      vm.releaseName = null;
      vm.selectedDataSource = null;
      vm.selectedTeam = null;
      vm.selectedProject = null;
      vm.selectedAppIds = [];
      vm.selectedAppNames = [];
      vm.selectedAppSchemas = [];
      vm.releaseTag = null;
      vm.releaseGroup = null;
      vm.releaseName = null;
      vm.releaseDescription = null;
      vm.selectedDate = null;
      vm.instructions = null;
      vm.deploymentScheduleRequestId = 'null';
    },
    resetFilters: function resetFilters() {
      var vm = this;
      vm.selectedTeam = null;
      vm.selectedProject = null;
      vm.selectedAppSchemas = [];
      vm.selectedAppNames = [];
      vm.getTeams();
    },
    updateSchedule: function updateSchedule(row) {
      var vm = this;
      vm.wizardTitle = 'Update a Helium Deployment Schedule';
      vm.selected = row;
      vm.$refs.deploymentWizard.reset();
      vm.isEdit = true;
      vm.selectedDataSource = row.dataSource;
      vm.selectedTeam = row.team;
      vm.selectedProject = row.jiraProject;
      vm.selectedDate = row.deploymentDate;
      vm.selectedAppIds = row.appIds;
      vm.selectedAppSchemas = row.appSchemas;
      vm.selectedAppNames = row.appNames;
      vm.releaseTag = row.releaseTag;
      vm.releaseGroup = row.releaseGroup;
      vm.releaseName = row.releaseName;
      vm.instructions = row.instructions;
      vm.deploymentScheduleRequestId = row.id;
      vm.showForm = true;
    },
    modalInfoClose: function modalInfoClose() {
      var vm = this;
      vm.modalInfoShow = false;
      vm.selection = null;
    },
    viewSchedule: function viewSchedule(selection) {
      var vm = this;
      vm.modalInfoShow = true;
      vm.selection = selection;
    },
    mergeSchedule: function mergeSchedule() {
      var vm = this;
      vm.mergeBtnDisabled = false;
      var endpoint = vm.$parent.baseUrl + '/portal-backend/api/deployment/merge/' + vm.deploymentScheduleRequestId;
      var dateStr = vm.selectedDate;
      var isoDateStr = dateStr.replace(' ', 'T');
      var teamStr = vm.selectedTeam;
      var tagStr = vm.releaseTag.split('tag/').pop();
      if (vm.instructions === null) {
        vm.instructions = 'None';
      }
      var config = {};
      config['team'] = teamStr;
      config['jiraProject'] = vm.selectedProject;
      config['environment'] = vm.$parent.environment.name;
      config['dataSource'] = vm.selectedDataSource;
      config['appSchemas'] = vm.selectedAppSchemas;
      config['appNames'] = vm.selectedAppNames;
      config['appIds'] = vm.selectedAppIds;
      config['releaseTag'] = vm.releaseTag;
      config['releaseName'] = vm.releaseName;
      config['releaseGroup'] = vm.releaseGroup;
      config['releaseDescription'] = tagStr;
      config['scheduleStatus'] = 'MERGE';
      config['portalUser'] = vm.$parent.username;
      config['instructions'] = vm.instructions;
      config['deploymentDate'] = isoDateStr;
      vm.loading = true;
      vm.axios.post(endpoint, config).then(function (response) {
        vm.loading = false;
        vm.closeForm();
        vm.getSchedules();
        var obj = {
          title: 'Deployment Schedule has been updated.',
          message: response.data,
          type: 'success'
        };
        vm.$Simplert.open(obj);
      }).catch(function (error) {
        vm.loading = false;
        var obj = {
          title: 'Problem merging Deployment Schedule.',
          message: error.response,
          type: 'error'
        };
        vm.$Simplert.open(obj);
      });
    },
    closeModalBtnClick: function closeModalBtnClick() {
      this.modalResolveShow = false;
      this.scheduleToBeResolved = null;
      this.modalResolveConfirmInput = '';
    },
    resolveBtnClick: function resolveBtnClick(row) {
      this.modalTitle = 'Confirm resolve on Scheduled Deployment: ' + row.releaseName;
      this.modalResolveShow = true;
      this.scheduleToBeResolved = row.id;
    },
    resolveSchedule: function resolveSchedule() {
      var vm = this;
      var endpoint = vm.$parent.baseUrl + '/portal-backend/api/deployment/resolve/' + this.scheduleToBeResolved;
      vm.loading = true;
      vm.axios.post(endpoint).then(function (response) {
        vm.loading = false;
        vm.getSchedules();
        vm.closeModalBtnClick();
        var obj = {
          title: 'Resolved Deployment Schedule',
          message: response.data,
          type: 'success'
        };
        vm.$Simplert.open(obj);
      }).catch(function (error) {
        console.log(error);
        vm.loading = false;
        var obj = {
          title: 'Problem resolving Deployment Schedule.',
          message: error.response,
          type: 'error'
        };
        vm.$Simplert.open(obj);
      });
    },
    getSchedules: function getSchedules() {
      var vm = this;
      var endpoint = vm.$parent.baseUrl + '/portal-backend/api/deployment/list';
      vm.loading = true;
      vm.axios.get(endpoint).then(function (response) {
        vm.loading = false;
        vm.deployments = response.data;
      }).catch(function (error) {
        vm.loading = false;
        var obj = {
          title: 'Problem retrieving Deployment Schedules.',
          message: error.response,
          type: 'error'
        };
        vm.$Simplert.open(obj);
      });
    }
  },
  created: function created() {
    var vm = this;
    vm.getDatabaseServers();
    vm.getTeams();
    vm.getSchedules();
    vm.resetFields();
    window.addEventListener('keydown', function (e) {
      if (e.keyCode === 27) {
        vm.closeForm();
        vm.modalInfoClose();
        vm.resetFilters();
      }
    });
  },

  watch: {
    'modalResolveConfirmInput': function modalResolveConfirmInput(newValue) {
      if (newValue === 'RESOLVE') {
        this.resolveDisabled = false;
      } else {
        this.resolveDisabled = true;
      }
    },
    'selectedDataSource': function selectedDataSource(val, oldVal) {
      if (val && !this.isEdit) {
        this.resetFilters();
      }
    },
    'selectedTeam': function selectedTeam(val, oldVal) {
      if (val) {
        this.getJiraProjects(val);
      }
    },
    'selectedProject': function selectedProject(val) {
      if (val) {
        this.getHeliumApps(this.selectedTeam, val);
      }
    },
    'selectedAppIds': function selectedAppIds(val) {
      console.log(val);
    }
  }
});

/***/ }),

/***/ 239:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {
      textBlock: 'curl https://portal.heliumapps.com/static/deploy-helium-dev.sh | bash',
      heliumDevAppUri: '',
      noUIHeliumDevAppUri: ''
    };
  },
  methods: {
    getUri: function getUri() {
      var vm = this;
      var endpoint = vm.$parent.baseUrl + '/portal-backend/api/he-latest-release-version';

      vm.$parent.loading = true;
      vm.axios.get(endpoint).then(function (response) {
        vm.$parent.loading = false;
        var version = response.data;
        var releasePath = '/release-latest/HeliumDev-app-';
        vm.heliumDevAppUri = vm.$parent.baseUrl + releasePath + version + '-jar-with-dependencies.jar';
        vm.noUIHeliumDevAppUri = vm.$parent.baseUrl + releasePath + version + '-no-ui-jar-with-dependencies.jar';
      }).catch(function (error) {
        vm.$parent.loading = false;
        vm.$Simplert.open({ title: 'Error', message: error, type: 'error' });
        console.log(error);
      });
    },
    onCopy: function onCopy() {
      var vm = this;
      vm.$Simplert.open({ title: 'Copied', message: 'Paste me into terminal!', type: 'success' });
    }
  },
  created: function created() {
    var vm = this;
    vm.getUri();
  }
});

/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(318)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(584),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-322885e2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 240:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {};
  },

  methods: {
    pushApps: function pushApps() {
      this.$router.push({ name: 'Apps' });
    },
    pushHeliumJourney: function pushHeliumJourney() {
      this.$router.push({ name: 'Sync' });
    },
    pushDeployments: function pushDeployments() {
      if (this.$parent.isProduction) {
        this.$router.push({ name: 'Deployments' });
      }
    }
  }
});

/***/ }),

/***/ 241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PieChart_vue__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PieChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_PieChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_strap__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    modal: __WEBPACK_IMPORTED_MODULE_1_vue_strap__["modal"],
    PieChart: __WEBPACK_IMPORTED_MODULE_0__components_PieChart_vue___default.a
  },
  data: function data() {
    return {
      loading: false,
      hostnames: [],
      hostname: null,
      hostnameReset: null,
      hostnameApps: [],
      hostnameApp: null,
      columns: [{
        label: 'Query',
        field: 'query',
        filterable: true
      }, {
        label: 'Calls',
        field: 'calls',
        filterable: true,
        type: 'number'
      }, {
        label: 'Total Time',
        field: 'total_time',
        filterable: true,
        type: 'number'
      }, {
        label: 'Min Time',
        field: 'min_time',
        filterable: true,
        type: 'number'
      }, {
        label: 'Max Time',
        field: 'max_time',
        filterable: true,
        type: 'number'
      }, {
        label: 'Mean Time',
        field: 'mean_time',
        filterable: true,
        type: 'number'
      }, {
        label: 'Standard Deviation',
        field: 'stddev_time',
        filterable: true,
        type: 'number'
      }, {
        label: 'Rows retrieved or affected',
        field: 'rows',
        filterable: true,
        type: 'number'
      }],
      rows: [],
      modalResetShow: false,
      modalBackdrop: false,
      resetDisabled: true,
      resetConfirmText: null,
      lastReset: null,
      lastResetStr: null,
      modalShowDetail: false,
      selectedQuery: null,
      chartOptions: null,
      chartData: null,
      chartType: 'Mean Time',
      chartSortType: 'Descending',
      chartQueries: [],
      chartResultSetSize: 5,
      dataSources: [],
      dataSource: null,
      selectedMode: 'App'
    };
  },

  methods: {
    getDatabaseServers: function getDatabaseServers() {
      var vm = this;
      vm.$parent.environment.dataSources.forEach(function (key) {
        vm.pingDatabase(key);
      });
    },
    pingDatabase: function pingDatabase(dataSource) {
      var vm = this;
      var endpoint = vm.$parent.baseUrl + '/portal-backend/api/schema-access/ping-database';
      var config = {};
      config['environment'] = vm.$parent.environment.name;
      config['dataSource'] = dataSource;
      vm.axios.post(endpoint, config).then(function (response) {
        var element = {};
        element['heliumDataSourceName'] = dataSource.heliumDataSourceName;
        element['response'] = response.data.response;
        element['dataSource'] = dataSource;
        vm.dataSources.push(element);
      }).catch(function (error) {
        var element = {};
        element['heliumDataSourceName'] = dataSource.heliumDataSourceName;
        element['response'] = error.response.data.response;
        vm.dataSources.push(element);
      });
    },
    getDatabaseHostApps: function getDatabaseHostApps() {
      var vm = this;
      var endpoint = vm.$parent.baseUrl + '/portal-backend/api/schema-access/app-schemas';

      var config = {};
      config['environment'] = vm.$parent.environment.name;
      config['dataSource'] = vm.dataSource;

      vm.loading = true;
      vm.$parent.loading = true;
      vm.axios.post(endpoint, config).then(function (response) {
        vm.hostnameApps = response.data;
        vm.loading = false;
        vm.$parent.loading = false;
        if (vm.hostnameApps.length <= 0) {
          vm.$Simplert.open({ title: 'Info', message: 'No database servers found on ' + endpoint, type: 'info' });
        }
      }).catch(function (error) {
        vm.loading = false;
        vm.$parent.loading = false;
        vm.$Simplert.open({ title: 'Error', message: error, type: 'error' });
      });
    },
    getPgStats: function getPgStats(config) {
      var vm = this;
      var endpoint = vm.$parent.baseUrl + '/portal-backend/api/db-spy/stats';
      vm.loading = true;
      vm.$parent.loading = true;
      vm.axios.post(endpoint, config).then(function (response) {
        vm.loading = false;
        vm.$parent.loading = false;
        vm.rows = response.data;
        if (vm.rows.length <= 0) {
          vm.$Simplert.open({ title: 'Info', message: 'No postgres statement stats found on ' + endpoint, type: 'info' });
        }
        vm.maybeUpdateChartData();
      }).catch(function (error) {
        vm.loading = false;
        vm.$parent.loading = false;
        vm.$Simplert.open({ title: 'Info', message: error, type: 'info' });
      });
    },
    getPgStatsDatasource: function getPgStatsDatasource() {
      var vm = this;
      var config = {};
      config['environment'] = vm.$parent.environment.name;
      config['dataSource'] = vm.dataSource;
      vm.getPgStats(config);
    },
    getPgStatsForApp: function getPgStatsForApp(appId) {
      var vm = this;
      var config = {};
      config['environment'] = vm.$parent.environment.name;
      config['appId'] = appId;
      vm.getPgStats(config);
    },
    pgStatReset: function pgStatReset() {
      var vm = this;
      var endpoint = vm.$parent.baseUrl + '/schema-access/api/pgStatReset/?hostname=' + vm.hostnameReset;
      var config = {};
      config['hostname'] = vm.hostnameReset;
      vm.loading = true;
      vm.$parent.loading = true;
      vm.axios.post(endpoint, config).then(function (response) {
        vm.rows = response.data;
        vm.loading = false;
        vm.$parent.loading = false;
        vm.closePgStatReset();
        vm.resetData();
      }).catch(function (error) {
        vm.loading = false;
        vm.$parent.loading = false;
        vm.$Simplert.open({ title: 'Error', message: error, type: 'error' });
        vm.closePgStatReset();
      });
    },
    pgStatLastReset: function pgStatLastReset() {
      var vm = this;
      var endpoint = vm.$parent.baseUrl + '/portal-backend/api/db-spy/last-reset';
      vm.loading = true;
      vm.$parent.loading = false;
      vm.axios.post(endpoint).then(function (response) {
        vm.lastReset = response.data;
        vm.loading = false;
        vm.$parent.loading = false;
      }).catch(function (error) {
        vm.loading = false;
        vm.$parent.loading = false;
        vm.$Simplert.open({ title: 'Error', message: error, type: 'error' });
      });
    },
    showPgStatReset: function showPgStatReset() {
      var vm = this;
      vm.modalResetShow = true;
    },
    closePgStatReset: function closePgStatReset() {
      var vm = this;
      vm.modalResetShow = false;
    },
    resetData: function resetData() {
      var vm = this;
      vm.rows = [];
      vm.hostnameApps = [];
      vm.hostname = null;
      vm.hostnameApp = null;
    },
    refreshRows: function refreshRows() {
      var vm = this;
      if (vm.hostnameApp) {
        var appId = vm.hostnameApp.split('( ').pop().split(' )').shift();
        vm.getPgStatsForApp(appId);
      }
    },
    onClickFn: function onClickFn(row, index) {
      var vm = this;
      vm.selectedQuery = row;
      vm.modalShowDetail = true;
    },
    closeModalShowDetail: function closeModalShowDetail() {
      var vm = this;
      vm.modalShowDetail = false;
    },
    setChartData: function setChartData() {
      var vm = this;

      vm.chartQueries = [];

      var chartLabels = [];
      var chartDataElements = [];
      var chartColours = [];
      var chartDatasets = [];

      var chartTypeField = vm.formatChartTypeLabelToField(vm.chartType);

      var rowsData = this.rows.slice().sort(function (a, b) {
        if (vm.chartSortType === 'Ascending') {
          return a[chartTypeField] - b[chartTypeField];
        } else if (vm.chartSortType === 'Descending') {
          return b[chartTypeField] - a[chartTypeField];
        }
      });
      for (var i = 0; i < vm.chartResultSetSize && i < rowsData.length; i++) {
        var ele = rowsData[i];
        chartLabels.push('#' + (i + 1) + ' ' + chartTypeField);
        var suffix = chartTypeField === 'total_time' || chartTypeField === 'min_time' || chartTypeField === 'max_time' || chartTypeField === 'mean_time' || chartTypeField === 'stddev_time' ? 's' : '';
        vm.chartQueries.push('-- Query #' + (i + 1) + '\n' + ele.query + '\n-- Value:\n' + ele[chartTypeField] + suffix + ' ' + vm.chartType);
        chartDataElements.push(ele[chartTypeField]);
        chartColours.push(vm.getRandomColor());
      }
      chartDatasets.push({
        backgroundColor: chartColours,
        data: chartDataElements
      });
      vm.chartData = {
        labels: chartLabels,
        datasets: [{
          backgroundColor: chartColours,
          data: chartDataElements
        }]
      };
    },
    getRandomColor: function getRandomColor() {
      var letters = '0123456789ABCDEF';
      var color = '#';
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    maybeUpdateChartData: function maybeUpdateChartData() {
      var vm = this;
      if (vm.chartType !== null && vm.chartSortType !== null && vm.chartResultSetSize != null) {
        vm.setChartData();
      }
    },
    formatChartTypeLabelToField: function formatChartTypeLabelToField(value) {
      var vm = this;
      if (vm.chartType === null) {
        return null;
      }
      var result = null;
      vm.columns.slice().filter(function (item) {
        return item.label === value;
      }).forEach(function (element) {
        result = element.field;
      });
      return result;
    }
  },
  created: function created() {
    var vm = this;
    vm.getDatabaseServers();
    vm.pgStatLastReset();
    window.addEventListener('keydown', function (e) {
      if (e.keyCode === 27) {
        vm.closeModalShowDetail();
        vm.closePgStatReset();
      }
    });
  },
  mounted: function mounted() {},

  beforeDestroy: function beforeDestroy() {},
  watch: {
    'dataSource': function dataSource(newValue) {
      var vm = this;
      if (newValue) {
        vm.getDatabaseHostApps();
        vm.lastReset.forEach(function (key) {
          if (key.databaseHost.toUpperCase().replace(/_/g, '-') === newValue.toUpperCase()) {
            vm.lastResetStr = 'Stats last reset on ' + newValue + ' last reset at ' + key.lastReset;
          }
        });
        if (vm.selectedMode === 'Datasource') {
          vm.getPgStatsDatasource();
        }
      }
    },
    'hostnameApp': function hostnameApp(newValue) {
      var vm = this;
      if (newValue) {
        var appId = newValue.split('( ').pop().split(' )').shift();
        vm.getPgStatsForApp(appId);
      }
    },
    selectedMode: function selectedMode(newValue) {
      this.dataSource = null;
      this.hostnameApp = null;
    },
    'resetConfirmText': function resetConfirmText(newValue) {
      var vm = this;
      if (newValue === 'RESET') {
        vm.resetDisabled = false;
      } else {
        vm.resetDisabled = true;
      }
    },
    'chartType': function chartType(newValue) {
      var vm = this;
      vm.maybeUpdateChartData();
    },
    'chartSortType': function chartSortType(newValue) {
      var vm = this;
      vm.maybeUpdateChartData();
    },
    'chartResultSetSize': function chartResultSetSize(newValue) {
      var vm = this;
      vm.maybeUpdateChartData();
    }
  },
  computed: {
    chartTypeDropdown: function chartTypeDropdown() {
      var vm = this;
      return vm.columns.slice().filter(function (item) {
        return item.field !== 'query';
      });
    },
    chartResultSetSizes: function chartResultSetSizes() {
      var values = [];
      for (var i = 5; i <= this.rows.length; i = i + 5) {
        values.push(i);
      }
      return values;
    }
  }
});

/***/ }),

/***/ 242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay_dist_vue_loading_min_css__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay_dist_vue_loading_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay_dist_vue_loading_min_css__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      app: null,
      scheduledFunctions: [],
      functionColumns: [{
        label: 'Schedule',
        field: 'schedule'
      }, {
        label: 'Unit',
        field: 'unit',
        filterable: true
      }, {
        label: 'Function',
        field: 'event',
        filterable: true
      }, {
        label: 'State',
        field: 'state',
        filterable: true
      }, {
        label: 'Actions',
        field: 'btn',
        html: true
      }],
      sfLoading: false
    };
  },
  methods: {
    getCurrentScheduledFunctions: function getCurrentScheduledFunctions() {
      var vm = this;
      vm.$parent.loading = true;
      vm.scheduledFunctions = [];

      var config = {};
      var credentials = {};
      credentials['userName'] = vm.$parent.username;
      credentials['password'] = vm.$parent.password;
      config['credentials'] = credentials;
      config['baseUrl'] = vm.$parent.environment.baseUrl;
      config['appId'] = vm.app.id;
      var endpoint = vm.$parent.baseUrl + '/portal-backend/api/config/get-scheduled-events/';
      vm.axios.post(endpoint, config).then(function (response) {
        vm.scheduledFunctions = response.data;
        vm.$parent.loading = false;
      }).catch(function (error) {
        vm.$parent.loading = false;
        var obj = {
          title: 'Error getting scheduled functions!',
          message: error.response.data,
          type: 'error'
        };
        vm.$Simplert.open(obj);
      });
    },
    btnToggleScheduledFunction: function btnToggleScheduledFunction(unit, event, state) {
      var vm = this;
      var config = {};
      config['baseUrl'] = vm.$parent.environment.baseUrl;
      config['appId'] = vm.app.id;
      config['scheduledEvent'] = unit + ':' + event;
      config['state'] = state;
      var endpoint = vm.$parent.baseUrl + '/portal-backend/api/config/toggle-scheduled-event';
      vm.$parent.loading = true;
      vm.axios.post(endpoint, config).then(function (response) {
        vm.$Simplert.open({ title: 'Success', message: response.data, type: 'success' });
        vm.$parent.loading = false;
      }).catch(function (error) {
        vm.$parent.loading = false;
        vm.$Simplert.open({ title: 'Error', message: error.response.data, type: 'error' });
      });
      vm.getCurrentScheduledFunctions();
    }
  },
  created: function created() {
    var vm = this;
    vm.$parent.apps.forEach(function (key) {
      if (key.id === vm.$route.params.appid) {
        vm.app = key;
      }
    });
    vm.getCurrentScheduledFunctions();
  }
});

/***/ }),

/***/ 243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TextEditor_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TextEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_TextEditor_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SchemaAccess',
  components: {
    TextEditor: __WEBPACK_IMPORTED_MODULE_0__components_TextEditor_vue___default.a
  },
  data: function data() {
    return {
      dataSource: null,
      dataSources: [],
      teamNames: [],
      teamUser: '',
      schemaName: '',
      response: null,
      actions: [],
      textBlockWidth: 0,
      textBlockHeight: 0,
      textBlockReadOnly: false,
      textBlockScrollToLine: 0,
      modeRadio: 'migrate',
      textBlockLang: 'sql',
      appList: []
    };
  },
  methods: {
    getDatabaseServers: function getDatabaseServers() {
      var vm = this;
      vm.$parent.environment.dataSources.forEach(function (dataSource) {
        vm.pingDatabase(dataSource);
      });
    },
    getTeams: function getTeams() {
      var vm = this;
      var endpoint = vm.$parent.baseUrl + '/portal-backend/api/schema-access/team-names';
      vm.axios.post(endpoint).then(function (response) {
        vm.teamNames = response.data;
      }).catch(function (error) {
        var obj = {
          title: 'Unable to find team names',
          message: error,
          type: 'error'
        };
        vm.$Simplert.open(obj);
      });
    },
    pingDatabase: function pingDatabase(dataSource) {
      var vm = this;
      var endpoint = vm.$parent.baseUrl + '/portal-backend/api/schema-access/ping-database';
      var config = {};
      config['environment'] = vm.$parent.environment.name;
      config['dataSource'] = dataSource;
      vm.axios.post(endpoint, config).then(function (response) {
        var element = {};
        element['heliumDataSourceName'] = dataSource.heliumDataSourceName;
        element['response'] = response.data.response;
        element['dataSource'] = dataSource;
        vm.dataSources.push(element);
      }).catch(function (error) {
        var element = {};
        element['heliumDataSourceName'] = dataSource.heliumDataSourceName;
        element['response'] = error.response.data.response;
        vm.dataSources.push(element);
        var obj = {
          title: 'Unable to ping database',
          message: error,
          type: 'error'
        };
        vm.$Simplert.open(obj);
      });
    },
    grantAccess: function grantAccess() {
      var vm = this;
      vm.showFeedback = true;
      vm.actions = [];
      var endpoint = vm.$parent.baseUrl + '/portal-backend/api/schema-access/migrate-schema';
      var config = {};
      config['environment'] = vm.$parent.environment.name;
      config['dataSource'] = vm.dataSource;
      config['teamUser'] = vm.teamUser;
      config['schemaName'] = vm.schemaName;
      vm.axios.post(endpoint, config).then(function (response) {
        var obj = {
          title: 'Access granted!',
          type: 'success'
        };
        vm.$Simplert.open(obj);
        vm.response = response.data;
        vm.updateActions(response.data.actions);
      }).catch(function (error) {
        var obj = {
          title: 'Failed to grant access!',
          message: error.response.data,
          type: 'error'
        };
        vm.$Simplert.open(obj);
        vm.response = error.response.data;
        vm.updateActions(error.response.data.actions);
      });
    },
    generateSql: function generateSql() {
      var vm = this;
      var endpoint = vm.$parent.baseUrl + '/portal-backend/api/schema-access/generate-sql';
      var config = {};
      config['teamUser'] = vm.teamUser;
      config['schemaName'] = vm.schemaName;
      vm.actions = [];
      vm.axios.post(endpoint, config).then(function (response) {
        vm.showFeedback = false;
        vm.response = response.data;
        response.data.actions.forEach(function (key) {
          vm.actions.push(key);
        });
        var obj = {
          title: 'SQL generated!',
          type: 'success'
        };
        vm.$Simplert.open(obj);
        vm.resizeEditor();
      }).catch(function (error) {
        vm.response = error.response.data;
        var obj = {
          title: 'Failed to generated SQL!',
          message: error,
          type: 'error'
        };
        vm.$Simplert.open(obj);
        vm.resizeEditor();
      });
    },
    updateActions: function updateActions(actionsParam) {
      var vm = this;
      vm.actions = [];
      actionsParam.forEach(function (key) {
        vm.actions.push(key);
      });
    },
    onCopy: function onCopy() {
      var vm = this;
      var obj = {
        title: 'Copied to your clipboard!',
        message: 'Remember to execute the SQL generating statements',
        type: 'success'
      };
      vm.$Simplert.open(obj);
    },
    resizeEditor: function resizeEditor() {
      var newHeight = window.innerHeight;
      var newWidth = 0;
      if (this.$refs.resultsRef) {
        newWidth = this.$refs.resultsRef.clientWidth;
      }
      this.textBlockWidth = Math.round(newWidth * 90 / 100);
      this.textBlockHeight = Math.round(newHeight * 60 / 100);
    },
    getApps: function getApps(value) {
      var vm = this;
      var endpoint = vm.$parent.baseUrl + '/portal-backend/api/schema-access/app-schemas';
      var config = {};

      config['environment'] = vm.$parent.environment.name;
      config['dataSource'] = value;

      vm.loading = true;
      vm.$parent.loading = true;
      vm.axios.post(endpoint, config).then(function (response) {
        vm.loading = false;
        vm.$parent.loading = false;
        vm.appList = response.data;
        if (vm.appList.length <= 0) {
          var obj = {
            title: 'No database servers',
            message: 'There were no database servers found on ' + endpoint,
            type: 'error'
          };
          vm.$Simplert.open(obj);
        }
      }).catch(function (error) {
        vm.loading = false;
        vm.$parent.loading = false;
        console.log('error getting app-schemas');
        console.log(error.response);
        var obj = { title: 'Error', message: error.response, type: 'error' };
        vm.$Simplert.open(obj);
        vm.alertResponse(false, error.response.status, error.response.data);
      });
    },
    resetData: function resetData() {
      this.appList = [];
      this.teamUser = null;
      this.dataSource = null;
      this.schemaName = null;
    }
  },
  created: function created() {
    this.getDatabaseServers();
    this.getTeams();
    window.addEventListener('resize', this.resizeEditor);
  },

  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resizeEditor);
  },
  watch: {
    'dataSource': function dataSource(newValue) {
      var vm = this;
      if (newValue) {
        vm.getApps(newValue);
      }
    }
  },
  computed: {
    textBlock: function textBlock() {
      var vm = this;
      if (vm.actions === null) {
        return '';
      }
      return vm.actions.join('\n');
    }
  }
});

/***/ }),

/***/ 244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_search_select__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_search_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select_dist_VueSearchSelect_css__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select_dist_VueSearchSelect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_search_select_dist_VueSearchSelect_css__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    modal: __WEBPACK_IMPORTED_MODULE_0_vue_strap__["modal"],
    ModelSelect: __WEBPACK_IMPORTED_MODULE_1_vue_search_select__["ModelSelect"]
  },
  data: function data() {
    return {
      username: null,
      password: null,
      loginError: null,
      selectedEnvironmentOption: {
        value: '',
        text: ''
      }
    };
  },

  methods: {
    signInBtn: function signInBtn() {
      if (!this.username) {
        this.loginError = 'Please enter your Helium API username';
        return;
      } else if (!this.password) {
        this.loginError = 'Please enter your Helium API password';
        return;
      }
      this.signIn(this.username, this.password);
    },
    signIn: function signIn(usernameParam, passwordParam) {
      var vm = this;
      var config = {
        credentials: {
          userName: usernameParam,
          password: passwordParam
        },
        baseUrl: vm.$parent.environment.baseUrl
      };
      vm.$parent.loading = true;
      vm.axios.post(vm.$parent.baseUrl + '/portal-backend/api/apps', config).then(function (response) {
        vm.$parent.username = usernameParam;
        vm.$parent.password = passwordParam;
        vm.$parent.apps = response.data;
        vm.$parent.loading = false;
      }).catch(function (error) {
        console.log(error);
        if (error.response.status === 401) {
          vm.loginError = 'Either the username or password is incorrect';
        } else {
          vm.loginError = 'Error logging in: ' + error.response.statusText + ' (' + error.response.status + ')';

          if (error.response.responseText) {
            vm.loginError += ' ' + error.response.responseText;
          }
        }
        vm.$parent.loading = false;
      });
    }
  },
  created: function created() {
    var vm = this;
    vm.$parent.loading = true;
    vm.axios.get(vm.$parent.baseUrl + '/portal-backend/api/environments').then(function (response) {
      vm.$parent.loading = false;
      vm.$parent.environments = response.data.filter(function (env) {
        if (true) {
          return env.name.toLowerCase() !== 'localhost';
        } else {
          vm.$parent.environment = env;
          return env.name.toLowerCase() === 'localhost';
        }
      });
    }).catch(function (error) {
      vm.$parent.loading = false;
      vm.loginError = 'Error fetching environments: ' + error.response.statusText + ' (' + error.response.status + ')';
      if (error.response.responseText) {
        vm.loginError += ' ' + error.response.responseText;
      }
    });

    window.addEventListener('keydown', function (e) {
      if (e.keyCode === 13) {
        vm.signInBtn();
      }
    });
  },

  computed: {
    environmentOptions: function environmentOptions() {
      var vm = this;
      var result = [];
      if (vm.$parent.environments) {
        vm.$parent.environments.forEach(function (element) {
          var option = { value: element, text: element.name };
          result.push(option);
        });
      }
      return result;
    }
  },
  watch: {
    'selectedEnvironmentOption': function selectedEnvironmentOption(newValue) {
      this.$parent.environment = newValue.value;
    }
  }
});

/***/ }),

/***/ 245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {
      projects: [],
      selectedProject: null,
      loading: false,
      columns: [{
        label: 'Name',
        field: 'name',
        filterable: true
      }, {
        label: 'Number',
        field: 'number',
        filterable: true
      }, {
        label: 'Date',
        field: 'date',
        filterable: true
      }],
      rows: []
    };
  },

  methods: {
    getProjects: function getProjects() {
      var vm = this;
      var endpoint = vm.$parent.baseUrl + '/portal-backend/api/support-roster/teams';
      vm.$parent.loading = true;
      vm.axios.get(endpoint).then(function (response) {
        vm.$parent.loading = false;
        vm.projects = response.data;
      }).catch(function (error) {
        vm.$parent.loading = false;
        vm.$Simplert.open({ title: 'Error', message: error.response, type: 'error' });
        console.log(error);
      });
    },
    getRoster: function getRoster(team) {
      var vm = this;
      var endpoint = vm.$parent.baseUrl + '/portal-backend/api/support-roster/roster';
      var config = {};
      config['team'] = team;

      var d = new Date();

      config['startDate'] = d.getFullYear() + '-01-01';
      config['endDate'] = d.getFullYear() + 1 + '-01-01';
      vm.$parent.loading = true;
      vm.axios.post(endpoint, config).then(function (response) {
        vm.rows = response.data;
        vm.$parent.loading = false;
      }).catch(function (error) {
        console.log(error);
        vm.$parent.loading = false;
        vm.$Simplert.open({ title: 'Error', message: error.response, type: 'error' });
      });
    }
  },
  created: function created() {
    this.getProjects();
  },

  watch: {
    'selectedProject': function selectedProject(val, oldVal) {
      if (val) {
        this.getRoster(val);
      }
    }
  }
});

/***/ }),

/***/ 246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Feedback_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Feedback_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Feedback_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TextEditor_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TextEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_TextEditor_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Feedback: __WEBPACK_IMPORTED_MODULE_1__components_Feedback_vue___default.a,
    modal: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["modal"],
    TextEditor: __WEBPACK_IMPORTED_MODULE_3__components_TextEditor_vue___default.a
  },
  data: function data() {
    return {
      list: [],
      loading: false,
      displayButton: false,
      feedbackMessage: '',
      success: false,
      showSpinner: false,
      showFeedback: false,
      sync_columns: [{
        label: 'Platform',
        field: 'platform'
      }, {
        label: 'Type',
        field: 'type',
        filterable: true
      }, {
        label: 'Object Name',
        field: 'objectName',
        filterable: true
      }, {
        label: 'Object Count',
        field: 'objectCount',
        filterable: true
      }],
      columns: [{
        label: 'Status',
        field: 'status'
      }, {
        label: 'Name',
        field: 'appName',
        filterable: true
      }, {
        label: 'App ID',
        field: 'id',
        filterable: true
      }, {
        label: 'Helium Base Url',
        field: 'heliumBaseUrl',
        filterable: true
      }, {
        label: 'Journey Base Url',
        field: 'journeyBaseUrl',
        filterable: true
      }, {
        label: 'Actions',
        field: 'actions'
      }],
      rows: [],
      sync_rows: [],
      selection: null,
      modalInfoShow: false,
      modalObjectSyncShow: false,
      modalBackdrop: false,
      heliumCurl: null,
      journeyCurl: null,
      syncConfig: null,
      textBlockWidth: 0,
      textBlockHeight: 0,
      textBlockReadOnly: true,
      textBlockLang: 'sql',
      scrollToLine: true,
      logs: [],
      modalLogShow: false,
      showLogsFeedback: false,
      showSyncFeedback: false,
      feedbackLogsMessage: null,
      feedbackSyncMessage: null,
      showLogsSpinner: true,
      showSyncSpinner: true,
      logsSuccess: false,
      syncSuccess: false,
      expand: false,
      modalDeleteShow: false,
      heliumAppUuidForDelete: '',
      heliumDeleteConfirm: '',
      heliumAppNameForDelete: null,
      deleteDisabled: true
    };
  },

  methods: {
    getSyncUrl: function getSyncUrl() {
      var vm = this;
      var endpoint = vm.$parent.baseUrl + '/sync';
      if (vm.$parent.environment.name === 'Zambia-production') {
        endpoint += '-zm';
      } else if (vm.$parent.environment.name !== 'Production') {
        endpoint += '-stb';
      }
      endpoint += '/api/';
      return endpoint;
    },
    getList: function getList() {
      var vm = this;
      var endpoint = vm.getSyncUrl() + 'list';
      var config = {};
      config['environment'] = vm.$parent.environment.name;
      vm.$parent.loading = true;
      vm.loading = true;
      vm.feedbackMessage = null;
      vm.showFeedback = false;
      vm.axios.post(endpoint, config, {
        auth: {
          username: vm.$parent.username,
          password: vm.$parent.password
        }
      }).then(function (response) {
        vm.$parent.syncApps = response.data;
        vm.rows = vm.$parent.syncApps;
        vm.$parent.loading = false;
        vm.loading = false;
        vm.success = true;
        if (vm.rows.length <= 0) {
          vm.feedbackMessage = 'No Helium Journey Integrations found on ' + endpoint;
          vm.showFeedback = true;
        }
        if (vm.$route.params.appid) {
          var result = vm.$parent.syncApps.find(function (key) {
            return key.id === vm.$route.params.appid;
          });
          console.log(result);
          if (result) {
            vm.selectLogs(result);
          }
        }
      }).catch(function (error) {
        console.log(error);
        console.log(error.response);
        vm.$parent.loading = false;
        vm.loading = false;
        if (error.response) {
          vm.feedbackMessage = error.response.status === 502 ? 'Bad Gateway - Invalid response from the upstream server' : error.response.data;
        } else {
          vm.feedbackMessage = error;
          console.log(error);
        }
        vm.success = false;
        vm.showFeedback = true;
      });
    },
    selectInfo: function selectInfo(selection) {
      var vm = this;
      vm.modalInfoShow = true;
      vm.selection = selection;
      vm.heliumCurl = 'curl -X GET -u "d4ec6977-28ab-4caf-8872-edd39b471436:29Z47X436" ';
      vm.heliumCurl += selection.heliumBaseUrl + '/api/data/v1/' + selection.id + '/change-log?version=';
      vm.heliumCurl += selection.heliumSyncStatus;
      vm.heliumCurl += ' | python -mjson.tool';
      vm.journeyCurl = 'curl -X GET -u "' + selection.journeyUserName + ':' + selection.journeyPassword + '" "' + selection.journeyBaseUrl + '/api/v4/' + selection.journeyUserName + '/oplog?start=' + selection.journeySyncStatus + '&skip_source=api" | python -mjson.tool';
    },
    selectObjectSync: function selectObjectSync(selection) {
      var vm = this;
      vm.modalObjectSyncShow = true;
      vm.feedbackSyncMessage = 'Fetching objects';
      vm.showSyncSpinner = true;
      vm.showSyncFeedback = true;
      vm.syncSuccess = true;
      vm.selection = selection;
      vm.heliumCurl = selection.heliumBaseUrl + '/api/data/v1/' + selection.id + '/change-log?version=' + selection.heliumSyncStatus;
      vm.journeyCurl = selection.journeyBaseUrl + '/api/v4/' + selection.journeyUserName + '/oplog?start=' + selection.journeySyncStatus + '&skip_source=api';
      var endpoint = vm.$parent.baseUrl + '/portal-backend/api/get-sync-objects';
      var config = {};
      config['heliumUsername'] = 'd4ec6977-28ab-4caf-8872-edd39b471436';
      config['heliumPassword'] = '29Z47X436';
      config['heliumUrl'] = vm.heliumCurl;
      config['journeyUrl'] = vm.journeyCurl;
      config['journeyUsername'] = selection.journeyUserName;
      config['journeyPassword'] = selection.journeyPassword;
      vm.axios.post(endpoint, config).then(function (response) {
        vm.$parent.syncObjects = response.data;
        vm.sync_rows = vm.$parent.syncObjects;
        vm.showSyncSpinner = false;
        vm.showSyncFeedback = false;
      }).catch(function (error) {
        console.log(error);
        console.log(error.response);
        if (error.response) {
          vm.feedbackSyncMessage = error.response.status === 502 ? 'Bad Gateway - Invalid response from the upstream server' : error.response.data;
        } else {
          vm.feedbackSyncMessage = error;
          console.log(error);
        }
      });
    },
    selectEdit: function selectEdit(selection) {
      var vm = this;
      vm.selection = selection;
      vm.$router.push({ name: 'SyncForm', params: { appid: vm.selection.id } });
    },
    selectLogs: function selectLogs(selection) {
      var vm = this;
      var wsUrl = vm.$parent.httpUrlToWebSockeUrl(vm.getSyncUrl() + '/ws');
      vm.$parent.socket = new WebSocket(wsUrl);
      vm.modalLogShow = true;
      vm.selection = selection;
      vm.feedbackLogsMessage = 'Opening websocket connection to ' + wsUrl;
      if (selection.status === 'Disabled') {
        vm.feedbackLogsMessage = 'Integration Disabled';
        vm.showLogsSpinner = false;
        vm.showLogsFeedback = true;
        vm.logsSuccess = true;
        vm.logs.push('Integration is disabled logs cannot be streamed');
        return;
      }
      vm.$parent.socket.onopen = function () {
        vm.$parent.socket.onmessage = function (response) {
          var json = JSON.parse(response.data);
          vm.logs.push(json.value);
          vm.feedbackLogsMessage = 'Streaming Logs...';
          vm.showLogsSpinner = true;
          vm.showLogsFeedback = true;
          vm.logsSuccess = true;
        };
        vm.$parent.socket.onclose = function (response) {
          vm.showLogsSpinner = false;
          vm.showLogsFeedback = true;
          vm.logsSuccess = false;
          if (response.code === 1006) {
            vm.feedbackLogsMessage = vm.feedbackLogsMessage + ' ' + 'The connection was closed abnormally, e.g., without sending or receiving a Close control frame (RFC 6455 - The WebSocket Protocol)';
          }
        };
        var websocketRequest = {};
        websocketRequest['appId'] = selection.id;
        websocketRequest['type'] = 'LOG_SESSION';
        websocketRequest['config'] = null;
        vm.$parent.socket.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(websocketRequest));
      };
    },
    modalInfoClose: function modalInfoClose() {
      var vm = this;
      vm.modalInfoShow = false;
      vm.getList();
    },
    modalObjectSyncClose: function modalObjectSyncClose() {
      var vm = this;
      vm.sync_rows = [];
      vm.modalObjectSyncShow = false;
      vm.showSyncFeedback = false;
      vm.showSyncSpinner = false;
      vm.getList();
    },
    modalLogClose: function modalLogClose() {
      var vm = this;
      var doPush = vm.modalLogShow;
      vm.modalLogShow = false;
      vm.logs = [];
      vm.$parent.closeWs();
      vm.showLogsSpinner = false;
      if (doPush) {
        vm.$router.push({ name: 'Sync' });
      }
      vm.getList();
    },
    onCopy: function onCopy() {},
    resizeEditor: function resizeEditor() {
      var newHeight = window.innerHeight;
      var newWidth = 0;
      if (this.$refs.resultsRef) {
        newWidth = this.$refs.resultsRef.clientWidth;
      }
      this.textBlockWidth = Math.round(newWidth * 90 / 100);
      this.textBlockHeight = Math.round(newHeight * 60 / 100);
    },
    clickCreateNew: function clickCreateNew() {
      var vm = this;
      vm.$router.push({ name: 'SyncForm' });
    },
    clickGuide: function clickGuide() {
      var vm = this;
      vm.$router.push({ name: 'SyncGuide' });
    },
    clickDashboards: function clickDashboards() {
      var vm = this;
      vm.$router.push({ name: 'SyncDashboard' });
    },
    clickDelete: function clickDelete(selection) {
      var vm = this;
      vm.selection = selection;
      vm.modalDeleteShow = true;
      vm.heliumAppUuidForDelete = selection.id;
    },
    deleteWithWebsocket: function deleteWithWebsocket() {
      var vm = this;
      var wsUrl = vm.$parent.httpUrlToWebSockeUrl(vm.getSyncUrl() + 'ws');
      vm.$parent.loading = true;
      vm.$parent.socket = new WebSocket(wsUrl);
      vm.$parent.socket.onopen = function () {
        vm.$parent.socket.onmessage = function (response) {
          var json = JSON.parse(response.data);
          vm.feedbackMessage = json.value;
          vm.showFeedback = true;
        };
        vm.$parent.socket.onclose = function (response) {
          vm.getList();
          vm.$parent.loading = false;
        };
        var websocketRequest = {};
        websocketRequest['appId'] = vm.heliumAppUuidForDelete;
        websocketRequest['type'] = 'DESTROY';
        websocketRequest['config'] = null;
        vm.$parent.socket.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(websocketRequest));
      };
    },
    modalDeleteAction: function modalDeleteAction() {
      var vm = this;
      vm.modalDeleteShow = false;
      vm.deleteWithWebsocket();
      vm.heliumDeleteConfirm = null;
    },
    modalDeleteClose: function modalDeleteClose() {
      var vm = this;
      vm.modalDeleteShow = false;
      vm.heliumDeleteConfirm = null;
    },
    toggleExpand: function toggleExpand() {
      var vm = this;
      vm.expand = vm.expand !== true;
    },
    clickRefresh: function clickRefresh() {
      var vm = this;
      vm.modalLogClose();
      vm.getList();
    },
    formatEpoch: function formatEpoch(value) {
      var epoch = parseInt(value);
      var valueConverted = new Date(epoch);
      return valueConverted.toLocaleString();
    }
  },
  created: function created() {
    var vm = this;
    vm.getList();
    vm.resizeEditor();
    window.addEventListener('resize', vm.resizeEditor);
    window.addEventListener('keydown', function (e) {
      if (e.keyCode === 27) {
        vm.modalLogClose();
        vm.modalInfoClose();
        vm.modalDeleteClose();
      }
    });
  },

  beforeDestroy: function beforeDestroy() {
    var vm = this;
    window.removeEventListener('resize', vm.resizeEditor);
  },
  watch: {
    'enabledRadio': function enabledRadio(newValue) {
      var vm = this;
      if (vm.syncConfig !== null) {
        if (newValue === 'Enabled') {
          vm.syncConfig.enabled = true;
        } else {
          vm.syncConfig.enabled = false;
        }
      }
    },
    'heliumAppUuidForDelete': function heliumAppUuidForDelete(newValue) {
      var vm = this;
      var tmp = null;
      vm.$parent.apps.forEach(function (key) {
        if (key.id === newValue) {
          tmp = key.name;
        }
      });
      vm.heliumAppNameForDelete = tmp;
    },
    'heliumDeleteConfirm': function heliumDeleteConfirm(newValue) {
      var vm = this;
      if (newValue === 'DELETE') {
        vm.deleteDisabled = false;
      } else {
        vm.deleteDisabled = true;
      }
    }
  },
  computed: {
    numLogs: function numLogs() {
      return this.logs.length;
    },
    textBlock: function textBlock() {
      return this.logs.join('\n') + '\n';
    }
  }
});

/***/ }),

/***/ 247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay_dist_vue_loading_min_css__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay_dist_vue_loading_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay_dist_vue_loading_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DatetimeStringFactory_js__ = __webpack_require__(227);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay___default.a,
    modal: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["modal"]
  },
  data: function data() {
    return {
      syncDashboardUrl: this.$parent.baseUrl + '/portal-backend/api/sync-dashboard/',
      rows: [],
      rows2: [],
      rows3: [],
      loading: false,
      modalShow: false,
      modalDeleteShow: false,
      modalBackdrop: false,
      modalTitle: '',
      modalDeleteConfirmInput: '',
      deleteDisabled: true,
      dashboardToBeDeleted: null,
      modalMergeShow: false,
      modalDashboardNameInput: '',
      modalDashboardAppIds: [],
      timer: ''
    };
  },

  methods: {
    getSyncDashboards: function getSyncDashboards() {
      var vm = this;
      vm.loading = true;
      vm.axios.get(vm.syncDashboardUrl + 'null').then(function (response) {
        vm.rows = response.data;
        vm.loading = false;
      }).catch(function (error) {
        console.log(error);
        vm.loading = false;
        var obj = {
          title: 'Problem looking up dashboards',
          message: error.response,
          type: 'error'
        };
        vm.$Simplert.open(obj);
      });
    },
    getSyncDashboardResults: function getSyncDashboardResults(name) {
      var vm = this;
      var endpoint = vm.syncDashboardUrl + name;
      vm.loading = true;
      vm.axios.get(endpoint).then(function (response) {
        if (!vm.$route.params.name) {
          vm.modalShow = true;
        }
        vm.rows2 = response.data;
        var selectAll = {};
        vm.rows2.forEach(function () {
          if (name === 'all-apps') {
            selectAll['selected'] = false;
          } else {
            selectAll['selected'] = true;
          }
          selectAll['selectedRows'] = vm.rows2;
        });
        vm.onSelectAll(selectAll);
        vm.loading = false;
      }).catch(function (error) {
        console.log(error);
        vm.loading = false;
        var obj = {
          title: 'Problem looking up results for dashboard',
          message: error.response.data.message,
          type: 'error'
        };
        vm.$Simplert.open(obj);
      });
    },
    postSyncDashboard: function postSyncDashboard() {
      var vm = this;
      var endpoint = vm.syncDashboardUrl;
      var payload = {};
      payload['name'] = vm.modalDashboardNameInput;
      payload['appIds'] = vm.modalDashboardAppIds;
      vm.loading = true;
      vm.axios.post(endpoint, payload).then(function (response) {
        vm.loading = false;
        vm.getSyncDashboards();
        vm.closeModalBtnClick();
        var obj = {
          title: 'Dashboard saved',
          message: response.data,
          type: 'success'
        };
        vm.$Simplert.open(obj);
      }).catch(function (error) {
        console.log(error);
        vm.loading = false;
        var obj = {
          title: 'Unable to save dashboard',
          message: error,
          type: 'error'
        };
        vm.$Simplert.open(obj);
      });
    },
    clickCreateNew: function clickCreateNew() {
      this.modalTitle = 'Create new dashboard';
      this.getSyncDashboardResults('all-apps');
    },
    saveModalBtnClick: function saveModalBtnClick() {
      this.postSyncDashboard();
    },
    viewBtnClick: function viewBtnClick(row) {
      this.getSyncDashboardResults(row.name);
      this.$router.push({ name: 'SyncDashboard', params: { name: row.name } });
    },
    updateBtnClick: function updateBtnClick(row) {
      this.modalTitle = 'Dashboard: ' + row.name;
      this.modalDashboardNameInput = row.name;
      this.getSyncDashboardResults(row.name);
    },
    deleteBtnClick: function deleteBtnClick(row) {
      this.modalTitle = 'Confirm delete on dashboard: ' + row.name;
      this.modalDeleteShow = true;
      this.dashboardToBeDeleted = row.name;
      this.modalDashboardNameInput = '';
    },
    closeModalBtnClick: function closeModalBtnClick() {
      this.modalShow = false;
      this.modalDeleteShow = false;
      this.modalMergeShow = false;
      this.modalDashboardNameInput = '';
      this.modalDashboardAppIds = [];
      this.modalDeleteConfirmInput = '';
    },
    confirmDeleteModalBtnClick: function confirmDeleteModalBtnClick() {
      var vm = this;
      var endpoint = vm.$parent.baseUrl + '/portal-backend/api/sync-dashboard/' + vm.dashboardToBeDeleted;
      vm.loading = true;
      vm.axios.delete(endpoint).then(function (response) {
        vm.loading = false;
        vm.getSyncDashboards();
        vm.closeModalBtnClick();
        var obj = {
          title: 'Dashboard deleted',
          message: response.data,
          type: 'success'
        };
        vm.$Simplert.open(obj);
      }).catch(function (error) {
        console.log(error);
        vm.loading = false;
        vm.closeModalBtnClick();

        var obj = {
          title: 'Unable to delete dashboard',
          message: error,
          type: 'error'
        };
        vm.$Simplert.open(obj);
      });
    },
    onRowClick: function onRowClick(params) {
      var index = this.modalDashboardAppIds.indexOf(params.row.id);
      var exists = index !== -1;
      if (params.selected) {
        if (!exists) {
          this.modalDashboardAppIds.push(params.row.id);
        }
      } else {
        if (exists) {
          this.modalDashboardAppIds.splice(index, 1);
        }
      }
    },
    onSelectAll: function onSelectAll(params) {
      var vm = this;
      vm.modalDashboardAppIds = [];
      params.selectedRows.forEach(function (key) {
        if (params.selected) {
          vm.modalDashboardAppIds.push(key.id);
          key.vgtSelected = true;
        }
      });
    },
    repickAppsModalBtnClick: function repickAppsModalBtnClick() {
      var vm = this;
      this.modalDashboardAppIds = [];
      vm.getSyncDashboardResults('all-apps');
    },
    formatMillis: function formatMillis(value) {
      return __WEBPACK_IMPORTED_MODULE_3__components_DatetimeStringFactory_js__["a" /* default */].formatMillis(value);
    }
  },
  created: function created() {
    var vm = this;
    vm.getSyncDashboards();
    if (vm.$route.params.name) {
      vm.getSyncDashboardResults(vm.$route.params.name);
      vm.timer = setInterval(function () {
        console.log('Update data timer ' + new Date());
        vm.getSyncDashboardResults(vm.$route.params.name);
      }, 300000);
    }
    window.addEventListener('keydown', function (e) {
      if (e.keyCode === 27) {
        vm.closeModalBtnClick();
      }
    });
  },

  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
  },
  watch: {
    'modalDeleteConfirmInput': function modalDeleteConfirmInput(newValue) {
      if (newValue === 'DELETE') {
        this.deleteDisabled = false;
      } else {
        this.deleteDisabled = true;
      }
    },
    modalDashboardAppIds: function modalDashboardAppIds(newValue) {}
  },
  computed: {
    columns: function columns() {
      return [{
        label: 'Dashboard Name',
        field: 'name'
      }, { label: 'Actions',
        field: 'actions'
      }];
    },
    columns2: function columns2() {
      return [{
        label: 'Name',
        field: 'appName',
        filterable: true
      }, {
        label: 'App ID',
        field: 'id',
        filterable: true
      }];
    },
    columns3: function columns3() {
      return [{
        label: 'Status',
        field: 'status'
      }, {
        label: 'Name',
        field: 'appName',
        filterable: true
      }, {
        label: 'Helium Base Url',
        field: 'heliumBaseUrl',
        filterable: true
      }, {
        label: 'Journey Base Url',
        field: 'journeyBaseUrl',
        filterable: true
      }, {
        label: 'Helium Last Updated',
        field: 'heliumLastUpdated',
        filterable: true
      }, {
        label: 'Journey Last Updated',
        field: 'journeyLastUpdated',
        filterable: true
      }, {
        label: 'Last Pinged',
        field: 'lastPinged',
        filterable: true
      }];
    },
    modalIsEditMode: function modalIsEditMode() {
      return this.modalTitle !== 'Create new dashboard';
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ 248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Feedback_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Feedback_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Feedback_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TextEditor_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TextEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_TextEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_search_select__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_search_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay_dist_vue_loading_min_css__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay_dist_vue_loading_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay_dist_vue_loading_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_search_select_dist_VueSearchSelect_css__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_search_select_dist_VueSearchSelect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_search_select_dist_VueSearchSelect_css__);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Feedback: __WEBPACK_IMPORTED_MODULE_1__components_Feedback_vue___default.a,
    alert: __WEBPACK_IMPORTED_MODULE_2_vue_strap__["alert"],
    TextEditor: __WEBPACK_IMPORTED_MODULE_3__components_TextEditor_vue___default.a,
    ModelSelect: __WEBPACK_IMPORTED_MODULE_4_vue_search_select__["ModelSelect"],
    Loading: __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      username: 'a',
      password: 'a',
      list: [],
      loading: false,
      success: false,
      feedbackMessage: null,
      showFeedback: null,
      syncConfig: null,
      expand: false,
      enabledRadio: null,
      enableHeliumToJourneyRadio: null,
      enableJourneyToHeliumRadio: null,
      showSpinner: false,
      enabledEnrollmentRadio: null,
      enrollmentModeRadio: null,
      enrollmentMode: 'user',
      journeyToHeliumEnrollmentTmp: null,
      changeLogSkipTablesTmp: null,
      oplogSkipObjectTypes: null,
      dataSources: [],
      dataSource: null,
      dataSourceApps: [],
      dataSourceApp: null,
      showHeliumBookmarkIdHelp: false,
      showJourneyVersionHelp: false,
      showHeliumSkipHelp: false,
      textEditorWidthHelium: 0,
      textEditorWidthJourney: 0,
      textEditorHeightHelium: 0,
      textEditorHeightJourney: 0,
      textEditorReadOnly: true,
      textEditorScrollToLine: 0,
      textEditorLangHelium: 'sql',
      textEditorLangJourney: 'powershell',
      alertDuration: 5000,
      alertMessage: null,
      showJourneySkipHelp: null,
      readonlyVersions: false,
      feedbackLogsMessage: null,
      showLogsSpinner: true,
      logsSuccess: false,
      textBlockWidth: 500,
      textBlockHeight: 600,
      textBlockReadOnly: true,
      textBlockLang: 'sql',
      dataSourceOptions: [],
      selectedDataSourceOption: {
        value: '',
        text: ''
      }
    };
  },

  methods: {
    pingDatabase: function pingDatabase(dataSourceParam) {
      var vm = this;
      var endpoint = vm.$parent.baseUrl + '/portal-backend/api/schema-access/ping-database';
      var config = {};
      config['environment'] = vm.$parent.environment.name;
      config['dataSource'] = dataSourceParam;
      vm.axios.post(endpoint, config).then(function (response) {
        var element = {};
        element['heliumDataSourceName'] = dataSourceParam.heliumDataSourceName;
        element['response'] = response.data.response;
        element['dataSource'] = dataSourceParam;
        vm.dataSources.push(element);
        var dataSourceOption = { value: dataSourceParam, text: element.heliumDataSourceName };
        vm.dataSourceOptions.push(dataSourceOption);
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    getDatabaseHostApps: function getDatabaseHostApps() {
      var vm = this;
      var endpoint = vm.$parent.baseUrl + '/portal-backend/api/schema-access/app-schemas';
      var config = {};
      config['environment'] = vm.$parent.environment.name;
      config['dataSource'] = vm.dataSource;
      vm.loading = true;
      vm.feedbackMessage = null;
      vm.showFeedback = false;
      vm.axios.post(endpoint, config).then(function (response) {
        console.log(response.data);
        var existingIds = vm.$parent.syncApps.map(function (key) {
          return key.id;
        });
        response.data.filter(function (key) {
          return existingIds.indexOf(key.id) <= -1;
        }).forEach(function (element) {
          var text = element.name + ' (' + element.id + ')';
          vm.dataSourceApps.push({ value: element.id, text: text });
        });
        vm.loading = false;
        vm.success = true;
        if (vm.dataSourceApps.length <= 0) {
          vm.feedbackMessage = 'No apps found on ' + endpoint;
          vm.showFeedback = true;
        }
      }).catch(function (error) {
        vm.loading = false;
        vm.success = false;
        vm.showFeedback = true;
        vm.feedbackMessage = error;
      });
    },
    getSyncUrl: function getSyncUrl() {
      var vm = this;
      var endpoint = vm.$parent.baseUrl + '/sync';
      if (vm.$parent.environment.name === 'Zambia-production') {
        endpoint += '-zm';
      } else if (vm.$parent.environment.name !== 'Production') {
        endpoint += '-stb';
      }
      endpoint += '/api/';
      return endpoint;
    },
    getAxiosConfig: function getAxiosConfig() {
      var vm = this;
      var syncEnv = vm.$parent.environment.name;
      return {
        auth: {
          username: vm.$parent.username,
          password: vm.$parent.password
        },
        headers: {
          "X-Helium-Environment": syncEnv
        }
      };
    },
    toggleExpand: function toggleExpand() {
      var vm = this;
      vm.expand = vm.expand !== true;
    },
    mergeDone: function mergeDone(data) {
      var vm = this;
      console.log(data);
      vm.loading = false;
      if (vm.syncConfig.enabled) {
        vm.$router.push({ name: 'Sync', params: { appid: vm.syncConfig.helium.appId } });
      } else {
        vm.backBtn();
      }
    },
    mergeWithWebSocket: function mergeWithWebSocket() {
      var vm = this;
      var wsUrl = vm.$parent.httpUrlToWebSockeUrl(vm.getSyncUrl() + 'ws');
      vm.$parent.socket = new WebSocket(wsUrl);
      vm.$parent.socket.onopen = function () {
        vm.$parent.socket.onmessage = function (response) {
          console.log(response.data);
          vm.$parent.socket.close();
          vm.mergeDone(response.data);
        };
        vm.$parent.socket.onclose = function (response) {};
        var websocketRequest = {};
        websocketRequest['appId'] = vm.syncConfig.helium.appId;
        websocketRequest['type'] = 'MERGE';
        websocketRequest['config'] = vm.syncConfig;
        vm.$parent.socket.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(websocketRequest));
      };
    },
    saveBtn: function saveBtn() {
      var vm = this;
      vm.loading = true;
      vm.syncConfig.journey.appId = vm.syncConfig.journey.restAPICredentials.userName;
      vm.syncConfig.heliumToJourney.changeLogMinVersion = vm.syncConfig.heliumToJourney.changeLogMinVersionAsString;
      vm.syncConfig.journeyToHelium.oplogMinVersion = vm.syncConfig.journeyToHelium.oplogMinVersionAsString;

      vm.syncConfig.heliumToJourney.changeLogSkipTables = vm.changeLogSkipTablesTmp ? vm.changeLogSkipTablesTmp.split(',') : null;
      vm.syncConfig.journeyToHelium.oplogSkipObjectTypes = vm.oplogSkipObjectTypesTmp ? vm.oplogSkipObjectTypesTmp.split(',') : null;
      vm.mergeWithWebSocket();
    },
    backBtn: function backBtn() {
      var vm = this;
      vm.$router.go(-1);
    },
    setRadios: function setRadios() {
      var vm = this;
      if (vm.syncConfig.enabled) {
        vm.enabledRadio = 'Enabled';
      } else {
        vm.enabledRadio = 'Disabled';
      }
      if (vm.syncConfig.enableJourneyToHelium) {
        vm.enableHeliumToJourneyRadio = 'Enabled';
      } else {
        vm.enableHeliumToJourneyRadio = 'Disabled';
      }
      if (vm.syncConfig.enableHeliumToJourney) {
        vm.enableJourneyToHeliumRadio = 'Enabled';
      } else {
        vm.enableJourneyToHeliumRadio = 'Disabled';
      }
    },
    setSyncConfigTemplate: function setSyncConfigTemplate() {
      var vm = this;
      var endpoint = vm.getSyncUrl() + 'get-template';
      var config = {};
      config['environment'] = vm.$parent.environment.name;
      config['uuid'] = vm.dataSourceApp;
      config['dataSource'] = vm.dataSource;
      config['journeyUserMode'] = vm.enrollmentMode;
      var syncExists = vm.$parent.syncApps.some(function (key) {
        return key.id === vm.dataSourceApp;
      });
      if (syncExists) {
        vm.feedbackMessage = 'There is already an integration for ' + vm.dataSourceApp;
        vm.success = false;
        vm.showFeedback = true;
        return;
      }
      vm.loading = true;
      vm.axios.post(endpoint, config, {
        auth: {
          username: vm.$parent.username,
          password: vm.$parent.password
        }
      }).then(function (response) {
        vm.syncConfig = response.data;
        vm.journeyToHeliumEnrollmentTmp = vm.syncConfig.journeyToHeliumEnrollment;
        vm.changeLogSkipTablesTmp = null;
        vm.oplogSkipObjectTypesTmp = null;
        vm.setRadios();
        vm.enabledEnrollmentRadio = 'Enabled';
        vm.setEnrollmentModeRadio();
        vm.loading = false;
        vm.success = true;
      }).catch(function (error) {
        vm.feedbackMessage = 'Unable to fetch template: ' + error.response.data;
        vm.success = false;
        vm.showFeedback = true;
        vm.loading = false;
      });
    },
    setSyncConfig: function setSyncConfig(appId) {
      var vm = this;
      var endpoint = vm.getSyncUrl() + 'get/' + appId;
      var config = vm.getAxiosConfig();
      vm.loading = true;
      vm.axios.get(endpoint, config).then(function (response) {
        vm.syncConfig = response.data;
        vm.setRadios();
        vm.journeyToHeliumEnrollmentTmp = vm.syncConfig.journeyToHeliumEnrollment;
        vm.changeLogSkipTablesTmp = vm.syncConfig.heliumToJourney.changeLogSkipTables.join(',');
        vm.oplogSkipObjectTypesTmp = vm.syncConfig.journeyToHelium.oplogSkipObjectTypes.join(',');
        if (vm.syncConfig.journeyToHeliumEnrollment) {
          vm.enabledEnrollmentRadio = 'Enabled';
          vm.enrollmentMode = vm.syncConfig.journeyToHeliumEnrollment.type;
          vm.setEnrollmentModeRadio();
        } else {
          vm.enabledEnrollmentRadio = 'Disabled';
          vm.setEnrollmentModeRadio();
        }
        vm.loading = false;
        vm.success = true;
      }).catch(function (error) {
        vm.feedbackMessage = error.response && error.response.status === 502 ? 'Bad Gateway - Invalid response from the upstream server' : error.response.data;
        vm.success = false;
        vm.loading = false;
      });
    },
    setEnrollmentTemplate: function setEnrollmentTemplate() {
      var vm = this;
      var endpoint = vm.getSyncUrl() + 'get-template-enrollment';
      var config = {};
      config['environment'] = vm.$parent.environment.name;
      config['uuid'] = vm.dataSourceApp;
      config['journeyUserMode'] = vm.enrollmentMode;
      vm.loading = true;
      vm.axios.post(endpoint, config, {
        auth: {
          username: vm.$parent.username,
          password: vm.$parent.password
        }
      }).then(function (response) {
        vm.syncConfig.journeyToHeliumEnrollment = response.data;
        vm.loading = false;
        vm.success = true;
      }).catch(function (error) {
        vm.success = false;
        vm.feedbackMessage = 'Unable to fetch enrollment template ' + error.response.data;
        vm.showFeedback = true;
        vm.loading = false;
      });
    },
    btnHeliumBookmarkIdHelp: function btnHeliumBookmarkIdHelp() {
      var vm = this;
      if (vm.showHeliumBookmarkIdHelp) {
        vm.showHeliumBookmarkIdHelp = false;
      } else {
        vm.showHeliumBookmarkIdHelp = true;
      }
    },
    btnJourneyVersionHelp: function btnJourneyVersionHelp() {
      var vm = this;
      if (vm.showJourneyVersionHelp) {
        vm.showJourneyVersionHelp = false;
      } else {
        vm.showJourneyVersionHelp = true;
      }
    },
    btnHeliumSkipHelp: function btnHeliumSkipHelp() {
      var vm = this;
      if (vm.showHeliumSkipHelp) {
        vm.showHeliumSkipHelp = false;
      } else {
        vm.showHeliumSkipHelp = true;
      }
    },
    btnJourneySkipHelp: function btnJourneySkipHelp() {
      var vm = this;
      if (vm.showJourneySkipHelp) {
        vm.showJourneySkipHelp = false;
      } else {
        vm.showJourneySkipHelp = true;
      }
    },
    setEnrollmentModeRadio: function setEnrollmentModeRadio() {
      var vm = this;
      if (vm.syncConfig && vm.syncConfig.journeyToHeliumEnrollment) {
        if (vm.syncConfig.journeyToHeliumEnrollment.type === 'user') {
          vm.enrollmentModeRadio = 'Single device per user';
        } else {
          vm.enrollmentModeRadio = 'Multiple devices per user';
        }
      } else {
        vm.enrollmentModeRadio = 'Single device per user';
      }
    },
    getHeliumBookmarkInfoTextEditorHeight: function getHeliumBookmarkInfoTextEditorHeight() {
      return Math.round(window.innerHeight * 60 / 100);
    },
    resizeEditor: function resizeEditor() {
      var vm = this;
      var widthValue = Math.round(window.innerWidth * 42 / 100);
      vm.textEditorWidthHelium = widthValue;
      vm.textEditorWidthJourney = widthValue;
      vm.textEditorHeightHelium = vm.getHeliumBookmarkInfoTextEditorHeight();
      vm.textEditorHeightJourney = 35;
      vm.textEditorHeightWsLogs = 200;
    },
    onCopyCallBack: function onCopyCallBack() {
      var vm = this;
      vm.$Simplert.open({ title: 'Copied', message: 'Paste me into postgres!', type: 'success' });
    },
    onCopyResetJourneyVersion: function onCopyResetJourneyVersion() {
      var vm = this;
      vm.$Simplert.open({ title: 'Copied', message: 'Paste me into terminal!', type: 'success' });
    },
    findApp: function findApp() {
      var vm = this;
      return vm.$parent.syncApps.find(function (key) {
        return key.id === vm.syncConfig.helium.appId;
      });
    }
  },
  created: function created() {
    var vm = this;
    vm.$parent.environment.dataSources.forEach(vm.pingDatabase);
    vm.resizeEditor();
    if (vm.$route.params.appid) {
      vm.setSyncConfig(vm.$route.params.appid);
      vm.readonlyVersions = true;
    }
  },

  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resizeEditor);
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.resizeEditor);
  },
  watch: {
    'selectedDataSourceOption': function selectedDataSourceOption(newValue) {
      this.dataSource = newValue.value;
      this.getDatabaseHostApps();
    },
    'dataSourceApp': function dataSourceApp(newValue) {
      this.setSyncConfigTemplate();
    },
    'enabledRadio': function enabledRadio(newValue) {
      this.syncConfig.enabled = this.syncConfig !== null && newValue === 'Enabled';
    },
    'enableHeliumToJourneyRadio': function enableHeliumToJourneyRadio(newValue) {
      var vm = this;
      vm.syncConfig.enableJourneyToHelium = vm.syncConfig !== null && newValue === 'Enabled';
    },
    'enableJourneyToHeliumRadio': function enableJourneyToHeliumRadio(newValue) {
      var vm = this;
      vm.syncConfig.enableHeliumToJourney = vm.syncConfig !== null && newValue === 'Enabled';
    },
    'enabledEnrollmentRadio': function enabledEnrollmentRadio(newValue) {
      var vm = this;
      if (newValue !== 'Enabled') {
        vm.journeyToHeliumEnrollmentTmp = vm.syncConfig.journeyToHeliumEnrollment;
        vm.syncConfig.journeyToHeliumEnrollment = null;
      } else {
        if (vm.journeyToHeliumEnrollmentTmp) {
          vm.syncConfig.journeyToHeliumEnrollment = vm.journeyToHeliumEnrollmentTmp;
        } else {
          vm.setEnrollmentTemplate();
        }
      }
    },
    'enrollmentModeRadio': function enrollmentModeRadio(newValue) {
      var vm = this;
      if (newValue === 'Single device per user') {
        vm.enrollmentMode = 'user';
      } else {
        vm.enrollmentMode = 'session';
      }
      if (vm.syncConfig.journeyToHeliumEnrollment != null && vm.syncConfig.journeyToHeliumEnrollment.type !== vm.enrollmentMode) {
        vm.setEnrollmentTemplate();
      }
    }
  },
  computed: {
    updateIntervalValues: function updateIntervalValues() {
      var values = [];
      for (var i = 5; i <= 60; i = i + 5) {
        values.push(i);
      }
      return values;
    },
    buildNewHeliumVersionSql: function buildNewHeliumVersionSql() {
      var vm = this;
      if (!vm.syncConfig.helium.dbSchema) {
        return 'Unable to build SQL: No schema name!';
      }
      return 'set search_path TO ' + vm.syncConfig.helium.dbSchema + ';\n\n' + '--Creating new Helium Bookmark:\n' + '--Changes from previous bookmarks will be skipped\n' + 'insert into __he_sync_bookmark__(tx_id, tx_tstamp, entity, client_id)\n' + 'with src as (\n' + '\tselect\n' + '\t\ttxid_current() "tx_id",\n' + '\t\tmax(tx_id) "last_export_version_id",\n' + '\t\t(extract(\'epoch\' from now()) * 1000)::bigint "tstamp"\n' + '\tfrom __he_sync_obj_change__\n' + ') select\n' + '\ttx_id,\n' + '\tnow(),\n' + '\tjsonb_build_object(\n' + '\t\t\'id\', tx_id,\n' + '\t\t\'millis\',tstamp,\n' + '\t\t\'clientId\',\'d4ec6977-28ab-4caf-8872-edd39b471436\',\n' + '\t\t\'skippedVersionIds\',\'[]\'::jsonb,\n' + '\t\t\'lastExportVersionId\',last_export_version_id\n' + '\t),\n' + '\t\'d4ec6977-28ab-4caf-8872-edd39b471436\'::uuid\n' + 'from src;\n\n' + '--Lookup last bookmark:\n' + 'select tx_id from __he_sync_bookmark__ order by tx_tstamp desc limit 1;';
    },
    buildSkipHeliumViewsSql: function buildSkipHeliumViewsSql() {
      return 'WITH q AS (\n' + '\tSELECT v.viewname,\n' + '\tm.matviewname\n' + '\tFROM pg_views AS v\n' + '\tLEFT JOIN pg_matviews AS m ON v.schemaname = m.schemaname\n' + '\tWHERE v.schemaname NOT IN (\'pg_catalog\', \'information_schema\')\n' + '\tAND v.schemaname = \'' + this.syncConfig.helium.dbSchema + '\' ORDER BY v.viewname)\n' + 'SELECT CONCAT(array_to_string(array_agg(distinct "viewname"),\',\'), \',\', array_to_string(array_agg(distinct "matviewname"),\',\')) FROM q;';
    },
    buildNewJourneyVersionSql: function buildNewJourneyVersionSql() {
      return 'python -c "import time;print int(time.time())<<32;"';
    },
    heliumSyncStatus: function heliumSyncStatus() {
      var vm = this;
      if (!vm.$parent.syncApps) {
        return null;
      }
      var result = vm.findApp();
      return result ? result.heliumSyncStatus : null;
    },
    heliumLastUpdatedMillis: function heliumLastUpdatedMillis() {
      var vm = this;
      if (!vm.$parent.syncApps) {
        return null;
      }
      var result = vm.findApp();
      return result ? result.heliumLastUpdated : null;
    },
    journeySyncStatus: function journeySyncStatus() {
      var vm = this;
      if (!vm.$parent.syncApps) {
        return null;
      }
      var result = vm.findApp();
      return result ? result.journeySyncStatus : null;
    },
    journeyLastUpdatedMillis: function journeyLastUpdatedMillis() {
      var vm = this;
      if (!vm.$parent.syncApps) {
        return null;
      }
      var result = vm.findApp();
      return result ? result.journeyLastUpdated : null;
    }
  }
});

/***/ }),

/***/ 249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TextEditor_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TextEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_TextEditor_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    TextEditor: __WEBPACK_IMPORTED_MODULE_0__components_TextEditor_vue___default.a
  },
  data: function data() {
    return {
      textEditorWidthUser: 0,
      textEditorHeightUser: 0,
      textEditorReadOnly: true,
      textEditorScrollToLine: 0,
      textEditorJava: 'java',
      textEditorXml: 'xml',
      userHeliumContent: '/* Helium persistant object primary user declaration example */\n' + 'persistent object MobileUser {\n\n' + '\t@defaultValidator("error.required_field")\n' + '\tstring firstnames;\n\n' + '\t// .. other attributes\n\n' + '\t// Journey Enrollment\n' + '\tstring enrollment_allowed_access;\n' + '\tstring enrollment_enrolled;\n' + '\tstring enrollment_journey_launcher_version;\n' + '\tstring enrollment_device_os;\n' + '\tstring enrollment_device_model;\n' + '\tstring enrollment_last_connected;\n' + '\tstring enrollment_barcode;\n' + '\tstring enrollment_url;\n' + '\tstring enrollment_perform_re_enrollment;\n' + '\tdatetime enrollment_re_enrollment_last_processed;\n' + '\tbool enrollment_generate_enrollment_code;\n' + '\tstring enrollment_code;\n\n' + '\t// ... relationships\n\n' + '}',
      userJourneyContent: '<!-- Journey V4 model primary user declaration example -->\n' + '<model name="mobileuser" label="Mobile User">\n' + '\t<field name="firstnames" label="Firstnames" type="text"/>\n\n' + '\t<!-- ... other attributes -->\n\n' + '\t<field name="enrollment_allowed_access" label="Enrollment allowed access" type="text"/>\n' + '\t<field name="enrollment_enrolled" label="Enrollment enrolled" type="text"/>\n' + '\t<field name="enrollment_journey_launcher_version" label="Enrollment Journey launcher version" type="text"/>\n' + '\t<field name="enrollment_device_os" label="Enrollment device OS" type="text"/>\n' + '\t<field name="enrollment_device_model" label="Enrollment device model" type="text"/>\n' + '\t<field name="enrollment_last_connected" label="Enrollment last connected" type="text"/>\n' + '\t<field name="enrollment_barcode" label="Enrollment barcode" type="text"/>\n' + '\t<field name="enrollment_url" label="Enrollment URL" type="text"/>\n' + '\t<field name="enrollment_perform_re_enrollment" label="Enrollment perform re-enrollment" type="boolean"/>\n' + '\t<field name="enrollment_re_enrollment_last_processed" label="Enrollment re-enrollment last processed" type="text"/>\n' + '\t<field name="enrollment_generate_enrollment_code" label="Enrollment Generate Enrollment Code" type="boolean"/>' + '\t<field name="enrollment_code" label="Enrollment Code" type="text"/>' + '\t<!-- ... relationships -->\n\n' + '\t<display>{firstnames}</display>\n' + '</model>',
      userHeliumV2Content: '/* Helium persistant object primary user declaration example */\n' + 'persistent object mobileuser {\n\n' + '\t@defaultValidator("error.required_field")\n' + '\tstring firstnames;\n\n' + '\t// .. other attributes\n\n' + '\t// Journey Enrollment\n' + '\tdatetime last_connected_at;\n' + '\tbool enrolled;\n' + '\tbool locked;\n\n' + '\tbool enrollment_generate_enrollment_code; // set this as true to generate enrollmentCode\n' + '\tstring enrollment_code;\n\n' + '\t// ... relationships\n\n' + '}\n\n' + '/* Helium persistant object user session declaration example */\n' + 'persistent object mobileusersession {\n\n' + '\tstring state;\n' + '\tdatetime last_authenticated_at;\n' + '\tdatetime created_at;\n' + '\tdatetime signed_out_at;\n' + '\tdatetime last_connected_at;\n' + '\tbool perform_re_authenticate; // set this as true to force this user to reauthenticate\n' + '\tdatetime re_authenticate_last_processed;\n' + '\tstring label;\n\n' + '\t@ManyToOne\n' + '\tmobileuser mobileusersession_mobileuser via mobileuser_mobileusersession;\n\n' + '}\n\n' + '/* Helium persistant object user session container declaration example */\n' + '@NotTracked\n' + 'persistent object mobileusersessioncontainer {\n' + '\tstring version;\n' + '\tstring bundle_id;\n' + '\tstring platform;\n\n' + '\t@ManyToOne\n' + '\tmobileusersession mobileusersessioncontainer_mobileusersession via mobileusersession_mobileusersessioncontainer;\n' + '}\n',
      userJourneyV2Content: '<!-- Journey V4 model primary user declaration example -->\n' + '<model name="mobileuser" label="Mobile User">\n' + '\t<field name="firstnames" label="Firstnames" type="text"/>\n\n' + '\t<!-- ... other attributes -->\n\n' + '\t<field name="last_connected_at" label="Last Connected At" type="datetime"/>\n' + '\t<field name="enrolled" label="Enrolled" type="boolean"/>\n' + '\t<field name="locked" label="Locked" type="boolean"/>\n' + '\t<field name="generate_enrollment_code" label="Generate Enrollment Code" type="boolean"/>\n' + '\t<field name="enrollment_code" label="Generate Code" type="text"/>\n' + '\t<!-- ... relationships -->\n\n' + '\t<display>{firstnames}</display>\n' + '</model>',
      fkHeliumContent: '/* Helium persistant object example of parent in relationship */\n' + 'persistent object parent {\n' + '\tstring key;\n' + '\tdatetime dateRegistered;\n\n' + '\t@OneToMany\n' + '\tchild parent_child via child_parent;\n' + '}\n\n' + '/* Helium persistant object example of child in relationship */\n' + 'persistent object child {\n\n' + '\tstring key;\n' + '\tdatetime dateRegistered;\n\n' + '\t@ManyToOne\n' + '\tparent child_parent via parent_child;\n\n' + '}',
      fkJourneyContent: '<!-- Journey V4 model example of parent in relationship -->\n' + '<model name="parent" label="Parent">\n' + '\t<field name="key" label="Key" type="text"/>\n' + '\t<field name="dateRegistered" label="Date Registered" type="datetime"/>\n\n' + '\t<has-many name="children" inverse-of="child_parent" model="child"/>\n' + '\t<display>{key}</display>\n' + '</model>\n\n' + '<!-- Journey V4 model example of child in relationship -->\n' + '<model name="child" label="Child">\n' + '\t<field name="key" label="Key" type="text"/>\n' + '\t<field name="dateRegistered" label="Date Registered" type="datetime"/>\n' + '\t<belongs-to name="child_parent" model="parent"/>\n' + '\t<display>{key} {child_parent}</display>\n' + '</model>'
    };
  },

  methods: {
    resizeEditor: function resizeEditor() {
      var vm = this;
      var widthValue = Math.round(window.innerWidth * 47 / 100);
      vm.textEditorWidthUser = widthValue;
      vm.textEditorHeightUser = 500;
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resizeEditor);
  },
  mounted: function mounted() {
    this.resizeEditor();
    window.addEventListener('resize', this.resizeEditor);
  }
});

/***/ }),

/***/ 310:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 311:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 312:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 313:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 314:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 315:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 316:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 317:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 318:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 319:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 320:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 321:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 322:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 323:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 324:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 325:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 326:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 327:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 328:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 329:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 330:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 331:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 332:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 333:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 334:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 538:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 63,
	"./af.js": 63,
	"./ar": 71,
	"./ar-dz": 64,
	"./ar-dz.js": 64,
	"./ar-kw": 65,
	"./ar-kw.js": 65,
	"./ar-ly": 66,
	"./ar-ly.js": 66,
	"./ar-ma": 67,
	"./ar-ma.js": 67,
	"./ar-ps": 68,
	"./ar-ps.js": 68,
	"./ar-sa": 69,
	"./ar-sa.js": 69,
	"./ar-tn": 70,
	"./ar-tn.js": 70,
	"./ar.js": 71,
	"./az": 72,
	"./az.js": 72,
	"./be": 73,
	"./be.js": 73,
	"./bg": 74,
	"./bg.js": 74,
	"./bm": 75,
	"./bm.js": 75,
	"./bn": 77,
	"./bn-bd": 76,
	"./bn-bd.js": 76,
	"./bn.js": 77,
	"./bo": 78,
	"./bo.js": 78,
	"./br": 79,
	"./br.js": 79,
	"./bs": 80,
	"./bs.js": 80,
	"./ca": 81,
	"./ca.js": 81,
	"./cs": 82,
	"./cs.js": 82,
	"./cv": 83,
	"./cv.js": 83,
	"./cy": 84,
	"./cy.js": 84,
	"./da": 85,
	"./da.js": 85,
	"./de": 88,
	"./de-at": 86,
	"./de-at.js": 86,
	"./de-ch": 87,
	"./de-ch.js": 87,
	"./de.js": 88,
	"./dv": 89,
	"./dv.js": 89,
	"./el": 90,
	"./el.js": 90,
	"./en-au": 91,
	"./en-au.js": 91,
	"./en-ca": 92,
	"./en-ca.js": 92,
	"./en-gb": 93,
	"./en-gb.js": 93,
	"./en-ie": 94,
	"./en-ie.js": 94,
	"./en-il": 95,
	"./en-il.js": 95,
	"./en-in": 96,
	"./en-in.js": 96,
	"./en-nz": 97,
	"./en-nz.js": 97,
	"./en-sg": 98,
	"./en-sg.js": 98,
	"./eo": 99,
	"./eo.js": 99,
	"./es": 103,
	"./es-do": 100,
	"./es-do.js": 100,
	"./es-mx": 101,
	"./es-mx.js": 101,
	"./es-us": 102,
	"./es-us.js": 102,
	"./es.js": 103,
	"./et": 104,
	"./et.js": 104,
	"./eu": 105,
	"./eu.js": 105,
	"./fa": 106,
	"./fa.js": 106,
	"./fi": 107,
	"./fi.js": 107,
	"./fil": 108,
	"./fil.js": 108,
	"./fo": 109,
	"./fo.js": 109,
	"./fr": 112,
	"./fr-ca": 110,
	"./fr-ca.js": 110,
	"./fr-ch": 111,
	"./fr-ch.js": 111,
	"./fr.js": 112,
	"./fy": 113,
	"./fy.js": 113,
	"./ga": 114,
	"./ga.js": 114,
	"./gd": 115,
	"./gd.js": 115,
	"./gl": 116,
	"./gl.js": 116,
	"./gom-deva": 117,
	"./gom-deva.js": 117,
	"./gom-latn": 118,
	"./gom-latn.js": 118,
	"./gu": 119,
	"./gu.js": 119,
	"./he": 120,
	"./he.js": 120,
	"./hi": 121,
	"./hi.js": 121,
	"./hr": 122,
	"./hr.js": 122,
	"./hu": 123,
	"./hu.js": 123,
	"./hy-am": 124,
	"./hy-am.js": 124,
	"./id": 125,
	"./id.js": 125,
	"./is": 126,
	"./is.js": 126,
	"./it": 128,
	"./it-ch": 127,
	"./it-ch.js": 127,
	"./it.js": 128,
	"./ja": 129,
	"./ja.js": 129,
	"./jv": 130,
	"./jv.js": 130,
	"./ka": 131,
	"./ka.js": 131,
	"./kk": 132,
	"./kk.js": 132,
	"./km": 133,
	"./km.js": 133,
	"./kn": 134,
	"./kn.js": 134,
	"./ko": 135,
	"./ko.js": 135,
	"./ku": 137,
	"./ku-kmr": 136,
	"./ku-kmr.js": 136,
	"./ku.js": 137,
	"./ky": 138,
	"./ky.js": 138,
	"./lb": 139,
	"./lb.js": 139,
	"./lo": 140,
	"./lo.js": 140,
	"./lt": 141,
	"./lt.js": 141,
	"./lv": 142,
	"./lv.js": 142,
	"./me": 143,
	"./me.js": 143,
	"./mi": 144,
	"./mi.js": 144,
	"./mk": 145,
	"./mk.js": 145,
	"./ml": 146,
	"./ml.js": 146,
	"./mn": 147,
	"./mn.js": 147,
	"./mr": 148,
	"./mr.js": 148,
	"./ms": 150,
	"./ms-my": 149,
	"./ms-my.js": 149,
	"./ms.js": 150,
	"./mt": 151,
	"./mt.js": 151,
	"./my": 152,
	"./my.js": 152,
	"./nb": 153,
	"./nb.js": 153,
	"./ne": 154,
	"./ne.js": 154,
	"./nl": 156,
	"./nl-be": 155,
	"./nl-be.js": 155,
	"./nl.js": 156,
	"./nn": 157,
	"./nn.js": 157,
	"./oc-lnc": 158,
	"./oc-lnc.js": 158,
	"./pa-in": 159,
	"./pa-in.js": 159,
	"./pl": 160,
	"./pl.js": 160,
	"./pt": 162,
	"./pt-br": 161,
	"./pt-br.js": 161,
	"./pt.js": 162,
	"./ro": 163,
	"./ro.js": 163,
	"./ru": 164,
	"./ru.js": 164,
	"./sd": 165,
	"./sd.js": 165,
	"./se": 166,
	"./se.js": 166,
	"./si": 167,
	"./si.js": 167,
	"./sk": 168,
	"./sk.js": 168,
	"./sl": 169,
	"./sl.js": 169,
	"./sq": 170,
	"./sq.js": 170,
	"./sr": 172,
	"./sr-cyrl": 171,
	"./sr-cyrl.js": 171,
	"./sr.js": 172,
	"./ss": 173,
	"./ss.js": 173,
	"./sv": 174,
	"./sv.js": 174,
	"./sw": 175,
	"./sw.js": 175,
	"./ta": 176,
	"./ta.js": 176,
	"./te": 177,
	"./te.js": 177,
	"./tet": 178,
	"./tet.js": 178,
	"./tg": 179,
	"./tg.js": 179,
	"./th": 180,
	"./th.js": 180,
	"./tk": 181,
	"./tk.js": 181,
	"./tl-ph": 182,
	"./tl-ph.js": 182,
	"./tlh": 183,
	"./tlh.js": 183,
	"./tr": 184,
	"./tr.js": 184,
	"./tzl": 185,
	"./tzl.js": 185,
	"./tzm": 187,
	"./tzm-latn": 186,
	"./tzm-latn.js": 186,
	"./tzm.js": 187,
	"./ug-cn": 188,
	"./ug-cn.js": 188,
	"./uk": 189,
	"./uk.js": 189,
	"./ur": 190,
	"./ur.js": 190,
	"./uz": 192,
	"./uz-latn": 191,
	"./uz-latn.js": 191,
	"./uz.js": 192,
	"./vi": 193,
	"./vi.js": 193,
	"./x-pseudo": 194,
	"./x-pseudo.js": 194,
	"./yo": 195,
	"./yo.js": 195,
	"./zh-cn": 196,
	"./zh-cn.js": 196,
	"./zh-hk": 197,
	"./zh-hk.js": 197,
	"./zh-mo": 198,
	"./zh-mo.js": 198,
	"./zh-tw": 199,
	"./zh-tw.js": 199
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 538;

/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fontawesome-webfont.912ec66.svg";

/***/ }),

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),

/***/ 546:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),

/***/ 547:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.b06871f.ttf";

/***/ }),

/***/ 548:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.af7ae50.woff2";

/***/ }),

/***/ 549:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.fee66e7.woff";

/***/ }),

/***/ 566:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(327)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(593),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-67672014",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 567:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(334)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(234),
  /* template */
  __webpack_require__(600),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fecf2e2e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 568:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(321)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(235),
  /* template */
  __webpack_require__(587),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4ecd72df",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 569:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(316)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(237),
  /* template */
  __webpack_require__(582),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1fc931d9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 570:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(317)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(238),
  /* template */
  __webpack_require__(583),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-31c75772",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(330)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(596),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bae133e6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 572:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(315)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(240),
  /* template */
  __webpack_require__(581),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-02b87e94",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 573:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(320)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(241),
  /* template */
  __webpack_require__(586),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-44701a61",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 574:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(324)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(590),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5f1b0b85",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 575:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(319)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(243),
  /* template */
  __webpack_require__(585),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3544c43c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 576:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(326)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(592),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-659f0ef3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 577:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(332)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(598),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f030af1c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 578:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(331)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(597),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d0433b1c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(328)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(594),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6f58cb54",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 58:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(323)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(249),
  /* template */
  __webpack_require__(589),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5d1dd1da",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 581:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row text-center home-row-spacing"
  }, [_c('div', {
    staticClass: "col-4 mx-auto"
  }, [_c('div', {
    staticClass: "mb-2 showHand",
    on: {
      "click": _vm.pushApps
    }
  }, [_vm._m(2), _vm._v(" "), _c('p', [_vm._v("Inspect, monitor and configure your apps")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-4 mx-auto",
    on: {
      "click": _vm.pushHeliumJourney
    }
  }, [_vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "col-4 mx-auto",
    on: {
      "click": function($event) {
        return _vm.pushDeployments()
      }
    }
  }, [_c('div', {
    class: [_vm.$parent.isProduction ? 'showHand' : 'disabledBlock', 'mb-2']
  }, [_c('h4', {
    class: [_vm.$parent.isProduction ? 'text-primary' : 'disabled']
  }, [_c('i', {
    staticClass: "fas fa-cloud-upload-alt"
  }), _vm._v(" DevOps Deployments\n          ")]), _vm._v(" "), _c('p', {
    class: [_vm.$parent.isProduction ? '' : 'disabled']
  }, [_vm._v("Schedule a facilitated deployment")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "text-center home-row-spacing"
  }, [_c('strong', [_vm._v("Welcome to the Portal")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col text-center"
  }, [_vm._v("Tools and utilities for Helium app developers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "text-primary"
  }, [_c('i', {
    staticClass: "fas fa-mobile-alt"
  }), _vm._v(" Helium Apps")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-2 showHand"
  }, [_c('h4', {
    staticClass: "text-primary"
  }, [_c('i', {
    staticClass: "fas fa-rocket"
  }), _vm._v(" HeliumJourney Sync")]), _vm._v(" "), _c('p', [_vm._v("Integrate Helium and Journey")])])
}]}

/***/ }),

/***/ 582:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "jumbotron"
  }, [_c('div', {
    staticClass: "btn-group pull-right",
    attrs: {
      "role": "group",
      "aria-label": ""
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.btnNewEntryPoint
    }
  }, [_c('i', {
    staticClass: "fas fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" New")])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item active"
  }, [_vm._v("Config " + _vm._s(_vm.app.name))])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade active show",
    attrs: {
      "id": "timeouts"
    }
  }, [(_vm.config) ? _c('div', [_c('modal', {
    attrs: {
      "title": "Create new entry point",
      "show": _vm.modalShow,
      "backdrop": _vm.modalBackdrop,
      "effect": "zoom",
      "width": "400"
    },
    on: {
      "update:show": function($event) {
        _vm.modalShow = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('i', {
    staticClass: "fas fa-edit",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Set Entry point\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('form', [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-form-label",
    attrs: {
      "for": "selectType"
    }
  }, [_vm._v("Entry Point Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entryPointType),
      expression: "entryPointType"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "selectType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.entryPointType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("Helium View In WebApp")]), _vm._v(" "), _c('option', [_vm._v("Scheduled Function")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("Entry Point Scope")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entryPointScope),
      expression: "entryPointScope"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": _vm.entryPointScopeReadOnly,
      "placeholder": _vm.entryPointScopePlaceholder,
      "required": ""
    },
    domProps: {
      "value": (_vm.entryPointScope)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.entryPointScope = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("Entry Point")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entryPointName),
      expression: "entryPointName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.entryPointNamePlaceholder,
      "required": ""
    },
    domProps: {
      "value": (_vm.entryPointName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.entryPointName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("Timeout Value (Minutes)")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entryPointValue),
      expression: "entryPointValue"
    }],
    staticClass: "form-control",
    class: _vm.timeoutValueClass,
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.entryPointValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.timeoutValues), function(i) {
    return _c('option', [_vm._v("\n                    " + _vm._s(i) + "\n                    ")])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.modalCloseCallback
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.modalSaveCallback
    }
  }, [_vm._v("Save")])])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  })]) : _c('div', [_c('form', [_c('fieldset', [(_vm.config) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.disabledApp),
      expression: "disabledApp"
    }],
    staticClass: "custom-select form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.disabledApp = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Enable or disable this Helium app")]), _vm._v(" "), _c('option', [_vm._v("\n                      Enabled\n                    ")]), _vm._v(" "), _c('option', [_vm._v("\n                      Disabled\n                    ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.btnApplyEnabled
    }
  }, [_c('i', {
    staticClass: "fas fa-edit"
  }), _vm._v(" Apply")])]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("A disabled App will not allow users to login and will not run any scheduled functions tasks to be processed")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lockedApp),
      expression: "lockedApp"
    }],
    staticClass: "custom-select form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.lockedApp = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Lock or unlock this Helium app")]), _vm._v(" "), _c('option', [_vm._v("\n                      Locked\n                    ")]), _vm._v(" "), _c('option', [_vm._v("\n                      Unlocked\n                    ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.btnApplyLocked
    }
  }, [_c('i', {
    staticClass: "fas fa-edit"
  }), _vm._v(" Apply")])]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("A locked App will not allow users to login but background process will continue to run")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.maxDatabaseResults),
      expression: "maxDatabaseResults"
    }],
    staticClass: "form-control",
    class: _vm.maxDatabaseResultsValueClass,
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.maxDatabaseResults = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.maxDatabaseResultsValues), function(i) {
    return _c('option', [_vm._v("\n                    " + _vm._s(i) + "\n                    ")])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.btnApplyMaxDatabaseResults
    }
  }, [_c('i', {
    staticClass: "fas fa-edit"
  }), _vm._v(" Apply")])]), _vm._v(" "), _vm._m(7)]) : _vm._e()])]), _vm._v(" "), _c('app-config-entry-point', {
    attrs: {
      "config": _vm.config
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "schema-access"
    }
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('blockquote', {
    staticClass: "blockquote"
  }, [_c('form', [_c('fieldset', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("App")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.app.name),
      expression: "app.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": "",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.app.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.app, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("Team")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.teamUser),
      expression: "teamUser"
    }],
    staticClass: "custom-select form-control",
    attrs: {
      "id": "selectTeamName"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.teamUser = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.teamNames), function(entry) {
    return _c('option', [_vm._v("\n                            " + _vm._s(entry) + "\n                        ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-md",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip"
    },
    on: {
      "click": _vm.grantAccess
    }
  }, [_c('i', {
    staticClass: "fa fa-upload",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                        Grant Access\n                      ")])])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "#/home"
    }
  }, [_vm._v("Home")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "#/apps"
    }
  }, [_vm._v("Apps")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card card-inverse card-info text-xs-center"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('blockquote', {
    staticClass: "card-blockquote"
  }, [_c('p', [_vm._v("Update timeout value")])]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-edit card-block-watermark",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card card-inverse card-danger text-xs-center"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('blockquote', {
    staticClass: "card-blockquote"
  }, [_c('p', [_vm._v("Remove timeout value")])]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-minus-circle card-block-watermark",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "data-toggle": "tab",
      "href": "#timeouts"
    }
  }, [_vm._v("Timeouts")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "tab",
      "href": "#schema-access"
    }
  }, [_vm._v("Schema Access")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-6 col-form-label"
  }, [_c('i', {
    staticClass: "fas fa-check-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" App is currently:\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-6 col-form-label"
  }, [_c('i', {
    staticClass: "fas fa-lock-open",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" App is currently:\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-6 col-form-label"
  }, [_c('i', {
    staticClass: "fa fa-database",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Max Database Results\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Maximum number of results that can be returned by Helium's "), _c('code', [_vm._v("sql:query")]), _vm._v(" feature. See "), _c('a', {
    attrs: {
      "href": "https://wiki.mezzanineware.com/display/HTUT/Lesson+22%3A+Executing+SQL+Select+Queries+From+the+DSL"
    }
  }, [_vm._v("Lesson 22 (Executing SQL Select Queries From the DSL)")]), _vm._v(" for more information.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "id": "timeouts-info",
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Schema Access")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("Alter DB obects (tables, views, functions, sequences) in the App Schema to owned by Helium and accessable by developers postgres accounts")])])])])
}]}

/***/ }),

/***/ 583:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "jumbotron"
  }, [_c('div', {
    staticClass: "btn-group pull-right",
    attrs: {
      "role": "group",
      "aria-label": ""
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.newForm
    }
  }, [_c('i', {
    staticClass: "fas fa-plus-circle"
  }), _vm._v(" New Deployment\n      ")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('modal', {
    attrs: {
      "v-if": _vm.modalInfoShow,
      "show": _vm.modalInfoShow,
      "backdrop": _vm.modalBackdrop,
      "effect": "zoom",
      "large": ""
    },
    on: {
      "update:show": function($event) {
        _vm.modalInfoShow = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [(_vm.selection) ? _c('h4', {
    staticClass: "modal-title"
  }, [_c('i', {
    staticClass: "fa fa-rocket",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n         Deployment for " + _vm._s(_vm.selection.releaseName) + "\n         "), _c('span', {
    staticClass: "badge badge-default badge-pill"
  }, [_vm._v(_vm._s(_vm.selection.id))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [(_vm.selection) ? _c('ul', {
    staticClass: "list-group"
  }, [_c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Dev Team")]), _vm._v(" "), _c('span', {
    staticClass: "info-form col-12"
  }, [_vm._v(_vm._s(_vm.selection.team))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Jira Project")]), _vm._v(" "), _c('span', {
    staticClass: "info-form col-12"
  }, [_vm._v(_vm._s(_vm.selection.jiraProject))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Helium App Names")]), _vm._v(" "), _c('span', {
    staticClass: "info-form col-12"
  }, [_vm._v(_vm._s(_vm.selection.appNames))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Helium App IDs")]), _vm._v(" "), _c('span', {
    staticClass: "info-form col-12"
  }, [_vm._v(_vm._s(_vm.selection.appIds))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Data Source")]), _vm._v(" "), _c('span', {
    staticClass: "info-form col-12"
  }, [_vm._v(_vm._s(_vm.selection.dataSource.heliumDataSourceName))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Host Name")]), _vm._v(" "), _c('span', {
    staticClass: "info-form col-12"
  }, [_vm._v(_vm._s(_vm.selection.dataSource.hostname))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Database")]), _vm._v(" "), _c('span', {
    staticClass: "info-form col-12"
  }, [_vm._v(_vm._s(_vm.selection.dataSource.dbName))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Helium App Schemas")]), _vm._v(" "), _c('span', {
    staticClass: "info-form col-12"
  }, [_vm._v(_vm._s(_vm.selection.appSchemas))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Helium Release Group")]), _vm._v(" "), _c('span', {
    staticClass: "info-form col-12"
  }, [_vm._v(_vm._s(_vm.selection.releaseGroup))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Helium Release Name")]), _vm._v(" "), _c('span', {
    staticClass: "info-form col-12"
  }, [_vm._v(_vm._s(_vm.selection.releaseName))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Helium Release Description")]), _vm._v(" "), _c('span', {
    staticClass: "info-form col-12"
  }, [_vm._v(_vm._s(_vm.selection.releaseDescription))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Bitbucket URL")]), _vm._v(" "), _c('span', {
    staticClass: "info-form col-12"
  }, [_vm._v(_vm._s(_vm.selection.releaseTag))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Deployment Instructions")]), _vm._v(" "), _c('span', {
    staticClass: "info-form col-12"
  }, [_vm._v(_vm._s(_vm.selection.instructions))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Deployment Date")]), _vm._v(" "), _c('span', {
    staticClass: "info-form col-12"
  }, [_vm._v(_vm._s(_vm.selection.deploymentDate))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.modalInfoClose
    }
  }, [_vm._v("Close")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "title": "Schedule Deployment",
      "large": "",
      "show": _vm.showForm,
      "backdrop": _vm.modalBackdrop
    },
    on: {
      "update:show": function($event) {
        _vm.showForm = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('form-wizard', {
    ref: "deploymentWizard",
    attrs: {
      "color": "#3498db",
      "title": _vm.wizardTitle,
      "subtitle": "based on a Helium Release",
      "error-color": "#e74c3c"
    },
    on: {
      "on-complete": function($event) {
        return _vm.mergeSchedule()
      },
      "on-error": _vm.handleErrorMessage,
      "on-validate": _vm.handleValidation
    }
  }, [(_vm.loadingWizard) ? _c('div', {
    staticClass: "loader"
  }) : _vm._e(), _vm._v(" "), _c('tab-content', {
    attrs: {
      "title": "Select Helium Apps",
      "before-change": _vm.validateStep1
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("Data Source *")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedDataSource),
      expression: "selectedDataSource"
    }],
    staticClass: "custom-select form-control",
    attrs: {
      "name": "dataSource",
      "type": "text",
      "placeholder": "Data Source"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedDataSource = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": "Please select a Data Source"
    }
  }, [_vm._v("Please select a Data Source")]), _vm._v(" "), _vm._l((_vm.dataSources), function(entry) {
    return _c('option', {
      domProps: {
        "value": entry.dataSource
      }
    }, [_vm._v(_vm._s(entry.heliumDataSourceName))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("Developer Team *")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedTeam),
      expression: "selectedTeam"
    }],
    staticClass: "custom-select form-control",
    attrs: {
      "name": "team",
      "type": "text",
      "placeholder": "Team"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedTeam = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": "Please select a team"
    }
  }, [_vm._v("Please select a Dev Team")]), _vm._v(" "), _vm._l((_vm.teams), function(team) {
    return _c('option', [_vm._v(_vm._s(team))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("JIRA Project *")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedProject),
      expression: "selectedProject"
    }],
    staticClass: "custom-select form-control",
    attrs: {
      "name": "project",
      "type": "text",
      "placeholder": "JIRA Project"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedProject = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Please select a JIRA Project")]), _vm._v(" "), _vm._l((_vm.jiraProjects), function(jiraProject) {
    return _c('option', [_vm._v(_vm._s(jiraProject))])
  })], 2)]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted text-left col-sm-4"
  }, [_vm._v("Please select the Dev Team before selecting the JIRA Project.")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('vue-good-table', {
    ref: "heliumAppsTable",
    attrs: {
      "paginationOptions": {
        enabled: true
      },
      "sort-options": {
        enabled: true,
        initialSortBy: {
          field: 'name',
          type: 'asc'
        }
      },
      "select-options": {
        enabled: true
      },
      "styleClass": "vgt-table striped bordered table-hover",
      "columns": _vm.heliumAppColumns,
      "rows": _vm.heliumApps
    },
    on: {
      "on-select-all": _vm.onSelectAll,
      "on-row-click": _vm.onRowClick
    }
  })], 1)])]), _vm._v(" "), _c('tab-content', {
    attrs: {
      "title": "Fill in Release Details",
      "before-change": _vm.validateStep2
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("Bitbucket URL *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.releaseTag),
      expression: "releaseTag"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "releaseTag",
      "type": "text",
      "placeholder": "Bitbucket URL"
    },
    domProps: {
      "value": (_vm.releaseTag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.releaseTag = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted text-left col-sm-4"
  }, [_vm._v("Syntax: https://bitbucket.org/mezzanineapps/\n                  {repository}/commits/tag/ DEPLOY_{releaseGroup}_{YYYYMMDD}")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("Helium Release Group *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.releaseGroup),
      expression: "releaseGroup"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "releaseGroup",
      "type": "text",
      "placeholder": "Helium Release Group"
    },
    domProps: {
      "value": (_vm.releaseGroup)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.releaseGroup = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted text-left col-sm-4"
  }, [_vm._v("The Helium product name used to filter Helium apps for a release upgrade. Eg. Vouchering")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("Helium Release Name *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.releaseName),
      expression: "releaseName"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "releaseName",
      "type": "text",
      "placeholder": "Helium Release Name"
    },
    domProps: {
      "value": (_vm.releaseName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.releaseName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted text-left col-sm-4"
  }, [_vm._v(" Syntax: {product} - {YYYYMMDD}")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("Deployment Date *")]), _vm._v(" "), _c('flat-pickr', {
    attrs: {
      "placeholder": "Deployment Date",
      "config": _vm.config,
      "type": "date",
      "name": "deploymentDate"
    },
    model: {
      value: (_vm.selectedDate),
      callback: function($$v) {
        _vm.selectedDate = $$v
      },
      expression: "selectedDate"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "title": "Toggle",
      "data-toggle": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }, [_c('span', {
    staticClass: "sr-only",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("Toggle")])])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.instructions),
      expression: "instructions"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Deployment Instructions here",
      "rows": 5,
      "name": "instructions"
    },
    domProps: {
      "value": (_vm.instructions)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.instructions = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted text-left col-sm-4"
  }, [_vm._v("Eg. Does it require a Journey deployment? Are there post sql scripts? What user role is required to create the release? etc.")])])]), _vm._v(" "), _c('tab-content', {
    attrs: {
      "title": "Confirmation"
    }
  }, [_c('ul', {
    staticClass: "list-group break-word"
  }, [_c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Dev Team")]), _vm._v(" "), _c('span', {
    staticClass: "info-form col-12"
  }, [_vm._v(_vm._s(this.selectedTeam))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Jira Project")]), _vm._v(" "), _c('span', {
    staticClass: "info-form col-12"
  }, [_vm._v(_vm._s(this.selectedProject))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Helium App Names")]), _vm._v(" "), _c('span', {
    staticClass: "info-form col-12"
  }, [_vm._v(_vm._s(this.selectedAppNames))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Helium App IDs")]), _vm._v(" "), _c('span', {
    staticClass: "info-form col-12"
  }, [_vm._v(_vm._s(this.selectedAppIds))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Helium App Schemas")]), _vm._v(" "), _c('span', {
    staticClass: "info-form col-12"
  }, [_vm._v(_vm._s(this.selectedAppSchemas))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Datasource")]), _vm._v(" "), _c('span', {
    staticClass: "info-form col-12"
  }, [_vm._v(_vm._s(this.selectedDataSource))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Helium Release Group")]), _vm._v(" "), _c('span', {
    staticClass: "info-form col-12"
  }, [_vm._v(_vm._s(this.releaseGroup))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Helium Release Name")]), _vm._v(" "), _c('span', {
    staticClass: "info-form col-12"
  }, [_vm._v(_vm._s(this.releaseName))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Bitbucket URL")]), _vm._v(" "), _c('span', {
    staticClass: "info-form col-12"
  }, [_vm._v(_vm._s(this.releaseTag))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Deployment Instructions")]), _vm._v(" "), _c('span', {
    staticClass: "info-form col-12"
  }, [_vm._v(_vm._s(this.instructions))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Deployment Date")]), _vm._v(" "), _c('span', {
    staticClass: "info-form col-12"
  }, [_vm._v(_vm._s(this.selectedDate))])])])]), _vm._v(" "), (_vm.errorMsg) ? _c('div', [_c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorMsg))])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.closeForm
    }
  }, [_vm._v("Close")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "show": _vm.modalResolveShow,
      "backdrop": _vm.modalBackdrop,
      "effect": "zoom",
      "large": ""
    },
    on: {
      "update:show": function($event) {
        _vm.modalResolveShow = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.modalTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._v("\n        Are you sure you want to resolve this schedule ?\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-4 col-form-label text-danger"
  }, [_vm._v("Enter RESOLVE in capital letters")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.modalResolveConfirmInput),
      expression: "modalResolveConfirmInput"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.modalResolveConfirmInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.modalResolveConfirmInput = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeModalBtnClick
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.resolveDisabled
    },
    on: {
      "click": _vm.resolveSchedule
    }
  }, [_vm._v("Resolve")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('vue-good-table', {
    ref: "deployments",
    attrs: {
      "title": "Scheduled Deployments",
      "columns": _vm.deploymentColumns,
      "rows": _vm.deployments,
      "styleClass": "vgt-table striped bordered table-hover",
      "sort-options": {
        enabled: true,
        initialSortBy: {
          field: 'deploymentDate',
          type: 'desc'
        }
      },
      "search-options": {
        enabled: true
      },
      "paginationOptions": {
        enabled: true
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'deploymentDate') ? _c('span', [_vm._v(_vm._s(props.row.deploymentDate))]) : _vm._e(), _vm._v(" "), (props.column.field == 'team') ? _c('span', [_vm._v(_vm._s(props.row.team))]) : _vm._e(), _vm._v(" "), (props.column.field == 'jiraProject') ? _c('span', [_vm._v(_vm._s(props.row.jiraProject))]) : _vm._e(), _vm._v(" "), (props.column.field == 'appNames') ? _c('span', [_vm._v(_vm._s(props.row.appNames))]) : _vm._e(), _vm._v(" "), (props.column.field == 'appSchemas') ? _c('span', [_vm._v(_vm._s(props.row.appSchemas))]) : _vm._e(), _vm._v(" "), (props.column.field == 'releaseName') ? _c('span', [_vm._v(_vm._s(props.row.releaseName))]) : _vm._e(), _vm._v(" "), (props.column.field == 'releaseGroup') ? _c('span', [_vm._v(_vm._s(props.row.releaseGroup))]) : _vm._e(), _vm._v(" "), (props.column.label == 'Actions') ? _c('span', [_c('div', {
          staticClass: "btn-group text-right",
          attrs: {
            "role": "group"
          }
        }, [_c('button', {
          staticClass: "btn btn-info",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.viewSchedule(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-info-circle"
        }), _vm._v(" View\n                ")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-warning",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.updateSchedule(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-edit"
        }), _vm._v(" Update\n                ")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-success",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.resolveBtnClick(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-minus-circle"
        }), _vm._v(" Resolve\n                ")])])]) : _vm._e()]
      }
    }])
  })], 1)]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(2)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "#/home"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item active"
  }, [_vm._v("Scheduled Deployments")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card card-inverse card-info text-xs-center"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('blockquote', {
    staticClass: "card-blockquote"
  }, [_c('p', [_vm._v("Inspect a scheduled deployment")])]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-info-circle card-block-watermark",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card card-inverse card-warning text-xs-center"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('blockquote', {
    staticClass: "card-blockquote"
  }, [_c('p', [_vm._v("Update a scheduled deployment")])]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-edit card-block-watermark",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card card-inverse card-success text-xs-center"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('blockquote', {
    staticClass: "card-blockquote"
  }, [_c('p', [_vm._v("Resolve or remove a scheduled deployment")])]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-minus-circle card-block-watermark",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col d-flex justify-content-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  })])
}]}

/***/ }),

/***/ 584:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert",
    class: _vm.success === true ? 'alert-success' : 'alert-danger'
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('div', {
    attrs: {
      "id": "spinner"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-lg",
    class: _vm.spin === true ? 'fa-spin' : ''
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('p', [_vm._v(_vm._s(_vm.message))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 585:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('blockquote', {
    staticClass: "blockquote"
  }, [_c('form', [_c('fieldset', [_c('legend', [_vm._v("Grant Schema Access")]), _vm._v(" "), _c('fieldset', {
    staticClass: "form-group"
  }, [_c('legend', [_vm._v("Mode")]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.modeRadio),
      expression: "modeRadio"
    }],
    staticClass: "form-check-input",
    attrs: {
      "id": "optionsRadios1",
      "name": "optionsRadios",
      "type": "radio",
      "value": "migrate"
    },
    domProps: {
      "checked": _vm._q(_vm.modeRadio, "migrate")
    },
    on: {
      "change": function($event) {
        _vm.modeRadio = "migrate"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "badge badge-primary badge-pill"
  }, [_vm._v("Migrate")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.modeRadio),
      expression: "modeRadio"
    }],
    staticClass: "form-check-input",
    attrs: {
      "id": "optionsRadios2",
      "name": "optionsRadios",
      "type": "radio",
      "value": "generate"
    },
    domProps: {
      "checked": _vm._q(_vm.modeRadio, "generate")
    },
    on: {
      "change": function($event) {
        _vm.modeRadio = "generate"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "badge badge-default badge-pill"
  }, [_vm._v("Generate SQL")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("Team")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.teamUser),
      expression: "teamUser"
    }],
    staticClass: "custom-select form-control",
    attrs: {
      "id": "selectTeamName"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.teamUser = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.teamNames), function(entry) {
    return _c('option', [_vm._v("\n                        " + _vm._s(entry) + "\n                    ")])
  }), 0)])]), _vm._v(" "), (_vm.modeRadio === 'migrate') ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("Data Source")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataSource),
      expression: "dataSource"
    }],
    staticClass: "custom-select form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.dataSource = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.dataSources), function(entry) {
    return _c('option', {
      domProps: {
        "value": entry.dataSource
      }
    }, [_vm._v("\n                        " + _vm._s(entry.dataSource.heliumDataSourceName) + "\n                    ")])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("Schema Name")]), _vm._v(" "), (_vm.modeRadio !== 'migrate') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schemaName),
      expression: "schemaName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.schemaName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.schemaName = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.modeRadio === 'migrate') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schemaName),
      expression: "schemaName"
    }],
    staticClass: "custom-select form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.schemaName = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.appList), function(entry) {
    return _c('option', [_vm._v("\n                        " + _vm._s(entry.schemaName) + "\n                    ")])
  }), 0) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetData
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                  Clear selection\n                ")]), _vm._v(" "), (_vm.modeRadio === 'migrate') ? _c('button', {
    staticClass: "btn btn-primary btn-md",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Alter all obects in the schema name for the selected server to be owned by the selected team"
    },
    on: {
      "click": _vm.grantAccess
    }
  }, [_c('i', {
    staticClass: "fa fa-upload",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                  Grant Access\n                ")]) : _c('button', {
    staticClass: "btn btn-secondary btn-md",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Generate the SQL required to migrate the schema to the team"
    },
    on: {
      "click": _vm.generateSql
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                  Generate SQL\n                ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_vm._m(1), _vm._v(" "), _c('table', {
    staticClass: "table table-sm table-striped table-hover"
  }, [_vm._m(2), _c('thead'), _vm._v(" "), _c('tbody', _vm._l((_vm.dataSources), function(entry) {
    return _c('tr', {
      class: entry.response === 'Ping successful' ? '' : 'table-warning'
    }, [_c('td', [_vm._v(_vm._s(entry.heliumDataSourceName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.response))])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    ref: "resultsRef",
    staticClass: "container-fluid"
  }, [(_vm.response) ? _c('div', {
    staticClass: "card card-block card-outline-primary",
    attrs: {
      "id": "resultsDiv"
    }
  }, [_c('div', {
    staticClass: "card-title"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "form-inline float-right"
  }, [(_vm.textBlock) ? _c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.textBlock),
      expression: "textBlock",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "id": "copyToClipBtn",
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Copy SQL to your clipboard!"
    }
  }, [_c('i', {
    staticClass: "fa fa-clipboard"
  })]) : _vm._e()])])]), _vm._v(" "), (_vm.modeRadio === 'generate') ? _c('text-editor', {
    attrs: {
      "contentProp": _vm.textBlock,
      "width": _vm.textBlockWidth,
      "height": _vm.textBlockHeight,
      "readonly": _vm.textBlockReadOnly,
      "scrollToLine": _vm.textBlockScrollToLine,
      "lang": _vm.textBlockLang
    }
  }) : _vm._e()], 1) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "#/home"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item active"
  }, [_vm._v("Schema Access")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info pull-right",
    attrs: {
      "id": "schema-access-info",
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Postgres Permissions")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("By default developer's postgres users to not have permissions to view or update the data and schema of a Helium app")]), _vm._v(" "), _c('strong', [_vm._v("Connection Status")]), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-inverse"
  }, [_c('tr', [_c('th', [_vm._v("Data Source")]), _vm._v(" "), _c('th', [_vm._v("Ping Status")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('h4', [_vm._v("Results")])])
}]}

/***/ }),

/***/ 586:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "jumbotron"
  }, [_c('div', {
    staticClass: "btn-group pull-right",
    attrs: {
      "role": "group",
      "aria-label": "Reset pg stats on a data source"
    }
  }, [(_vm.hostname && _vm.hostnameApp) ? _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.refreshRows
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Refresh\n        ")]) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('form', [_c('fieldset', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedMode),
      expression: "selectedMode"
    }],
    staticClass: "custom-select form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedMode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("App")]), _vm._v(" "), _c('option', [_vm._v("Datasource")])])]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Select DB Spy mode, view results for entire datasource or for one Helium app")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataSource),
      expression: "dataSource"
    }],
    staticClass: "custom-select form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.dataSource = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Please select a data source")]), _vm._v(" "), _vm._l((_vm.dataSources), function(entry) {
    return _c('option', {
      domProps: {
        "value": entry.dataSource
      }
    }, [_vm._v("\n                      " + _vm._s(entry.dataSource.heliumDataSourceName) + "\n                  ")])
  })], 2)]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Helium data source to be examined")]), _vm._v(" "), (_vm.selectedMode === 'App') ? _c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hostnameApp),
      expression: "hostnameApp"
    }],
    staticClass: "custom-select form-control",
    attrs: {
      "placeholder": "Helium App",
      "type": "text"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.hostnameApp = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Please select an app")]), _vm._v(" "), _vm._l((_vm.hostnameApps), function(a) {
    return _c('option', [_vm._v("\n                      " + _vm._s(a.name) + " ( " + _vm._s(a.id) + " )\n                  ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.selectedMode === 'App') ? _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Helium App on selected data source to be examined.")]) : _vm._e()])])])])]), _vm._v(" "), (_vm.dataSource) ? _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_vm._m(5), _vm._v(" "), _vm._m(6)]) : _vm._e(), _vm._v(" "), (_vm.dataSource) ? _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade active show",
    attrs: {
      "id": "chart"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('form', [_c('fieldset', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(7), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chartType),
      expression: "chartType"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.chartType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Please select a chart metric")]), _vm._v(" "), _vm._l((_vm.chartTypeDropdown), function(entry) {
    return _c('option', [_vm._v("\n                          " + _vm._s(entry.label) + "\n                      ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(8), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chartSortType),
      expression: "chartSortType"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.chartSortType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Please select a sort type")]), _vm._v(" "), _c('option', [_vm._v("\n                        Ascending\n                      ")]), _vm._v(" "), _c('option', [_vm._v("\n                        Descending\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(9), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chartResultSetSize),
      expression: "chartResultSetSize"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.chartResultSetSize = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Please select a number of results")]), _vm._v(" "), _vm._l((_vm.chartResultSetSizes), function(i) {
    return _c('option', [_vm._v("\n                        " + _vm._s(i) + "\n                      ")])
  })], 2)])])])]), _vm._v(" "), (_vm.chartData) ? _c('div', [_c('pie-chart', {
    attrs: {
      "chartData": _vm.chartData,
      "options": {
        responsive: true,
        maintainAspectRatio: true
      }
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, _vm._l((_vm.chartQueries), function(entry) {
    return (_vm.chartData) ? _c('div', [_c('pre', {
      directives: [{
        name: "highlightjs",
        rawName: "v-highlightjs",
        value: (entry),
        expression: "entry"
      }]
    }, [_c('code', {
      staticClass: "sql"
    })])]) : _vm._e()
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "table"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [(!_vm.loading && _vm.rows.length > 0) ? _c('div', [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "sort-options": {
        enabled: true,
        initialSortBy: {
          field: 'mean_time',
          type: 'desc'
        }
      },
      "search-options": {
        enabled: true
      },
      "paginationOptions": {
        enabled: true
      },
      "styleClass": "vgt-table striped bordered table-hover",
      "lineNumbers": true
    },
    on: {
      "on-row-click": _vm.onClickFn
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'query') ? _c('span', [_vm._v(_vm._s(props.row.query))]) : _vm._e(), _vm._v(" "), (props.column.field == 'calls') ? _c('span', [_vm._v(_vm._s(props.row.calls))]) : _vm._e(), _vm._v(" "), (props.column.field == 'total_time') ? _c('span', [_vm._v(_vm._s(props.row.total_time))]) : _vm._e(), _vm._v(" "), (props.column.field == 'min_time') ? _c('span', [_vm._v(_vm._s(props.row.min_time))]) : _vm._e(), _vm._v(" "), (props.column.field == 'max_time') ? _c('span', [_vm._v(_vm._s(props.row.max_time))]) : _vm._e(), _vm._v(" "), (props.column.field == 'mean_time') ? _c('span', [_vm._v(_vm._s(props.row.mean_time))]) : _vm._e(), _vm._v(" "), (props.column.field == 'stddev_time') ? _c('span', [_vm._v(_vm._s(props.row.stddev_time))]) : _vm._e(), _vm._v(" "), (props.column.field == 'rows') ? _c('span', [_vm._v(_vm._s(props.row.rows))]) : _vm._e()]
      }
    }], null, false, 188718182)
  })], 1) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(10)]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('modal', {
    attrs: {
      "show": _vm.modalResetShow,
      "backdrop": _vm.modalBackdrop,
      "effect": "zoom",
      "large": ""
    },
    on: {
      "update:show": function($event) {
        _vm.modalResetShow = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Reset Stats on Data Source\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('form', [_c('fieldset', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("Data Source")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hostnameReset),
      expression: "hostnameReset"
    }],
    staticClass: "custom-select form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.hostnameReset = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Please select a data source")]), _vm._v(" "), _vm._l((_vm.hostnames), function(entry) {
    return _c('option', [_vm._v("\n                        " + _vm._s(entry.hostname) + "\n                    ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-4 col-form-label text-danger"
  }, [_vm._v("Enter RESET in capital letters")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resetConfirmText),
      expression: "resetConfirmText"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.resetConfirmText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.resetConfirmText = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.resetDisabled
    },
    on: {
      "click": _vm.pgStatReset
    }
  }, [_vm._v("Reset Stats on server")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closePgStatReset
    }
  }, [_vm._v("Close")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "show": _vm.modalShowDetail,
      "backdrop": _vm.modalBackdrop,
      "effect": "zoom",
      "large": ""
    },
    on: {
      "update:show": function($event) {
        _vm.modalShowDetail = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Query Pattern Detail\n        ")])]), _vm._v(" "), (_vm.selectedQuery) ? _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('pre', {
    directives: [{
      name: "highlightjs",
      rawName: "v-highlightjs",
      value: (_vm.selectedQuery.query),
      expression: "selectedQuery.query"
    }]
  }, [_c('code', {
    staticClass: "sql"
  })]), _vm._v(" "), _c('form', [_c('fieldset', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-6 col-form-label"
  }, [_vm._v("Number of Calls")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedQuery.calls),
      expression: "selectedQuery.calls"
    }],
    staticClass: "form-control col-2",
    attrs: {
      "type": "text",
      "readonly": "true"
    },
    domProps: {
      "value": (_vm.selectedQuery.calls)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedQuery, "calls", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-6 col-form-label"
  }, [_vm._v("Total Time spend processing")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedQuery.total_time),
      expression: "selectedQuery.total_time"
    }],
    staticClass: "form-control col-2",
    attrs: {
      "type": "text",
      "readonly": "true"
    },
    domProps: {
      "value": (_vm.selectedQuery.total_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedQuery, "total_time", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-6 col-form-label"
  }, [_vm._v("Minimum Time query has lasted")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedQuery.min_time),
      expression: "selectedQuery.min_time"
    }],
    staticClass: "form-control col-2",
    attrs: {
      "type": "text",
      "readonly": "true"
    },
    domProps: {
      "value": (_vm.selectedQuery.min_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedQuery, "min_time", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-6 col-form-label"
  }, [_vm._v("Maximum Time query has lasted")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedQuery.max_time),
      expression: "selectedQuery.max_time"
    }],
    staticClass: "form-control col-2",
    attrs: {
      "type": "text",
      "readonly": "true"
    },
    domProps: {
      "value": (_vm.selectedQuery.max_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedQuery, "max_time", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-6 col-form-label"
  }, [_vm._v("Mean Time spend processing query")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedQuery.mean_time),
      expression: "selectedQuery.mean_time"
    }],
    staticClass: "form-control col-2",
    attrs: {
      "type": "text",
      "readonly": "true"
    },
    domProps: {
      "value": (_vm.selectedQuery.mean_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedQuery, "mean_time", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-6 col-form-label"
  }, [_vm._v("Standard deviation of time processing query")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedQuery.stddev_time),
      expression: "selectedQuery.stddev_time"
    }],
    staticClass: "form-control col-2",
    attrs: {
      "type": "text",
      "readonly": "true"
    },
    domProps: {
      "value": (_vm.selectedQuery.stddev_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedQuery, "stddev_time", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-6 col-form-label"
  }, [_vm._v("Total Rows retrieved or affected by query")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedQuery.rows),
      expression: "selectedQuery.rows"
    }],
    staticClass: "form-control col-2",
    attrs: {
      "type": "text",
      "readonly": "true"
    },
    domProps: {
      "value": (_vm.selectedQuery.rows)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedQuery, "rows", $event.target.value)
      }
    }
  })])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeModalShowDetail
    }
  }, [_vm._v("Close")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "#/home"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item active"
  }, [_vm._v("DB Spy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card card-inverse card-info text-xs-center"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('blockquote', {
    staticClass: "card-blockquote"
  }, [_c('p', [_vm._v("Display details of a Helium apps performance")])]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-mobile-alt card-block-watermark",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card card-inverse card-success text-xs-center"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('blockquote', {
    staticClass: "card-blockquote"
  }, [_c('p', [_vm._v("Display overview of datasource performance")])]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-database card-block-watermark",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-3 col-form-label"
  }, [_c('i', {
    staticClass: "fas fa-eye"
  }), _vm._v(" DB Spy viewing mode: ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-3 col-form-label"
  }, [_c('i', {
    staticClass: "fas fa-database"
  }), _vm._v(" Data Source")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-3 col-form-label"
  }, [_c('i', {
    staticClass: "fas fa-mobile-alt"
  }), _vm._v(" App")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "data-toggle": "tab",
      "href": "#chart"
    }
  }, [_vm._v("Chart")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "tab",
      "href": "#table"
    }
  }, [_vm._v("Table")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-4 col-form-label"
  }, [_c('i', {
    staticClass: "fa fa-pie-chart",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Chart Metric\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-4 col-form-label"
  }, [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Sort\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-4 col-form-label"
  }, [_c('i', {
    staticClass: "fa fa-sort-numeric-asc",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Number of results\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col d-flex justify-content-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  })])
}]}

/***/ }),

/***/ 587:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    ref: "sfStatsRef",
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "tab",
      "href": "#sf-stats"
    }
  }, [_vm._v("Scheduled Function Stats")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade active show",
    attrs: {
      "id": "query-visualizer"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('form', [_c('fieldset', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chartType),
      expression: "chartType"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.chartType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Please select a chart metric")]), _vm._v(" "), _vm._l((_vm.chartTypeDropdown), function(entry) {
    return _c('option', [_vm._v("\n                        " + _vm._s(entry.label) + "\n                    ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chartSortType),
      expression: "chartSortType"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.chartSortType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Please select a sort type")]), _vm._v(" "), _c('option', [_vm._v("\n                      Ascending\n                    ")]), _vm._v(" "), _c('option', [_vm._v("\n                      Descending\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chartResultSetSize),
      expression: "chartResultSetSize"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.chartResultSetSize = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Please select a number of results")]), _vm._v(" "), _vm._l((_vm.chartResultSetSizes), function(i) {
    return _c('option', [_vm._v("\n                      " + _vm._s(i) + "\n                    ")])
  })], 2)])])])]), _vm._v(" "), (_vm.chartData) ? _c('div', [_c('pie-chart', {
    attrs: {
      "chartData": _vm.chartData,
      "options": {
        responsive: true,
        maintainAspectRatio: true
      }
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, _vm._l((_vm.chartQueries), function(entry) {
    return (_vm.chartData) ? _c('div', [_c('pre', {
      directives: [{
        name: "highlightjs",
        rawName: "v-highlightjs",
        value: (entry),
        expression: "entry"
      }]
    }, [_c('code', {
      staticClass: "sql"
    })])]) : _vm._e()
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "query-stats"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [(_vm.statsLoading) ? _c('div', [_c('strong', [_vm._v("Results are loading ...")]), _vm._v(" This is a heavy query and can take some time to process please be patient.\n            ")]) : _c('div', [(_vm.rows.length > 0) ? _c('div', [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "sort-options": {
        enabled: true,
        initialSortBy: {
          field: 'mean_time',
          type: 'desc'
        }
      },
      "search-options": {
        enabled: true
      },
      "paginationOptions": {
        enabled: true
      },
      "styleClass": "vgt-table striped bordered table-hover",
      "lineNumbers": true
    },
    on: {
      "on-row-click": _vm.onClickFn
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'query') ? _c('span', [_vm._v(_vm._s(props.row.query))]) : _vm._e(), _vm._v(" "), (props.column.field == 'calls') ? _c('span', [_vm._v(_vm._s(props.row.calls))]) : _vm._e(), _vm._v(" "), (props.column.field == 'total_time') ? _c('span', [_vm._v(_vm._s(props.row.total_time))]) : _vm._e(), _vm._v(" "), (props.column.field == 'min_time') ? _c('span', [_vm._v(_vm._s(props.row.min_time))]) : _vm._e(), _vm._v(" "), (props.column.field == 'max_time') ? _c('span', [_vm._v(_vm._s(props.row.max_time))]) : _vm._e(), _vm._v(" "), (props.column.field == 'mean_time') ? _c('span', [_vm._v(_vm._s(props.row.mean_time))]) : _vm._e(), _vm._v(" "), (props.column.field == 'stddev_time') ? _c('span', [_vm._v(_vm._s(props.row.stddev_time))]) : _vm._e(), _vm._v(" "), (props.column.field == 'rows') ? _c('span', [_vm._v(_vm._s(props.row.rows))]) : _vm._e()]
      }
    }], null, false, 188718182)
  })], 1) : _c('div', [_c('strong', [_vm._v("No Results found!")]), _vm._v(" No recently PG stats could be found.\n              ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "sf-stats"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('loading', {
    attrs: {
      "active": _vm.sfLoading
    },
    on: {
      "update:active": function($event) {
        _vm.sfLoading = $event
      }
    }
  }), _vm._v(" "), (_vm.sfLoading) ? _c('div', [_c('strong', [_vm._v("Results are loading ...")]), _vm._v(" This is a heavy query and can take some time to process please be patient.\n              ")]) : _c('div', [(_vm.functionResults.length > 0) ? _c('div', [_c('vue-good-table', {
    attrs: {
      "title": "Processed Scheduled Functions",
      "columns": _vm.functionColumns,
      "rows": _vm.functionResults,
      "sort-options": {
        enabled: true,
        initialSortBy: {
          field: 'started',
          type: 'desc'
        }
      },
      "search-options": {
        enabled: true
      },
      "paginationOptions": {
        enabled: true
      },
      "styleClass": "vgt-table striped bordered table-hover"
    }
  })], 1) : _c('div', [_c('strong', [_vm._v("No Results found!")]), _vm._v(" No recently processed scheduled function stats cound be found.\n                ")])])], 1)])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "show": _vm.modalShowDetail,
      "backdrop": _vm.modalBackdrop,
      "effect": "zoom",
      "large": ""
    },
    on: {
      "update:show": function($event) {
        _vm.modalShowDetail = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Query Pattern Detail\n      ")])]), _vm._v(" "), (_vm.selectedQuery) ? _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('pre', {
    directives: [{
      name: "highlightjs",
      rawName: "v-highlightjs",
      value: (_vm.selectedQuery.query),
      expression: "selectedQuery.query"
    }]
  }, [_c('code', {
    staticClass: "sql"
  })]), _vm._v(" "), _c('form', [_c('fieldset', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-6 col-form-label"
  }, [_vm._v("Number of Calls")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedQuery.calls),
      expression: "selectedQuery.calls"
    }],
    staticClass: "form-control col-2",
    attrs: {
      "type": "text",
      "readonly": "true"
    },
    domProps: {
      "value": (_vm.selectedQuery.calls)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedQuery, "calls", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-6 col-form-label"
  }, [_vm._v("Total Time spend processing")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedQuery.total_time),
      expression: "selectedQuery.total_time"
    }],
    staticClass: "form-control col-2",
    attrs: {
      "type": "text",
      "readonly": "true"
    },
    domProps: {
      "value": (_vm.selectedQuery.total_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedQuery, "total_time", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-6 col-form-label"
  }, [_vm._v("Minimum Time query has lasted")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedQuery.min_time),
      expression: "selectedQuery.min_time"
    }],
    staticClass: "form-control col-2",
    attrs: {
      "type": "text",
      "readonly": "true"
    },
    domProps: {
      "value": (_vm.selectedQuery.min_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedQuery, "min_time", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-6 col-form-label"
  }, [_vm._v("Maximum Time query has lasted")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedQuery.max_time),
      expression: "selectedQuery.max_time"
    }],
    staticClass: "form-control col-2",
    attrs: {
      "type": "text",
      "readonly": "true"
    },
    domProps: {
      "value": (_vm.selectedQuery.max_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedQuery, "max_time", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-6 col-form-label"
  }, [_vm._v("Mean Time spend processing query")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedQuery.mean_time),
      expression: "selectedQuery.mean_time"
    }],
    staticClass: "form-control col-2",
    attrs: {
      "type": "text",
      "readonly": "true"
    },
    domProps: {
      "value": (_vm.selectedQuery.mean_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedQuery, "mean_time", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-6 col-form-label"
  }, [_vm._v("Standard deviation of time processing query")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedQuery.stddev_time),
      expression: "selectedQuery.stddev_time"
    }],
    staticClass: "form-control col-2",
    attrs: {
      "type": "text",
      "readonly": "true"
    },
    domProps: {
      "value": (_vm.selectedQuery.stddev_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedQuery, "stddev_time", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-6 col-form-label"
  }, [_vm._v("Total Rows retrieved or affected by query")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedQuery.rows),
      expression: "selectedQuery.rows"
    }],
    staticClass: "form-control col-2",
    attrs: {
      "type": "text",
      "readonly": "true"
    },
    domProps: {
      "value": (_vm.selectedQuery.rows)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedQuery, "rows", $event.target.value)
      }
    }
  })])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeModalShowDetail
    }
  }, [_vm._v("Close")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "#/home"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "#/apps"
    }
  }, [_vm._v("Apps")])]), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item active"
  }, [_vm._v("View")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "data-toggle": "tab",
      "href": "#query-visualizer"
    }
  }, [_vm._v("Query Visualizer")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "tab",
      "href": "#query-stats"
    }
  }, [_vm._v("Query Stats")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-4 col-form-label"
  }, [_c('i', {
    staticClass: "fa fa-pie-chart",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Chart Metric\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-4 col-form-label"
  }, [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Sort\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-4 col-form-label"
  }, [_c('i', {
    staticClass: "fa fa-sort-numeric-asc",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Number of results\n                  ")])
}]}

/***/ }),

/***/ 588:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('editor', {
    attrs: {
      "id": "editor",
      "width": _vm.width,
      "height": _vm.height,
      "lang": _vm.lang,
      "theme": "monokai"
    },
    on: {
      "init": function($event) {
        return _vm.editorInit();
      }
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 589:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "relationships"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('legend', [_vm._v("Helium:")]), _vm._v(" "), _c('text-editor', {
    attrs: {
      "contentProp": _vm.fkHeliumContent,
      "width": _vm.textEditorWidthUser,
      "height": _vm.textEditorHeightUser,
      "readonly": _vm.textEditorReadOnly,
      "scrollToLine": _vm.textEditorScrollToLine,
      "lang": _vm.textEditorJava
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('legend', [_vm._v("Journey:")]), _vm._v(" "), _c('text-editor', {
    attrs: {
      "contentProp": _vm.fkJourneyContent,
      "width": _vm.textEditorWidthUser,
      "height": _vm.textEditorHeightUser,
      "readonly": _vm.textEditorReadOnly,
      "scrollToLine": _vm.textEditorScrollToLine,
      "lang": _vm.textEditorXml
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "user-helium"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('legend', [_vm._v("Helium:")]), _vm._v(" "), _c('text-editor', {
    attrs: {
      "contentProp": _vm.userHeliumContent,
      "width": _vm.textEditorWidthUser,
      "height": _vm.textEditorHeightUser,
      "readonly": _vm.textEditorReadOnly,
      "scrollToLine": _vm.textEditorScrollToLine,
      "lang": _vm.textEditorJava
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('legend', [_vm._v("Journey:")]), _vm._v(" "), _c('text-editor', {
    attrs: {
      "contentProp": _vm.userJourneyContent,
      "width": _vm.textEditorWidthUser,
      "height": _vm.textEditorHeightUser,
      "readonly": _vm.textEditorReadOnly,
      "scrollToLine": _vm.textEditorScrollToLine,
      "lang": _vm.textEditorXml
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "user-journey"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('legend', [_vm._v("Helium:")]), _vm._v(" "), _c('text-editor', {
    attrs: {
      "contentProp": _vm.userHeliumV2Content,
      "width": _vm.textEditorWidthUser,
      "height": _vm.textEditorHeightUser,
      "readonly": _vm.textEditorReadOnly,
      "scrollToLine": _vm.textEditorScrollToLine,
      "lang": _vm.textEditorJava
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('legend', [_vm._v("Journey:")]), _vm._v(" "), _c('text-editor', {
    attrs: {
      "contentProp": _vm.userJourneyV2Content,
      "width": _vm.textEditorWidthUser,
      "height": _vm.textEditorHeightUser,
      "readonly": _vm.textEditorReadOnly,
      "scrollToLine": _vm.textEditorScrollToLine,
      "lang": _vm.textEditorXml
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "#/home"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "#/sync"
    }
  }, [_vm._v("Sync")])]), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item active"
  }, [_vm._v("Guide")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "data-toggle": "tab",
      "href": "#guide"
    }
  }, [_vm._v("Guide")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "tab",
      "href": "#relationships"
    }
  }, [_vm._v("Relationships")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "tab",
      "href": "#user-helium"
    }
  }, [_vm._v("Single device per user")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "tab",
      "href": "#user-journey"
    }
  }, [_vm._v("Multiple devices per user")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-pane active show",
    attrs: {
      "id": "guide"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('legend', [_vm._v("Introduction:")]), _vm._v(" "), _c('p', [_vm._v("The Helium Journey middleware provides bidirectional data synchronisation between a Helium app's database and a Journey app's database. See the other tabs for code examples.")]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Data model:")]), _vm._v(" "), _c('p', [_vm._v("In order to facilitate data sync between the two platforms the Helium Journey middleware requires the data model of the Helium and Joureny app to match. Persistent objects declared must exist the same on both sides such as the object name, attributes and relationship names.")]), _vm._v(" "), _c('legend', [_vm._v("Primitive Data Types:")]), _vm._v(" "), _c('p', [_vm._v("The data models declared for an integrated Helium Journey application, for the objects that are to be synchronised, must be exactly the same and of equivalent types.")]), _vm._v(" "), _c('p', [_vm._v("Supported Data Types:")]), _vm._v(" "), _c('table', {
    staticClass: "table table-sm table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Whole number")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Textual value")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Floating point number")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Boolean value")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Date value")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Date and time value")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Photo value")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Signature value")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Attachment value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Helium")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("decimal")]), _vm._v(" "), _c('td', [_vm._v("bool")]), _vm._v(" "), _c('td', [_vm._v("date")]), _vm._v(" "), _c('td', [_vm._v("datetime")]), _vm._v(" "), _c('td', [_vm._v("blob")]), _vm._v(" "), _c('td', [_vm._v("blob")]), _vm._v(" "), _c('td', [_vm._v("blob")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Journey")]), _vm._v(" "), _c('td', [_vm._v("integer")]), _vm._v(" "), _c('td', [_vm._v("text")]), _vm._v(" "), _c('td', [_vm._v("number")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("date")]), _vm._v(" "), _c('td', [_vm._v("datetime")]), _vm._v(" "), _c('td', [_vm._v("photo")]), _vm._v(" "), _c('td', [_vm._v("signature")]), _vm._v(" "), _c('td', [_vm._v("attachment")])])])]), _vm._v(" "), _c('p', [_vm._v("Unsupported Data Types:")]), _vm._v(" "), _c('table', {
    staticClass: "table table-sm table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Void")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Location")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Single Choice")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Single Choice Integer")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Multiple Choice")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Multiple Choice Integer")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Tracker")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Helium")]), _vm._v(" "), _c('td', [_vm._v("void (as method return type only)")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Journey")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("location")]), _vm._v(" "), _c('td', [_vm._v("single-choice")]), _vm._v(" "), _c('td', [_vm._v("single-choice-integer")]), _vm._v(" "), _c('td', [_vm._v("multiple-choice")]), _vm._v(" "), _c('td', [_vm._v("multiple-choice-integer")]), _vm._v(" "), _c('td', [_vm._v("track")])])])]), _vm._v(" "), _c('p', [_vm._v("The unsupported data types on Joureny may be used however only in the context of the view javascript and when using the "), _c('a', {
    attrs: {
      "href": "https://docs.journeyapps.com/docs/app-database#section-localdb"
    }
  }, [_vm._v("LocalDB")])]), _vm._v(" "), _c('legend', [_vm._v("Enums:")]), _vm._v(" "), _c('p', [_vm._v("Helium and Journey handle enum types differently and due to this a Journey enum is not directly compatable with a Helium enum. Enums can however be used in an integrated application by using enums only on Helium. On Journey use the datatype type text, values persisted in the text format on Journey need to be a valid enum value as declared on the Helium model.")]), _vm._v(" "), _c('p', [_vm._v("Journey enums can be used on the Journey app as long as they are used only in the view javascript or when using the "), _c('a', {
    attrs: {
      "href": "https://docs.journeyapps.com/docs/app-database#section-localdb"
    }
  }, [_vm._v("LocalDB")])]), _vm._v(" "), _c('legend', [_vm._v("Relationships:")]), _vm._v(" "), _c('p', [_vm._v("OneToOne and ManyToOne relationships are supported provided the relationship names are matching on Helium and Journey.")]), _vm._v(" "), _c('p', [_vm._v("ManyToMany and OneToOne relationships are not supported on Journey and are therefore objects using these annotations should also be skipped from syncing by also adding the @NotTracked annotation to the persistent object")]), _vm._v(" "), _c('legend', [_vm._v("Ignoring Certain Objects:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("To skip an object from being processed from Helium to Journey the "), _c('a', {
    attrs: {
      "href": "https://wiki.mezzanineware.com/display/HTUT/Data+Types#DataTypes-@NotTracked"
    }
  }, [_vm._v("@NotTracked annotation")]), _vm._v(" can be used.")]), _vm._v(" "), _c('li', [_vm._v("To skip an object from being processed from Journey to Helium the "), _c('a', {
    attrs: {
      "href": "https://docs.journeyapps.com/docs/app-database#section-localdb"
    }
  }, [_vm._v("LocalDB")]), _vm._v(" feature can be used.")]), _vm._v(" "), _c('li', [_vm._v("If for some reason the annotation or LocalDB cannot be used objects can be specifically skipped on the integration configuration.")]), _vm._v(" "), _c('li', [_vm._v("When an object is halting integration because it cannot be synced to either Helium or Journey then it's type can be explicilty skipped until sync has advanced past that version")])]), _vm._v(" "), _c('legend', [_vm._v("Special Attribute Names:")]), _vm._v("\n            If for some reason on Journey side someone has defined an attribute name that is reserved on Helium, an alternative attribute name must be used on both Helium and Journey.\n            "), _c('table', {
    staticClass: "table table-sm table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Reserved attribute / column name")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Recommended naming on both Helium and Journey")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("date")]), _vm._v(" "), _c('td', [_vm._v("creation_date")])])])]), _vm._v(" "), _c('legend', [_vm._v("Attribute names ending in \"_id\"")]), _vm._v(" "), _c('p', [_vm._v("Do not create attributes on Helium ending in \"_id\".  This is seen as a relationship on Journey's side.")]), _vm._v(" "), _c('legend', [_vm._v("Object names in CAPS")]), _vm._v(" "), _c('p', [_vm._v("Do not use Journey object names in all CAPS.  It will not be handled correctly on Helium's side.")]), _vm._v(" "), _c('legend', [_vm._v("Cascade in relationships")]), _vm._v(" "), _c('p', [_vm._v("When you delete an object on Journey, and some other object depends on it (in a many-to-one relationship), then Journey has a cascade policy and will subsequently nullify the other object's owner reference. Helium as of 1.3.5 also has a \"on cascade set null\" policy. As an example, if you have a Farmer object with a many to one relationship to a Country object e.g. South Africa.  If the country South Africa gets deleted, then the country_id gets set to null on Journey, and likewise the column country_fk gets set to null on Helium")]), _vm._v(" "), _c('legend', [_vm._v("Resources:")]), _vm._v(" "), _c('p', [_vm._v("See "), _c('a', {
    attrs: {
      "href": "https://wiki.mezzanineware.com/display/HTUT/Data+Types"
    }
  }, [_vm._v("Helium data type docs")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "https://docs.journeyapps.com/v4/reference#section-field-types"
    }
  }, [_vm._v("Journey data type docs")]), _vm._v(" for more info data types.")])])])])])
}]}

/***/ }),

/***/ 590:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "jumbotron"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item active"
  }, [_vm._v("Scheduled Functions " + _vm._s(_vm.app.name))])])]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    ref: "sfStatsRef",
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "tab",
      "href": "#sf"
    }
  }, [_vm._v("Scheduled Functions")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade active show",
    attrs: {
      "id": "sf"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', [(_vm.scheduledFunctions.length > 0) ? _c('div', [_c('vue-good-table', {
    attrs: {
      "title": "Scheduled Functions",
      "columns": _vm.functionColumns,
      "rows": _vm.scheduledFunctions,
      "sort-options": {
        enabled: true,
        initialSortBy: {
          field: 'unit',
          type: 'asc'
        }
      },
      "search-options": {
        enabled: true
      },
      "paginationOptions": {
        enabled: true
      },
      "styleClass": "vgt-table striped bordered table-hover"
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'schedule') ? _c('span', [_vm._v(_vm._s(props.row.schedule))]) : _vm._e(), _vm._v(" "), (props.column.field == 'unit') ? _c('span', [_vm._v(_vm._s(props.row.unit))]) : _vm._e(), _vm._v(" "), (props.column.field == 'event') ? _c('span', [_vm._v(_vm._s(props.row.event))]) : _vm._e(), _vm._v(" "), (props.column.field == 'state') ? _c('span', [_vm._v(_vm._s(props.row.state))]) : _vm._e(), _vm._v(" "), (props.column.label == 'Actions') ? _c('span', [_c('button', {
          staticClass: "btn btn-sm btn-info",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.btnToggleScheduledFunction(props.row.unit, props.row.event, props.row.state)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-edit",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Toggle\n                    ")])]) : _vm._e()]
      }
    }], null, false, 3887991541)
  })], 1) : _c('div', [_c('strong', [_vm._v("No Results found!")]), _vm._v(" No scheduled function cound be found for this app.\n            ")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "#/home"
    }
  }, [_vm._v("Home")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "#/apps"
    }
  }, [_vm._v("Apps")])])
}]}

/***/ }),

/***/ 591:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "widthRef"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row table-search-header"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("\n      " + _vm._s(_vm.$parent.apps.length) + " apps found from\n      " + _vm._s(_vm.$parent.$parent.baseUrl) + "/helium/api/v2/app\n    ")])]), _vm._v(" "), _c('vue-good-table', {
    attrs: {
      "title": "",
      "columns": _vm.columns,
      "rows": _vm.apps,
      "sort-options": {
        enabled: true,
        initialSortBy: {
          field: 'name',
          type: 'asc'
        }
      },
      "search-options": {
        enabled: true
      },
      "paginationOptions": {
        enabled: true
      },
      "styleClass": "vgt-table striped bordered table-hover",
      "lineNumbers": true
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'name') ? _c('span', [_vm._v("\n          " + _vm._s(props.row.name) + "\n      ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'id') ? _c('span', [_vm._v("\n          " + _vm._s(props.row.id) + "\n      ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'fqdn') ? _c('span', [_vm._v("\n          " + _vm._s(props.row.fqdn) + "\n      ")]) : _vm._e(), _vm._v(" "), (props.column.label == 'Actions') ? _c('span', [_c('button', {
          staticClass: "btn btn-info",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.view(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-chart-pie",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" View\n          ")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-warning",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.config(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-wrench",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Config\n          ")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-success",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.logs(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-history",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Logs\n          ")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-error",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.scheduledfunctions(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-tasks",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Scheduled Functions\n          ")])]) : _vm._e()]
      }
    }])
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "#/home"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item active"
  }, [_vm._v("Apps")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card card-inverse card-info text-xs-center"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('blockquote', {
    staticClass: "card-blockquote"
  }, [_c('p', [_vm._v("Visualize db performance and scheduled functions results")])]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-chart-pie card-block-watermark",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card card-inverse card-warning text-xs-center"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('blockquote', {
    staticClass: "card-blockquote"
  }, [_c('p', [_vm._v("Set timeout values for scheduled functions and views")])]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-wrench card-block-watermark",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card card-inverse card-success text-xs-center"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('blockquote', {
    staticClass: "card-blockquote"
  }, [_c('p', [_vm._v("Stream Helium app logs directly to your browser")])]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-history card-block-watermark",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])])
}]}

/***/ }),

/***/ 592:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('blockquote', {
    staticClass: "blockquote"
  }, [_c('form', [_c('fieldset', [_c('legend', [_vm._v("Support Roster")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("Project")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedProject),
      expression: "selectedProject"
    }],
    staticClass: "custom-select form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedProject = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Please select one")]), _vm._v(" "), _vm._l((_vm.projects), function(entry) {
    return _c('option', [_vm._v("\n                        " + _vm._s(entry) + "\n                    ")])
  })], 2)])])])])])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('vue-good-table', {
    attrs: {
      "title": "Team members",
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": {
        enabled: true
      },
      "paginationOptions": {
        enabled: true
      },
      "styleClass": "vgt-table striped bordered table-hover",
      "lineNumbers": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n        Select a Project to view team members\n      ")])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "#/home"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item active"
  }, [_vm._v("Support Roster")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "alert alert-info pull-right",
    attrs: {
      "id": "schema-access-info",
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("On Call Support Roster")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("Each project has a team support the project. The roster is used for deciding the recipient of outbound monitoring notifications")])])])
}]}

/***/ }),

/***/ 593:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    attrs: {
      "show": _vm.modalShow,
      "backdrop": _vm.modalBackdrop,
      "effect": "zoom",
      "width": "400"
    },
    on: {
      "update:show": function($event) {
        _vm.modalShow = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('i', {
    staticClass: "fas fa-minus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Remove Entry Point\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_vm._v("\n      Are you sure you want to remove the entry point " + _vm._s(_vm.selectedKey) + " from the App Config?\n      "), _c('p', {
    staticClass: "text-danger"
  }, [_vm._v("This action cannot be undone.")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.modalCloseCallback
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.modalRemoveCallback
    }
  }, [_vm._v("Remove")])])]), _vm._v(" "), (_vm.showConfigData) ? _c('div', [_c('vue-good-table', {
    attrs: {
      "title": "Configured entry points",
      "columns": _vm.columns,
      "rows": _vm.config.entryPointList,
      "sort-options": {
        enabled: true,
        initialSortBy: {
          field: 'key',
          type: 'asc'
        }
      },
      "search-options": {
        enabled: true
      },
      "paginationOptions": {
        enabled: true
      },
      "rowStyleClass": _vm.tableRowClass,
      "styleClass": "vgt-table striped bordered table-hover",
      "lineNumbers": true
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'key') ? _c('span', [_vm._v(_vm._s(props.row.key))]) : _vm._e(), _vm._v(" "), (props.column.field == 'value') ? _c('span', [_vm._v(_vm._s(props.row.value))]) : _vm._e(), _vm._v(" "), (props.column.label == 'Actions') ? _c('span', [_c('button', {
          staticClass: "btn btn-sm btn-info",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.btnUpdateEntryPoint(props.row.key, props.row.value)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-edit",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Update\n          ")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-sm btn-danger",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.btnRemoveEntryPoint(props.row.key, props.row.value)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-minus-circle"
        }), _vm._v(" Remove\n          ")])]) : _vm._e()]
      }
    }], null, false, 3197696587)
  })], 1) : _c('div', {
    staticClass: "alert alert-success",
    attrs: {
      "id": "timeouts-info",
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("No Entry Points.")]), _c('br'), _vm._v("\n    There are no entry point timeouts set for this app\n  ")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 594:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loading', {
    attrs: {
      "active": _vm.loading
    },
    on: {
      "update:active": function($event) {
        _vm.loading = $event
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [(_vm.showFeedback) ? _c('feedback', {
    attrs: {
      "message": _vm.feedbackMessage,
      "spin": _vm.showSpinner,
      "success": _vm.success
    }
  }) : _vm._e(), _vm._v(" "), _c('form', [(!_vm.syncConfig) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('model-select', {
    attrs: {
      "options": _vm.dataSourceOptions,
      "placeholder": "Select Helium datasouce"
    },
    model: {
      value: (_vm.selectedDataSourceOption),
      callback: function($$v) {
        _vm.selectedDataSourceOption = $$v
      },
      expression: "selectedDataSourceOption"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('model-select', {
    attrs: {
      "options": _vm.dataSourceApps,
      "placeholder": "Select Helium app"
    },
    model: {
      value: (_vm.dataSourceApp),
      callback: function($$v) {
        _vm.dataSourceApp = $$v
      },
      expression: "dataSourceApp"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.syncConfig) ? _c('div', [_c('button', {
    staticClass: "btn btn-xs btn-info pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleExpand
    }
  }, [(!_vm.expand) ? _c('div', [_vm._v("Show Advanced")]) : _c('div', [_vm._v("Hide Advanced")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('fieldset', {
    staticClass: "form-group"
  }, [_c('legend', [_vm._v("HeliumJourney Sync Middleware:")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Middleware Sync Status")]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enabledRadio),
      expression: "enabledRadio"
    }],
    staticClass: "form-check-input",
    attrs: {
      "id": "enabledRadio1",
      "name": "enabledRadios",
      "type": "radio",
      "value": "Enabled"
    },
    domProps: {
      "checked": _vm._q(_vm.enabledRadio, "Enabled")
    },
    on: {
      "change": function($event) {
        _vm.enabledRadio = "Enabled"
      }
    }
  }), _vm._v("\n                    Enabled\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enabledRadio),
      expression: "enabledRadio"
    }],
    staticClass: "form-check-input",
    attrs: {
      "id": "enabledRadio2",
      "name": "enabledRadios",
      "type": "radio",
      "value": "Disabled"
    },
    domProps: {
      "checked": _vm._q(_vm.enabledRadio, "Disabled")
    },
    on: {
      "change": function($event) {
        _vm.enabledRadio = "Disabled"
      }
    }
  }), _vm._v("\n                      Disabled\n                  ")])])])]), _vm._v(" "), (_vm.expand) ? _c('div', {
    staticClass: "col"
  }, [_c('fieldset', {
    staticClass: "form-group"
  }, [_c('legend', [_vm._v("Journey To Helium:")]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enableHeliumToJourneyRadio),
      expression: "enableHeliumToJourneyRadio"
    }],
    staticClass: "form-check-input",
    attrs: {
      "id": "enabledRadio3",
      "name": "enableJourneyToHeliumRadios",
      "type": "radio",
      "value": "Enabled"
    },
    domProps: {
      "checked": _vm._q(_vm.enableHeliumToJourneyRadio, "Enabled")
    },
    on: {
      "change": function($event) {
        _vm.enableHeliumToJourneyRadio = "Enabled"
      }
    }
  }), _vm._v("\n                    Enabled\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enableHeliumToJourneyRadio),
      expression: "enableHeliumToJourneyRadio"
    }],
    staticClass: "form-check-input",
    attrs: {
      "id": "enabledRadio4",
      "name": "enableJourneyToHeliumRadios",
      "type": "radio",
      "value": "Disabled"
    },
    domProps: {
      "checked": _vm._q(_vm.enableHeliumToJourneyRadio, "Disabled")
    },
    on: {
      "change": function($event) {
        _vm.enableHeliumToJourneyRadio = "Disabled"
      }
    }
  }), _vm._v("\n                    Disabled\n                  ")])]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("When set as enabled data updated on Journey will be synced to Helium's backend database.")])])]) : _vm._e(), _vm._v(" "), (_vm.expand) ? _c('div', {
    staticClass: "col"
  }, [_c('fieldset', {
    staticClass: "form-group"
  }, [_c('legend', [_vm._v("Helium To Journey:")]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enableJourneyToHeliumRadio),
      expression: "enableJourneyToHeliumRadio"
    }],
    staticClass: "form-check-input",
    attrs: {
      "id": "enabledRadio5",
      "name": "enabledHeliumToJourneyRadios",
      "type": "radio",
      "value": "Enabled"
    },
    domProps: {
      "checked": _vm._q(_vm.enableJourneyToHeliumRadio, "Enabled")
    },
    on: {
      "change": function($event) {
        _vm.enableJourneyToHeliumRadio = "Enabled"
      }
    }
  }), _vm._v("\n                    Enabled\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enableJourneyToHeliumRadio),
      expression: "enableJourneyToHeliumRadio"
    }],
    staticClass: "form-check-input",
    attrs: {
      "id": "enabledRadio6",
      "name": "enabledHeliumToJourneyRadios",
      "type": "radio",
      "value": "Disabled"
    },
    domProps: {
      "checked": _vm._q(_vm.enableJourneyToHeliumRadio, "Disabled")
    },
    on: {
      "change": function($event) {
        _vm.enableJourneyToHeliumRadio = "Disabled"
      }
    }
  }), _vm._v("\n                      Disabled\n                  ")])]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("When set as enabled data updated on Helium will be synced to Journey's backend database.")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    ref: "heliumBookmarkIdHelpRef",
    staticClass: "col-6"
  }, [_c('fieldset', [_c('legend', [_vm._v("Helium:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Base URL")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.helium.baseUrl),
      expression: "syncConfig.helium.baseUrl"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.syncConfig.helium.baseUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.helium, "baseUrl", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Base URL for Helium.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Schema Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.helium.dbSchema),
      expression: "syncConfig.helium.dbSchema"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.syncConfig.helium.dbSchema)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.helium, "dbSchema", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Schema name of Helium app.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Changelog Starting Version")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.heliumToJourney.changeLogMinVersionAsString),
      expression: "syncConfig.heliumToJourney.changeLogMinVersionAsString"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonlyVersions,
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.heliumToJourney.changeLogMinVersionAsString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.heliumToJourney, "changeLogMinVersionAsString", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("This integration was setup at this version, sync changes after this Helium bookmark ID."), _c('button', {
    staticClass: "btn-sm help-btn-padding",
    class: {
      'btn-outline-info': _vm.showHeliumBookmarkIdHelp,
      'btn-info': !_vm.showHeliumBookmarkIdHelp
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.btnHeliumBookmarkIdHelp
    }
  }, [_vm._v("More info")])]), _vm._v(" "), (_vm.showHeliumBookmarkIdHelp) ? _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("\n                    Each database transaction persisted on Helium is assigned a unique and incrementing Bookmark ID. If a record is created, deleted or changes state after this Bookmark ID the data will be merged to Journey.\n\n                    See "), _c('a', {
    attrs: {
      "href": "https://wiki.mezzanineware.com/display/HTUT/Change+Tracking"
    }
  }, [_vm._v("Helium Change tracking Documentation")]), _vm._v(" for more info.\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.showHeliumBookmarkIdHelp) ? _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("\n                    A changelog version with value 0 indicates all changes from the beginning of time on the app should be processed.\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.showHeliumBookmarkIdHelp) ? _c('div', {
    staticClass: "card card-block card-outline-secondary"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "form-inline float-right"
  }, [_c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.buildNewHeliumVersionSql),
      expression: "buildNewHeliumVersionSql",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopyCallBack),
      expression: "onCopyCallBack",
      arg: "success"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Copy Command to Clipboard"
    }
  }, [_c('i', {
    staticClass: "fa fa-clipboard"
  })])])])]), _vm._v(" "), (_vm.showHeliumBookmarkIdHelp) ? _c('text-editor', {
    attrs: {
      "contentProp": _vm.buildNewHeliumVersionSql,
      "width": _vm.textEditorWidthHelium,
      "height": _vm.textEditorHeightHelium,
      "readonly": _vm.textEditorReadOnly,
      "scrollToLine": _vm.textEditorScrollToLine,
      "lang": _vm.textEditorLangHelium
    }
  }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), (_vm.readonlyVersions) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Changelog Current Version")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.heliumSyncStatus),
      expression: "heliumSyncStatus"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.heliumSyncStatus)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.heliumSyncStatus = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("\n                    Integration is currently at this bookmark version since " + _vm._s(new Date(new Number(_vm.heliumLastUpdatedMillis))) + "\n                  ")])]) : _vm._e(), _vm._v(" "), (_vm.expand) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Change Log Skip Tables")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.changeLogSkipTablesTmp),
      expression: "changeLogSkipTablesTmp"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.changeLogSkipTablesTmp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.changeLogSkipTablesTmp = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Skip specific tables from syncing to Journey (Optional)"), _c('button', {
    staticClass: "btn-sm help-btn-padding",
    class: {
      'btn-outline-info': _vm.showHeliumSkipHelp,
      'btn-info': !_vm.showHeliumSkipHelp
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.btnHeliumSkipHelp
    }
  }, [_vm._v("More info")])]), _vm._v(" "), (_vm.showHeliumSkipHelp) ? _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Values are comma seperated (without spaces). Helium persistent objects which are not marked as @NotTracked must be explicitly added here.")]) : _vm._e(), _vm._v(" "), (_vm.showHeliumSkipHelp) ? _c('small', {
    staticClass: "form-text text-muted"
  }) : _vm._e(), _vm._v(" "), (_vm.showHeliumSkipHelp) ? _c('div', {
    staticClass: "card card-block card-outline-secondary"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "form-inline float-right"
  }, [_c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.buildSkipHeliumViewsSql),
      expression: "buildSkipHeliumViewsSql",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopyCallBack),
      expression: "onCopyCallBack",
      arg: "success"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Copy Command to Clipboard"
    }
  }, [_c('i', {
    staticClass: "fa fa-clipboard"
  })])])]), _vm._v(" "), (_vm.showHeliumSkipHelp) ? _c('text-editor', {
    attrs: {
      "contentProp": _vm.buildSkipHeliumViewsSql,
      "width": _vm.textEditorWidthHelium,
      "height": _vm.textEditorHeightHelium,
      "readonly": _vm.textEditorReadOnly,
      "scrollToLine": _vm.textEditorScrollToLine,
      "lang": _vm.textEditorLangHelium
    }
  }) : _vm._e()], 1)]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('fieldset', [_c('legend', [_vm._v("Journey:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Base URL")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journey.baseUrl),
      expression: "syncConfig.journey.baseUrl"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journey.baseUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journey, "baseUrl", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Base URL for Journey. To find this, go to the API Management page for your app on Journey. The baseURL is the domain before /api/v4/{app-id}. \n                    eg. https://{app-deployment-id}.backend.{region-code}.journeyapps.com")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Journey API Username")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journey.restAPICredentials.userName),
      expression: "syncConfig.journey.restAPICredentials.userName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journey.restAPICredentials.userName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journey.restAPICredentials, "userName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Journey backend API basic auth username.")]), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Journey API Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journey.restAPICredentials.password),
      expression: "syncConfig.journey.restAPICredentials.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "autocomplete": "password"
    },
    domProps: {
      "value": (_vm.syncConfig.journey.restAPICredentials.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journey.restAPICredentials, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Journey backend API basic auth password.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Oplog Starting Version")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHelium.oplogMinVersionAsString),
      expression: "syncConfig.journeyToHelium.oplogMinVersionAsString"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonlyVersions,
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHelium.oplogMinVersionAsString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHelium, "oplogMinVersionAsString", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Sync changes after this Journey Version."), _c('button', {
    staticClass: "btn-sm help-btn-padding",
    class: {
      'btn-outline-info': _vm.showJourneyVersionHelp,
      'btn-info': !_vm.showJourneyVersionHelp
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.btnJourneyVersionHelp
    }
  }, [_vm._v("More info")])]), _vm._v(" "), (_vm.showJourneyVersionHelp) ? _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("\n                    Each individual database operation on Journey is assigned a unique and incrementing version number known as the Sequence ID on Journey. If a record is created, deleted or changes state after this Sequence ID the data will be merged to Helium. See "), _c('a', {
    attrs: {
      "href": "https://docs.journeyapps.com/v4/reference#oplog"
    }
  }, [_vm._v("Journey Oplog Documentation")]), _vm._v(" for more info.\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.showJourneyVersionHelp) ? _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("A value of 0 indicates all changes from the beginning of time on the app should be processed.")]) : _vm._e(), _vm._v(" "), (_vm.showJourneyVersionHelp) ? _c('div', {
    staticClass: "card card-block card-outline-secondary"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "form-inline float-right"
  }, [_c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.buildNewJourneyVersionSql),
      expression: "buildNewJourneyVersionSql",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopyResetJourneyVersion),
      expression: "onCopyResetJourneyVersion",
      arg: "success"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Copy Command to Clipboard"
    }
  }, [_c('i', {
    staticClass: "fa fa-clipboard"
  })])])])]), _vm._v(" "), (_vm.showJourneyVersionHelp) ? _c('text-editor', {
    attrs: {
      "contentProp": _vm.buildNewJourneyVersionSql,
      "width": _vm.textEditorWidthJourney,
      "height": _vm.textEditorHeightJourney,
      "readonly": _vm.textEditorReadOnly,
      "scrollToLine": _vm.textEditorScrollToLine,
      "lang": _vm.textEditorLangJourney
    }
  }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), (_vm.readonlyVersions) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Oplog Current Version")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.journeySyncStatus),
      expression: "journeySyncStatus"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.journeySyncStatus)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.journeySyncStatus = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("\n                    Integration is currently at this bookmark version since " + _vm._s(new Date(new Number(_vm.journeyLastUpdatedMillis))) + "\n                  ")])]) : _vm._e(), _vm._v(" "), (_vm.expand) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Oplog Skip Object Types")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oplogSkipObjectTypesTmp),
      expression: "oplogSkipObjectTypesTmp"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.oplogSkipObjectTypesTmp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oplogSkipObjectTypesTmp = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Skip specific tables from syncing to Helium (Optional)"), _c('button', {
    staticClass: "btn-sm help-btn-padding",
    class: {
      'btn-outline-info': _vm.showJourneySkipHelp,
      'btn-info': !_vm.showJourneySkipHelp
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.btnJourneySkipHelp
    }
  }, [_vm._v("More info")])]), _vm._v(" "), (_vm.showJourneySkipHelp) ? _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Values are comma seperated (without spaces). Journey objects which are not declared on Helium must be explicitly added here. Using "), _c('a', {
    attrs: {
      "href": "https://docs.journeyapps.com/docs/app-database#section-localdb"
    }
  }, [_vm._v("LocalDB")]), _vm._v(" is suggested over using this field.")]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), (_vm.expand) ? _c('fieldset', {
    staticClass: "form-group"
  }, [_c('legend', [_vm._v("Journey enrollments and metadata:")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enabledEnrollmentRadio),
      expression: "enabledEnrollmentRadio"
    }],
    staticClass: "form-check-input",
    attrs: {
      "id": "enrollmentRadio1",
      "name": "enrollmentRadios",
      "type": "radio",
      "value": "Enabled"
    },
    domProps: {
      "checked": _vm._q(_vm.enabledEnrollmentRadio, "Enabled")
    },
    on: {
      "change": function($event) {
        _vm.enabledEnrollmentRadio = "Enabled"
      }
    }
  }), _vm._v("\n                      Enabled\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enabledEnrollmentRadio),
      expression: "enabledEnrollmentRadio"
    }],
    staticClass: "form-check-input",
    attrs: {
      "id": "enrollmentRadio2",
      "name": "enrollmentRadios",
      "type": "radio",
      "value": "Disabled"
    },
    domProps: {
      "checked": _vm._q(_vm.enabledEnrollmentRadio, "Disabled")
    },
    on: {
      "change": function($event) {
        _vm.enabledEnrollmentRadio = "Disabled"
      }
    }
  }), _vm._v("\n                        Disabled\n                      ")])]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("When set as enabled mobile user re-enrollment tasks are processed and Journey user enrollment meta data is merged into the application data model.")])])]), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enrollmentModeRadio),
      expression: "enrollmentModeRadio"
    }],
    staticClass: "form-check-input",
    attrs: {
      "id": "enrollmentModeRadio1",
      "name": "enrollmentModeRadios",
      "type": "radio",
      "value": "Single device per user"
    },
    domProps: {
      "checked": _vm._q(_vm.enrollmentModeRadio, "Single device per user")
    },
    on: {
      "change": function($event) {
        _vm.enrollmentModeRadio = "Single device per user"
      }
    }
  }), _vm._v("\n                      Single device per user\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enrollmentModeRadio),
      expression: "enrollmentModeRadio"
    }],
    staticClass: "form-check-input",
    attrs: {
      "id": "enrollmentModeRadio2",
      "name": "enrollmentModeRadios",
      "type": "radio",
      "value": "Multiple devices per user"
    },
    domProps: {
      "checked": _vm._q(_vm.enrollmentModeRadio, "Multiple devices per user")
    },
    on: {
      "change": function($event) {
        _vm.enrollmentModeRadio = "Multiple devices per user"
      }
    }
  }), _vm._v("\n                        Multiple devices per user\n                      ")])])]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Journey handles user enrollments in two possible ways. If support for multiple devices per user is enabled for a Journey app then 'Multiple devices per user' should be selected otherwise 'Single device per user' should be used.")])]) : _vm._e(), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment) ? _c('div', {
    staticClass: "form-group"
  }, [(_vm.enrollmentMode === 'user') ? _c('div', [_c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Journey user enrollment metadata is extraced and persisted into the mobile user worker objects '" + _vm._s(_vm.syncConfig.journeyToHeliumEnrollment.heliumObjectName) + "' and '" + _vm._s(_vm.syncConfig.journeyToHeliumEnrollment.journeyObjectName) + "'. ")]), _vm._v(" "), _vm._m(8)]) : _c('div', [_c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Journey user enrollment metadata is extraced and persisted into the mobile user worker objects '" + _vm._s(_vm.syncConfig.journeyToHeliumEnrollment.heliumObjectName) + "' and '" + _vm._s(_vm.syncConfig.journeyToHeliumEnrollment.journeyObjectName) + "'. User session data is persisted into '" + _vm._s(_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectName) + "' and user session container data is persisted into '" + _vm._s(_vm.syncConfig.journeyToHeliumEnrollment.sessionContainerObjectName) + "'.")]), _vm._v(" "), _vm._m(9)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [(_vm.syncConfig.journeyToHeliumEnrollment) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Update Interval Mins")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.updateIntervalMins),
      expression: "syncConfig.journeyToHeliumEnrollment.updateIntervalMins"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "updateIntervalMins", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.updateIntervalValues), function(i) {
    return _c('option', [_vm._v("\n                    " + _vm._s(i) + "\n                    ")])
  }), 0), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Number of minutes to wait between runs of the Journey-to-Helium synchronization of enrollment data. The default value is 15 and the minimum value is 5.")])]) : _vm._e()])]), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment) ? _c('legend', [_vm._v("\n              User:\n            ")]) : _vm._e(), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment) ? _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("The User object represents  users who are enrolled on a Journey app. Each user has available metadata for enrollment and session management.")]) : _vm._e(), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Helium Object Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.heliumObjectName),
      expression: "syncConfig.journeyToHeliumEnrollment.heliumObjectName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.heliumObjectName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "heliumObjectName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the Helium persistent object that represents the Journey user.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Journey Object Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.journeyObjectName),
      expression: "syncConfig.journeyToHeliumEnrollment.journeyObjectName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.journeyObjectName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "journeyObjectName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the Journey object that represents the Journey user.")])])])]) : _vm._e(), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment) ? _c('legend', [_vm._v("\n              User field names:\n            ")]) : _vm._e(), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment) ? _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Names of fields in Helium persistent object for Journey user.")]) : _vm._e(), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment && _vm.enrollmentMode === 'user') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Allowed Access Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.allowedAccessFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.allowedAccessFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.allowedAccessFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "allowedAccessFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains the flag that indicates if the user is allowed to access the Journey app. The field type may be boolean or string. For string fields the possible values are Yes and No.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Enrolled Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.enrolledFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.enrolledFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.enrolledFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "enrolledFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains the flag that indicates if the user is currently enrolled. The field type may be boolean or string. For string fields the possible values are Yes and No.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Journey Launcher Version Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.journeyLauncherVersionFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.journeyLauncherVersionFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.journeyLauncherVersionFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "journeyLauncherVersionFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains the version for the Journey Launcher last used by the user. The field type must be string.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Device OS Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.deviceOsFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.deviceOsFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.deviceOsFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "deviceOsFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains the description of the device operating system last used by the user. The field type must be string.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Perform Re-Enrollment Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.performReEnrollmentFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.performReEnrollmentFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.performReEnrollmentFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "performReEnrollmentFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains the flag that indicates if re-enrollment must be triggered for the user. When specified, this field is read by the Helium-to-Journey sync process. Setting the flag to a value that equates to \"true\", will trigger a re-enrollment against the Journey user management API. Once the re-enrollment has been triggered, the flag will be set back to a value that equates to \"false\" and the reEnrollmentLastProcessedFieldName will be updated. Note that Helium-to-Journey synchronization must be enabled for this flag to be processed. The field type may be boolean or string. For string fields the possible values are yes, no, true, false, t and f.  For string fields the values are not case sensitive.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Generate Enrollment Code Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.generateEnrollmentCodeFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.generateEnrollmentCodeFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.generateEnrollmentCodeFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "generateEnrollmentCodeFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains a flag to trigger generating enrollment code. The field type may be boolean or string. For string fields the possible values are yes, no, true, false, t and f. For string fields the values are not case sensitive.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Device Model Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.deviceModelFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.deviceModelFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.deviceModelFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "deviceModelFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains the description of the device model last used by the user. The field type must be string.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Last Connected Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.lastConnectedFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.lastConnectedFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.lastConnectedFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "lastConnectedFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains the date and time when the user was last connected. The field type may be string, date or dateTime. For string fields the value will be an ISO 8601 date and time string in coordinated universal time (UTC).")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Barcode Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.barcodeFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.barcodeFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.barcodeFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "barcodeFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains the URL to the Journey enrollment barcode for the user. The field type must be string.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("URL Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.urlFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.urlFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.urlFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "urlFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains the URL to the Journey enrollment page for the user. The field type must be string.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Re Enrollment Last Processed")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.reEnrollmentLastProcessedFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.reEnrollmentLastProcessedFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.reEnrollmentLastProcessedFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "reEnrollmentLastProcessedFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains the date and time when the last re-enrollment request was processed for the user. The field type may be string, date or dateTime. For string fields the value will be an ISO 8601 date and time string in coordinated universal time (UTC).")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Enrollment Code Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.enrollmentCodeFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.enrollmentCodeFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.enrollmentCodeFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "enrollmentCodeFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains an enrollment code. An enrollment code is used when enrolling with the journey-enrollment-service. The field type must be string")])])])]) : _vm._e(), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment && _vm.enrollmentMode === 'session') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Generate Enrollment Code Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.generateEnrollmentCodeFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.generateEnrollmentCodeFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.generateEnrollmentCodeFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "generateEnrollmentCodeFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains a flag to trigger generating enrollment code. The field type may be boolean or string. For string fields the possible values are yes, no, true, false, t and f. For string fields the values are not case sensitive.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Enrollment Code Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.enrollmentCodeFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.enrollmentCodeFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.enrollmentCodeFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "enrollmentCodeFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains an enrollment code. An enrollment code is used when enrolling with the journey-enrollment-service. The field type must be string.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Locked Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.lockedFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.lockedFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.lockedFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "lockedFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains the flag that indicates if a user is locked out of the Journey application. When a user is locked they are signed out if busy in a session and cannot log into the Journey application. The field type may be boolean or string. For string fields the possible values are Yes and No.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Last Connected At Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.lastConnectedAtFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.lastConnectedAtFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.lastConnectedAtFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "lastConnectedAtFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains the date and time when the user was last connected. The field type may be string, date or dateTime. For string fields the value will be an ISO 8601 date and time string in coordinated universal time (UTC).")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Enrolled Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.enrolledFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.enrolledFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.enrolledFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "enrolledFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains the flag that indicates if the user is currently enrolled. The field type may be boolean or string. For string fields the possible values are Yes and No.")])])])]) : _vm._e(), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment && _vm.enrollmentMode === 'session') ? _c('legend', [_vm._v("\n              User Session:\n            ")]) : _vm._e(), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment && _vm.enrollmentMode === 'session') ? _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("The User session object represents the sessions of users who are enrolled on a Journey app.")]) : _vm._e(), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment && _vm.enrollmentMode === 'session') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Session Object Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectName),
      expression: "syncConfig.journeyToHeliumEnrollment.sessionObjectName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "sessionObjectName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the Helium persistent object that contains device session data for Journey users. This table will be truncated and populated each update interval.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  })]) : _vm._e(), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment && _vm.enrollmentMode === 'session') ? _c('legend', [_vm._v("\n              User session object field names:\n            ")]) : _vm._e(), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment && _vm.enrollmentMode === 'session') ? _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("\n            Names of fields in Helium persistent object for Journey user session data")]) : _vm._e(), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment && _vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames && _vm.enrollmentMode === 'session') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("State Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.stateFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.stateFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.stateFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames, "stateFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains string representation of a Sessions state. The field type must be string.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Last Authenticated At Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.lastAuthenticatedAtFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.lastAuthenticatedAtFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.lastAuthenticatedAtFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames, "lastAuthenticatedAtFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains the date and time when the user was last authenticated. The field type may be string, date or dateTime. For string fields the value will be an ISO 8601 date and time string in coordinated universal time (UTC).")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Created At Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.createdAtFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.createdAtFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.createdAtFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames, "createdAtFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains the date and time when the user was created. The field type may be string, date or dateTime. For string fields the value will be an ISO 8601 date and time string in coordinated universal time (UTC).")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Helium Object Fk Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.heliumObjectFkFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.heliumObjectFkFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.heliumObjectFkFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames, "heliumObjectFkFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name of the id field in the Helium persistent object that contains the FK to the mobile user object on Helium '" + _vm._s(_vm.syncConfig.journeyToHeliumEnrollment.heliumObjectName) + "'. The field type must be string.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Perform Re-Authenticate Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.performReAuthenticateFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.performReAuthenticateFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.performReAuthenticateFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames, "performReAuthenticateFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains a flag to trigger re authenticating a users session. The field type may be boolean or string. For string fields the possible values are yes, no, true, false, t and f. For string fields the values are not case sensitive.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Re-Authenticated Last Processed Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.reAuthenticateLastProcessedFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.reAuthenticateLastProcessedFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.reAuthenticateLastProcessedFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames, "reAuthenticateLastProcessedFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains the date and time when the last re-authenticate request was processed for the user. The field type may be string, date or dateTime. For string fields the value will be an ISO 8601 date and time string in coordinated universal time (UTC).")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Signed Out At Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.signedOutAtFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.signedOutAtFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.signedOutAtFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames, "signedOutAtFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains the date and time when the user was last signed out. The field type may be string, date or dateTime. For string fields the value will be an ISO 8601 date and time string in coordinated universal time (UTC).")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Last Connected At Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.lastConnectedAtFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.lastConnectedAtFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.lastConnectedAtFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames, "lastConnectedAtFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains the date and time when the user was last connected. The field type may be string, date or dateTime. For string fields the value will be an ISO 8601 date and time string in coordinated universal time (UTC).")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Label Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.labelFieldname),
      expression: "syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.labelFieldname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames.labelFieldname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment.sessionObjectFieldNames, "labelFieldname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the field in the Helium persistent object that contains Journey Session Label. The field type must be string.")])])])]) : _vm._e(), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment && _vm.enrollmentMode === 'session') ? _c('legend', [_vm._v("\n              User Session Container:\n            ")]) : _vm._e(), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment && _vm.enrollmentMode === 'session') ? _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("\n            The User session container object represents the container of the session of enrolled Journey app users")]) : _vm._e(), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment && _vm.enrollmentMode === 'session') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Session Container Object Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.sessionContainerObjectName),
      expression: "syncConfig.journeyToHeliumEnrollment.sessionContainerObjectName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.sessionContainerObjectName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment, "sessionContainerObjectName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment && _vm.enrollmentMode === 'session') ? _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Name for the Helium persistent object that contains device container data for Journey user sessions")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  })]) : _vm._e(), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment && _vm.enrollmentMode === 'session') ? _c('legend', [_vm._v("User Session Container field names:")]) : _vm._e(), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment && _vm.enrollmentMode === 'session') ? _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("\n            Names of fields in Helium persistent object for Journey user session container data")]) : _vm._e(), _vm._v(" "), (_vm.syncConfig.journeyToHeliumEnrollment && _vm.syncConfig.journeyToHeliumEnrollment.sessionContainerObjectFieldNames && _vm.enrollmentMode === 'session') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Version Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.sessionContainerObjectFieldNames.versionFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.sessionContainerObjectFieldNames.versionFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.sessionContainerObjectFieldNames.versionFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment.sessionContainerObjectFieldNames, "versionFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("\n                  Name for the field in the Helium persistent object that contains Journey container version for a device. An example value is '3.30.3'. The field type must be string.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Bundle ID Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.sessionContainerObjectFieldNames.bundleIdFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.sessionContainerObjectFieldNames.bundleIdFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.sessionContainerObjectFieldNames.bundleIdFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment.sessionContainerObjectFieldNames, "bundleIdFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("\n                  Name for the field in the Helium persistent object that contains Journey application bundle id. An example value is xyz.appinstall.myapp. The field type must be string.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Platform Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.sessionContainerObjectFieldNames.platformFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.sessionContainerObjectFieldNames.platformFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.sessionContainerObjectFieldNames.platformFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment.sessionContainerObjectFieldNames, "platformFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("\n                  Name for the field in the Helium persistent object that contains device platform name. An example value is IOS or Chrome. The field type must be string.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Session Object FK Field Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncConfig.journeyToHeliumEnrollment.sessionContainerObjectFieldNames.sessionObjectFkFieldName),
      expression: "syncConfig.journeyToHeliumEnrollment.sessionContainerObjectFieldNames.sessionObjectFkFieldName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.syncConfig.journeyToHeliumEnrollment.sessionContainerObjectFieldNames.sessionObjectFkFieldName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.syncConfig.journeyToHeliumEnrollment.sessionContainerObjectFieldNames, "sessionObjectFkFieldName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("\n                  Name for the field in the Helium persistent object that contains FK the to the session that this container belongs. The field type must be UUID")])])])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "btn-group pull-right",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveBtn
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.backBtn
    }
  }, [_vm._v("Back")])])])])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "#/home"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "#/sync"
    }
  }, [_vm._v("Sync")])]), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item active"
  }, [_vm._v("Merge")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-3 col-form-label"
  }, [_c('i', {
    staticClass: "fas fa-database"
  }), _vm._v(" Data Source")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-3 col-form-label"
  }, [_c('i', {
    staticClass: "fas fa-mobile-alt"
  }), _vm._v(" App")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info pull-right",
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Please note")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("Remember to disable the middleware before attempting a Helium Upgrade. When set as enabled data for this integration will be processed.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("\n                            Use the following SQL statements to extract the last bookmark and create a new bookmark if needed.\n                          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("\n                              Use the following SQL statement to list all SQL views and SQL materialized views.\n                              Please note: If there aren't any materialized views it will leave a trailing comma that should not be added to the \"Change Log Skip Tables\" input.\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Integration leverages Journey's Backend API. See "), _c('a', {
    attrs: {
      "href": "https://docs.journeyapps.com/v4/reference#backend-api"
    }
  }, [_vm._v("Journey API Documentation")]), _vm._v(" for more info.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("\n                            Use the following in terminal to generate a new Journey version that represents now.\n                          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Journey docs: "), _c('a', {
    attrs: {
      "href": "https://docs.journeyapps.com/v4/reference#managing-mobile-users"
    }
  }, [_vm._v("Mobile users")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Journey docs: "), _c('a', {
    attrs: {
      "href": "https://docs.journeyapps.com/v4/reference#managing-app-users-and-sessions"
    }
  }, [_vm._v("Mobile users and sessions")])])
}]}

/***/ }),

/***/ 595:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('simplert'), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.loading
    },
    on: {
      "update:active": function($event) {
        _vm.loading = $event
      }
    }
  }), _vm._v(" "), _c('nav', {
    staticClass: "nav navbar-skinny navbar navbar-toggleable-md navbar-inverse bg-info"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.toggleSlideoutPanelBtn
    }
  }, [_c('i', {
    staticClass: "icon-Mezzanine_Favicon mezzwings",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Portal")]), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navbarColor01"
    }
  }, [_c('ul', {
    staticClass: "navbar-nav mr-auto"
  }, [_c('li', {
    staticClass: "nav-item active"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "badge badge-pill badge-light"
  }, [_vm._v(_vm._s(_vm.signedInAs))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('button', {
    staticClass: "signout-button btn btn-primary btn-sm",
    on: {
      "click": _vm.toggleSlideoutPanelBtn
    }
  }, [_c('i', {
    staticClass: "fas fa-bars"
  })]), _vm._v(" "), _c('button', {
    staticClass: "signout-button btn btn-primary btn-sm",
    on: {
      "click": _vm.signOutBtn
    }
  }, [_c('i', {
    staticClass: "fas fa-sign-out-alt"
  })])])])]), _vm._v(" "), _c('vue-slideout-panel', {
    attrs: {
      "widths": ['25%'],
      "closeHtml": "<button class='btn-sm btn-primary'><i class='fas fa-bars'></i></button>"
    },
    on: {
      "close": function($event) {
        _vm.showSlideoutPanel = false
      }
    },
    model: {
      value: (_vm.showSlideoutPanel),
      callback: function($$v) {
        _vm.showSlideoutPanel = $$v
      },
      expression: "showSlideoutPanel"
    }
  }, [_c('h5', {
    staticClass: "text-muted"
  }, [_c('i', {
    staticClass: "icon-Mezzanine_Favicon mezzwings text-primary"
  }), _vm._v(" Portal Features \n    ")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group list-group-flush"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#/"
    },
    on: {
      "click": _vm.setSlideoutPanelHidden
    }
  }, [_c('i', {
    staticClass: "fas fa-home"
  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#/apps"
    },
    on: {
      "click": _vm.setSlideoutPanelHidden
    }
  }, [_c('i', {
    staticClass: "fas fa-mobile-alt"
  }), _vm._v(" Apps")])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#/sync"
    },
    on: {
      "click": _vm.setSlideoutPanelHidden
    }
  }, [_c('i', {
    staticClass: "fas fa-rocket"
  }), _vm._v(" Helium-Journey Sync")])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#/dbspy"
    },
    on: {
      "click": _vm.setSlideoutPanelHidden
    }
  }, [_c('i', {
    staticClass: "fas fa-user-secret"
  }), _vm._v(" DB Spy")])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#/schema-access"
    },
    on: {
      "click": _vm.setSlideoutPanelHidden
    }
  }, [_c('i', {
    staticClass: "fas fa-unlock-alt"
  }), _vm._v(" Schema Access")])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#/support-roster"
    },
    on: {
      "click": _vm.setSlideoutPanelHidden
    }
  }, [_c('i', {
    staticClass: "fas fa-phone"
  }), _vm._v(" Support Roster")])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#/helium-dev-latest"
    },
    on: {
      "click": _vm.setSlideoutPanelHidden
    }
  }, [_c('i', {
    staticClass: "fas fa-download"
  }), _vm._v(" Helium Dev Client")])]), _vm._v(" "), (_vm.isProduction) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#/deployments"
    },
    on: {
      "click": _vm.setSlideoutPanelHidden
    }
  }, [_c('i', {
    staticClass: "fas fa-cloud-upload-alt"
  }), _vm._v(" Deployments")])]) : _vm._e()]), _vm._v(" "), _c('h5', {
    staticClass: "text-muted"
  }, [_c('i', {
    staticClass: "fas fa-external-link-alt text-primary"
  }), _vm._v(" Links")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group list-group-flush"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "https://monitor.heliumapps.com"
    }
  }, [_c('i', {
    staticClass: "fas fa-tv"
  }), _vm._v(" Helium Monitor")])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "https://wiki.stb.mezzanineware.com/devops-docs/mezzanine-infrastructure/#infrastructure"
    }
  }, [_c('i', {
    staticClass: "fas fa-server"
  }), _vm._v(" Infrastructure docs")])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "https://wiki.stb.mezzanineware.com/display/HD/Helium+DevOps"
    }
  }, [_c('i', {
    staticClass: "fab fa-wikipedia-w"
  }), _vm._v(" Mezzanine Wiki")])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "https://wiki.stb.mezzanineware.com/display/HD/Helium+SPE+Support"
    }
  }, [_c('i', {
    staticClass: "fa fa-ban",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Mezzanine Jira")])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "https://mezzanineteams.slack.com"
    }
  }, [_c('i', {
    staticClass: "fab fa-slack"
  }), _vm._v(" Mezzanine Slack channel")])])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "content"
    }
  }, [(!_vm.apps) ? _c('sign-in', {
    staticClass: "signin"
  }) : _vm._e(), _vm._v(" "), (_vm.apps) ? _c('router-view', {
    ref: "homelink"
  }) : _vm._e()], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "show": _vm.modalSignoutVisibile,
      "backdrop": _vm.modalBackdrop,
      "effect": "zoom",
      "large": ""
    },
    on: {
      "update:show": function($event) {
        _vm.modalSignoutVisibile = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\n        Sign out\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("\n          Going so soon?\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('button', {
    staticClass: "btn btn-default btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.modalSignoutConfirmBtn
    }
  }, [_vm._v("Sign me out!")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.modalSignoutCloseBtn
    }
  }, [_vm._v("Nevermind.")])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggler navbar-toggler-right",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbarColor01",
      "aria-controls": "navbarColor01",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-icon"
  })])
}]}

/***/ }),

/***/ 596:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('blockquote', {
    staticClass: "blockquote"
  }, [_c('form', [_c('fieldset', [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "readOnlyInput"
    }
  }, [_vm._v("Download the latest version of the Helium Dev Client and the \"no ui\" version of the Helium Dev Client")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "basic-addon1"
    }
  }, [_vm._v("$")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "readOnlyInput",
      "type": "text",
      "placeholder": _vm.textBlock,
      "readonly": ""
    }
  })]), _vm._v(" "), _c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.textBlock),
      expression: "textBlock",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "id": "copyToClipBtn",
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Copy Install Script to Clipboard"
    }
  }, [_c('i', {
    staticClass: "fa fa-clipboard"
  }), _vm._v(" To clipboard\n          ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.heliumDevAppUri
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Get JAR\n            ")])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.noUIHeliumDevAppUri
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Get JAR\n          ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item"
  }, [_vm._v("HeliumDevLatestCLI")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dev-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "readOnlyInput"
    }
  }, [_vm._v("Latest version of the Helium Dev Client")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-ui-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "readOnlyInput"
    }
  }, [_vm._v("Latest version of the \"no ui\" Helium Dev Client")])])
}]}

/***/ }),

/***/ 597:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "jumbotron"
  }, [_c('div', {
    staticClass: "btn-group pull-right",
    attrs: {
      "role": "group",
      "aria-label": ""
    }
  }, [(!_vm.loading) ? _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clickCreateNew
    }
  }, [_c('i', {
    staticClass: "fas fa-plus-circle"
  }), _vm._v(" Create new\n      ")]) : _vm._e()]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), (!_vm.$route.params.name) ? _c('li', {
    staticClass: "breadcrumb-item active"
  }, [_vm._v("Dashboards")]) : _vm._e(), _vm._v(" "), (_vm.$route.params.name) ? _c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "#/sync-dashboard"
    }
  }, [_vm._v("Dashboards")])]) : _vm._e(), _vm._v(" "), (_vm.$route.params.name) ? _c('li', {
    staticClass: "breadcrumb-item active"
  }, [_vm._v(_vm._s(_vm.$route.params.name))]) : _vm._e()]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), (!_vm.$route.params.name) ? _c('vue-good-table', {
    attrs: {
      "title": "Sync Dashboards",
      "lineNumbers": true,
      "sort-options": {
        enabled: true,
        initialSortBy: {
          field: 'name',
          type: 'asc'
        }
      },
      "select-options": {
        enabled: false
      },
      "search-options": {
        enabled: true
      },
      "styleClass": "vgt-table striped bordered table-hover",
      "columns": _vm.columns,
      "rows": _vm.rows,
      "paginationOptions": {
        enabled: true
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'name') ? _c('span', [_vm._v("\n            " + _vm._s(props.row.name) + "\n        ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'actions') ? _c('span', [_c('div', {
          staticClass: "btn-group text-right",
          attrs: {
            "role": "group"
          }
        }, [_c('button', {
          staticClass: "btn btn-primary btn-sm",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.viewBtnClick(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-info-circle"
        }), _vm._v(" View\n            ")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-warning btn-sm",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.updateBtnClick(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-wrench",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Update\n            ")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-danger btn-sm",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.deleteBtnClick(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-minus-circle"
        }), _vm._v(" Delete\n            ")])])]) : _vm._e()]
      }
    }], null, false, 1341246514)
  }) : _vm._e(), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.loading
    },
    on: {
      "update:active": function($event) {
        _vm.loading = $event
      }
    }
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "show": _vm.modalShow,
      "backdrop": _vm.modalBackdrop,
      "effect": "zoom",
      "large": ""
    },
    on: {
      "update:show": function($event) {
        _vm.modalShow = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.modalTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Dashboard Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.modalDashboardNameInput),
      expression: "modalDashboardNameInput"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": _vm.modalIsEditMode
    },
    domProps: {
      "value": (_vm.modalDashboardNameInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.modalDashboardNameInput = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("The name of this dashboard.")])]), _vm._v(" "), _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns2,
      "rows": _vm.rows2,
      "lineNumbers": true,
      "sort-options": {
        enabled: true,
        initialSortBy: {
          field: 'appName',
          type: 'asc'
        }
      },
      "select-options": {
        enabled: true
      },
      "styleClass": "vgt-table striped bordered table-hover",
      "paginationOptions": {
        enabled: true,
        perPage: 5
      },
      "searchOptions": {
        enabled: false
      }
    },
    on: {
      "on-select-all": _vm.onSelectAll,
      "on-row-click": _vm.onRowClick
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'appName') ? _c('span', [_vm._v("\n              " + _vm._s(props.row.appName) + "\n            ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'id') ? _c('span', [_vm._v("\n              " + _vm._s(props.row.id) + "\n            ")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeModalBtnClick
    }
  }, [_vm._v("Close")]), _vm._v(" "), (!_vm.$route.params.name) ? _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.repickAppsModalBtnClick
    }
  }, [_vm._v("Repick Apps")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveModalBtnClick
    }
  }, [_vm._v("Save")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "show": _vm.modalDeleteShow,
      "backdrop": _vm.modalBackdrop,
      "effect": "zoom",
      "large": ""
    },
    on: {
      "update:show": function($event) {
        _vm.modalDeleteShow = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.modalTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._v("\n        Are you sure you want to delete this dashboard ?\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-4 col-form-label text-danger"
  }, [_vm._v("Enter DELETE in capital letters")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.modalDeleteConfirmInput),
      expression: "modalDeleteConfirmInput"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.modalDeleteConfirmInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.modalDeleteConfirmInput = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeModalBtnClick
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.deleteDisabled
    },
    on: {
      "click": _vm.confirmDeleteModalBtnClick
    }
  }, [_vm._v("Delete")])])]), _vm._v(" "), (_vm.$route.params.name) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns3,
      "rows": _vm.rows2,
      "lineNumbers": true,
      "sort-options": {
        enabled: true,
        initialSortBy: {
          field: 'appName',
          type: 'asc'
        }
      },
      "select-options": {
        enabled: false
      },
      "styleClass": "vgt-table striped bordered table-hover",
      "paginationOptions": {
        enabled: false
      },
      "searchOptions": {
        enabled: false
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'status') ? _c('span', [(props.row.status === 'Enabled') ? _c('div', [_c('span', {
          staticClass: "badge badge-success"
        }, [_c('i', {
          staticClass: "fa fa-play",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("\n              " + _vm._s(props.row.status) + "\n            ")])]) : _vm._e(), _vm._v(" "), (props.row.status === 'Disabled') ? _c('div', [_c('span', {
          staticClass: "badge badge-warning"
        }, [_c('i', {
          staticClass: "fa fa-stop",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("\n              " + _vm._s(props.row.status) + "\n            ")])]) : _vm._e(), _vm._v(" "), (props.row.status === 'Halted') ? _c('div', [_c('span', {
          staticClass: "badge badge-danger"
        }, [_c('i', {
          staticClass: "fa fa-exclamation-triangle",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("\n              " + _vm._s(props.row.status) + "\n            ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (props.column.field == 'appName') ? _c('span', [_vm._v("\n            " + _vm._s(props.row.appName) + "\n        ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'id') ? _c('span', [_vm._v("\n          " + _vm._s(props.row.id) + "\n        ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'heliumBaseUrl') ? _c('span', [_vm._v("\n        " + _vm._s(props.row.heliumBaseUrl) + "\n        ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'journeyBaseUrl') ? _c('span', [_vm._v("\n          " + _vm._s(props.row.journeyBaseUrl) + "\n        ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'heliumLastUpdated') ? _c('span', [_vm._v("\n          " + _vm._s(_vm.formatMillis(props.row.heliumLastUpdated)) + "\n        ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'journeyLastUpdated') ? _c('span', [_vm._v("\n          " + _vm._s(_vm.formatMillis(props.row.journeyLastUpdated)) + "\n        ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'lastPinged') ? _c('span', [_vm._v("\n          " + _vm._s(_vm.formatMillis(props.row.lastPinged)) + "\n        ")]) : _vm._e()]
      }
    }], null, false, 3823709548)
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "#/home"
    }
  }, [_vm._v("Home")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "#/sync"
    }
  }, [_vm._v("Sync")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card card-inverse card-info text-xs-center"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('blockquote', {
    staticClass: "card-blockquote"
  }, [_c('p', [_vm._v("View dashboard")])]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-info-circle card-block-watermark",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card card-inverse card-warning text-xs-center"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('blockquote', {
    staticClass: "card-blockquote"
  }, [_c('p', [_vm._v("Update dashboard")])]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-wrench card-block-watermark",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card card-inverse card-danger text-xs-center"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('blockquote', {
    staticClass: "card-blockquote"
  }, [_c('p', [_vm._v("Remove dashboard")])]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-minus-circle card-block-watermark",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])
}]}

/***/ }),

/***/ 598:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "jumbotron"
  }, [_c('div', {
    staticClass: "btn-group pull-right",
    attrs: {
      "role": "group",
      "aria-label": ""
    }
  }, [(!_vm.loading && _vm.success) ? _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clickCreateNew
    }
  }, [_c('i', {
    staticClass: "fas fa-plus-circle"
  }), _vm._v(" Create\n      ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clickGuide
    }
  }, [_c('i', {
    staticClass: "fas fa-question"
  }), _vm._v(" Guide\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clickDashboards
    }
  }, [_c('i', {
    staticClass: "fas fa-tachometer-alt"
  }), _vm._v(" Dashboards\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clickRefresh
    }
  }, [_c('i', {
    staticClass: "fas fa-sync"
  }), _vm._v(" Refresh\n      ")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [(_vm.showFeedback) ? _c('feedback', {
    attrs: {
      "message": _vm.feedbackMessage,
      "spin": _vm.showSpinner,
      "success": _vm.success
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.success && _vm.rows.length > 0) ? _c('div', [_c('vue-good-table', {
    attrs: {
      "title": "Helium Journey Apps",
      "columns": _vm.columns,
      "rows": _vm.rows,
      "sort-options": {
        enabled: true,
        initialSortBy: {
          field: 'appName',
          type: 'asc'
        }
      },
      "search-options": {
        enabled: true
      },
      "paginationOptions": {
        enabled: true
      },
      "styleClass": "vgt-table striped bordered table-hover",
      "lineNumbers": true
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'status') ? _c('span', [(props.row.status === 'Enabled') ? _c('div', [_c('span', {
          staticClass: "badge badge-success"
        }, [_c('i', {
          staticClass: "fa fa-play",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("\n                      " + _vm._s(props.row.status) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (props.row.status === 'Disabled') ? _c('div', [_c('span', {
          staticClass: "badge badge-warning"
        }, [_c('i', {
          staticClass: "fa fa-stop",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("\n                      " + _vm._s(props.row.status) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (props.row.status === 'Halted') ? _c('div', [_c('span', {
          staticClass: "badge badge-danger"
        }, [_c('i', {
          staticClass: "fa fa-exclamation-triangle",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("\n                      " + _vm._s(props.row.status) + "\n                    ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (props.column.field == 'appName') ? _c('span', [_vm._v("\n                    " + _vm._s(props.row.appName) + "\n                ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'id') ? _c('span', [_vm._v("\n                  " + _vm._s(props.row.id) + "\n                ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'heliumBaseUrl') ? _c('span', [_vm._v("\n                " + _vm._s(props.row.heliumBaseUrl) + "\n                ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'journeyBaseUrl') ? _c('span', [_vm._v("\n                  " + _vm._s(props.row.journeyBaseUrl) + "\n                ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'actions') ? _c('span', {
          staticClass: "text-right"
        }, [_c('div', {
          staticClass: "btn-group",
          attrs: {
            "role": "group"
          }
        }, [_c('button', {
          staticClass: "btn btn-primary btn-sm",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.selectInfo(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-info-circle"
        }), _vm._v(" Info\n                    ")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-group btn-sm",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.selectObjectSync(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-arrow-right-arrow-left"
        }), _vm._v(" Objects\n                    ")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-success btn-sm",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.selectLogs(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-history"
        }), _vm._v(" Logs\n                    ")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-warning btn-sm",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.selectEdit(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-edit"
        }), _vm._v(" Edit\n                    ")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-danger btn-sm",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.clickDelete(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-minus-circle"
        }), _vm._v(" Delete\n                    ")])])]) : _vm._e()]
      }
    }], null, false, 3761807820)
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('modal', {
    attrs: {
      "v-if": _vm.modalInfoShow,
      "show": _vm.modalInfoShow,
      "backdrop": _vm.modalBackdrop,
      "effect": "zoom",
      "large": ""
    },
    on: {
      "update:show": function($event) {
        _vm.modalInfoShow = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [(_vm.selection) ? _c('h4', {
    staticClass: "modal-title"
  }, [_c('i', {
    staticClass: "fa fa-rocket",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n         " + _vm._s(_vm.selection.appName) + "\n         "), _c('span', {
    staticClass: "badge badge-default badge-pill"
  }, [_vm._v(_vm._s(_vm.selection.id))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [(_vm.selection) ? _c('ul', {
    staticClass: "list-group"
  }, [_c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_vm._v("\n          App ID\n          "), _c('span', {
    staticClass: "badge badge-default badge-pill"
  }, [_vm._v(_vm._s(_vm.selection.id))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_vm._v("\n          Helium API URL\n          "), _c('span', {
    staticClass: "badge badge-default badge-pill"
  }, [_vm._v(_vm._s(_vm.selection.heliumBaseUrl))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_vm._v("\n          Journey Environment\n          "), _c('span', {
    staticClass: "badge badge-default badge-pill"
  }, [_vm._v(_vm._s(_vm.selection.journeyEnvironment))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_vm._v("\n          Journey User\n          "), _c('span', {
    staticClass: "badge badge-default badge-pill"
  }, [_vm._v(_vm._s(_vm.selection.journeyUserName))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_vm._v("\n          Journey Password\n          "), _c('span', {
    staticClass: "badge badge-default badge-pill"
  }, [_vm._v(_vm._s(_vm.selection.journeyPassword))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_vm._v("\n          Journey Last Sync\n          "), _c('span', {
    staticClass: "badge badge-default badge-pill"
  }, [_vm._v(_vm._s(_vm.formatEpoch(_vm.selection.journeyLastUpdated)))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_vm._v("\n          Helium Last Sync\n          "), _c('span', {
    staticClass: "badge badge-default badge-pill"
  }, [_vm._v(_vm._s(_vm.formatEpoch(_vm.selection.heliumLastUpdated)))])]), _vm._v(" "), (_vm.selection.lastPinged && _vm.selection.lastPinged != 'null') ? _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_vm._v("\n          Last Pinged\n          "), _c('span', {
    staticClass: "badge badge-default badge-pill"
  }, [_vm._v(_vm._s(_vm.formatEpoch(_vm.selection.lastPinged)))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_vm._v("\n          Last Helium Version Processed (change-log)\n          "), _c('span', {
    staticClass: "badge badge-default badge-pill"
  }, [_vm._v(_vm._s(_vm.selection.heliumSyncStatus))]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-2 mr-sm-2 mb-sm-0"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.heliumCurl),
      expression: "heliumCurl",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Copy Command to Clipboard"
    }
  }, [_c('i', {
    staticClass: "fa fa-clipboard"
  })])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.heliumCurl),
      expression: "heliumCurl"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "heliumCurl",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.heliumCurl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.heliumCurl = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item justify-content-between"
  }, [_vm._v("\n          Last Journey Version Processed (op-log)\n          "), _c('span', {
    staticClass: "badge badge-default badge-pill"
  }, [_vm._v(_vm._s(_vm.selection.journeySyncStatus))]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-2 mr-sm-2 mb-sm-0"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.journeyCurl),
      expression: "journeyCurl",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Copy Command to Clipboard"
    }
  }, [_c('i', {
    staticClass: "fa fa-clipboard"
  })])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.journeyCurl),
      expression: "journeyCurl"
    }],
    staticClass: "form-control sm",
    attrs: {
      "type": "text",
      "id": "journeyCurl",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.journeyCurl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.journeyCurl = $event.target.value
      }
    }
  })])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.modalInfoClose
    }
  }, [_vm._v("Close")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "v-if": _vm.modalObjectSyncShow,
      "show": _vm.modalObjectSyncShow,
      "backdrop": _vm.modalBackdrop,
      "effect": "zoom",
      "large": ""
    },
    on: {
      "update:show": function($event) {
        _vm.modalObjectSyncShow = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [(_vm.selection) ? _c('h4', {
    staticClass: "modal-title"
  }, [_c('i', {
    staticClass: "fa fa-arrow-right-arrow-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n         " + _vm._s(_vm.selection.appName) + "\n         "), _c('span', {
    staticClass: "badge badge-default badge-pill"
  }, [_vm._v(_vm._s(_vm.selection.id))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [(_vm.showSyncFeedback) ? _c('feedback', {
    attrs: {
      "message": _vm.feedbackSyncMessage,
      "spin": _vm.showSyncSpinner,
      "success": _vm.syncSuccess
    }
  }) : _vm._e(), _vm._v(" "), _c('vue-good-table', {
    attrs: {
      "title": "Sync Objects",
      "columns": _vm.sync_columns,
      "rows": _vm.sync_rows,
      "sort-options": {
        enabled: true,
        initialSortBy: {
          field: 'objectName',
          type: 'asc'
        }
      },
      "search-options": {
        enabled: true
      },
      "paginationOptions": {
        enabled: true
      },
      "styleClass": "vgt-table striped bordered table-hover",
      "lineNumbers": true
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'platform') ? _c('span', [_vm._v("\n                  " + _vm._s(props.row.platform) + "\n              ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'type') ? _c('span', [_vm._v("\n                  " + _vm._s(props.row.type) + "\n              ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'objectName') ? _c('span', [_vm._v("\n                  " + _vm._s(props.row.objectName) + "\n              ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'objectCount') ? _c('span', [_vm._v("\n                " + _vm._s(props.row.objectCount) + "\n              ")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.modalObjectSyncClose
    }
  }, [_vm._v("Close")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "show": _vm.modalLogShow,
      "backdrop": _vm.modalBackdrop,
      "effect": "zoom",
      "title": "Sync Logs",
      "large": ""
    },
    on: {
      "update:show": function($event) {
        _vm.modalLogShow = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [(_vm.selection) ? _c('h4', {
    staticClass: "modal-title"
  }, [_c('i', {
    staticClass: "fa fa-rocket",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.selection.appName) + " "), _c('span', {
    staticClass: "badge badge-default badge-pill"
  }, [_vm._v(_vm._s(_vm.selection.id))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [(_vm.showLogsFeedback) ? _c('feedback', {
    attrs: {
      "message": _vm.feedbackLogsMessage,
      "spin": _vm.showLogsSpinner,
      "success": _vm.logsSuccess
    }
  }) : _vm._e(), _vm._v(" "), _c('text-editor', {
    attrs: {
      "contentProp": _vm.textBlock,
      "width": _vm.textBlockWidth,
      "height": _vm.textBlockHeight,
      "readonly": _vm.textBlockReadOnly,
      "scrollToLine": _vm.scrollToLine,
      "lang": _vm.textBlockLang
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('fieldset', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scrollToLine),
      expression: "scrollToLine"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "autoScrollToBottom"
    },
    domProps: {
      "checked": Array.isArray(_vm.scrollToLine) ? _vm._i(_vm.scrollToLine, null) > -1 : (_vm.scrollToLine)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.scrollToLine,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.scrollToLine = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.scrollToLine = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.scrollToLine = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "autoScrollToBottom"
    }
  }, [_vm._v("Scroll to bottom")])])])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.modalLogClose
    }
  }, [_vm._v("Close")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "show": _vm.modalDeleteShow,
      "backdrop": _vm.modalBackdrop,
      "effect": "zoom",
      "large": ""
    },
    on: {
      "update:show": function($event) {
        _vm.modalDeleteShow = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('i', {
    staticClass: "fa fa-rocket",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Delete Helium Journey Integration\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('form', [_c('fieldset', [_c('legend', [_vm._v("Confirm Delete:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("App ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.heliumAppUuidForDelete),
      expression: "heliumAppUuidForDelete"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.heliumAppUuidForDelete)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.heliumAppUuidForDelete = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("App Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.heliumAppNameForDelete),
      expression: "heliumAppNameForDelete"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.heliumAppNameForDelete)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.heliumAppNameForDelete = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-4 col-form-label text-danger"
  }, [_vm._v("Enter DELETE in capital letters")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.heliumDeleteConfirm),
      expression: "heliumDeleteConfirm"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.heliumDeleteConfirm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.heliumDeleteConfirm = $event.target.value
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.deleteDisabled
    },
    on: {
      "click": _vm.modalDeleteAction
    }
  }, [_vm._v("Delete")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.modalDeleteClose
    }
  }, [_vm._v("Close")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "#/home"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item active"
  }, [_vm._v("Sync")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "card card-inverse card-info text-xs-center"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('blockquote', {
    staticClass: "card-blockquote"
  }, [_c('p', [_vm._v("View integration details")])]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-info-circle card-block-watermark",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "card card-inverse card-success text-xs-center"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('blockquote', {
    staticClass: "card-blockquote"
  }, [_c('p', [_vm._v("Stream integration logs to your browser")])]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-history card-block-watermark",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "card card-inverse card-warning text-xs-center"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('blockquote', {
    staticClass: "card-blockquote"
  }, [_c('p', [_vm._v("Edit the configuration for an integration")])]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-edit card-block-watermark",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "card card-inverse card-danger text-xs-center"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('blockquote', {
    staticClass: "card-blockquote"
  }, [_c('p', [_vm._v("Disable and remove an integration")])]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-minus-circle card-block-watermark",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])
}]}

/***/ }),

/***/ 599:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-container-outer"
  }, [_c('div', {
    staticClass: "login-container col-lg-5 col-8"
  }, [_c('span', {
    staticClass: "login-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "login-header"
  }, [_c('h1', [_vm._v("Portal | Sign In")]), _vm._v(" "), (!_vm.loginError) ? _c('div', {
    staticClass: "login-help text-muted"
  }, [_vm._v("\n          Use your Helium API credentials\n      ")]) : _vm._e(), _vm._v(" "), (_vm.loginError) ? _c('div', {
    staticClass: "login-error"
  }, [_vm._v("\n          " + _vm._s(_vm.loginError) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-5 col-form-label"
  }, [_vm._v("Environment")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('model-select', {
    attrs: {
      "options": _vm.environmentOptions,
      "placeholder": "Please select an environment"
    },
    model: {
      value: (_vm.selectedEnvironmentOption),
      callback: function($$v) {
        _vm.selectedEnvironmentOption = $$v
      },
      expression: "selectedEnvironmentOption"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-5 col-form-label"
  }, [_vm._v("Username")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "username",
      "placeholder": "Username",
      "required": "required",
      "autocomplete": "username",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-5 col-form-label"
  }, [_vm._v("Password")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password",
      "id": "password",
      "required": "required",
      "autocomplete": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-md btn-info btn-block login login-submit",
    attrs: {
      "type": "button",
      "disabled": !_vm.$parent.loading && !_vm.$parent.environment
    },
    on: {
      "click": _vm.signInBtn
    }
  }, [(!_vm.$parent.loading) ? _c('span', [_c('i', {
    staticClass: "fas fa-sign-in-alt"
  }), _vm._v(" Sign In")]) : _vm._e(), _vm._v(" "), (_vm.$parent.loading) ? _c('span', [_vm._v(" Logging in ...")]) : _vm._e()])])])])
},staticRenderFns: []}

/***/ }),

/***/ 600:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "resultsRef"
  }, [_c('div', {
    staticClass: "jumbotron"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item active"
  }, [_vm._v("Log for " + _vm._s(_vm.app.name) + " (" + _vm._s(_vm.app.id) + ")")])])]), _vm._v(" "), (_vm.showEditor) ? _c('text-editor', {
    attrs: {
      "contentProp": _vm.textBlock,
      "width": _vm.textBlockWidth,
      "height": _vm.textBlockHeight,
      "readonly": _vm.textBlockReadOnly,
      "scrollToLine": _vm.scrollToLine,
      "lang": _vm.textBlockLang
    }
  }) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Number of log records: " + _vm._s(_vm.numLogs))]), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn",
    class: {
      'btn-primary': !_vm.disableStart
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disableStart
    },
    on: {
      "click": _vm.openWs
    }
  }, [_c('i', {
    staticClass: "fa fa-play",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    class: {
      'btn-primary': !_vm.disableStop
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disableStop
    },
    on: {
      "click": _vm.closeWs
    }
  }, [_c('i', {
    staticClass: "fa fa-stop",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearLogs
    }
  }, [_c('i', {
    staticClass: "fa fa-bomb",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('feedback', {
    attrs: {
      "id": "feedback",
      "message": _vm.message,
      "spin": _vm.showSpinner,
      "success": _vm.success
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "#/home"
    }
  }, [_vm._v("Home")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "#/apps"
    }
  }, [_vm._v("Apps")])])
}]}

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[228]);


// WEBPACK FOOTER //
// static/js/app.53d95732d55aa60858a8.js